import React from 'react';
import Select, {
    components,
} from 'react-select';
import TestConnection from './testConnection';
import {helpContent,get_document_link, getSupportedDatasourceOptions} from "../../utils/common_utils";
import {TEST_CONNECTION_MESSAGES} from "../../utils/constant";
import {getIntegrationDetail, getQualdoIps} from "../../utils/event_handling"
import Load from '../../components/loadAction';
import Form from 'react-bootstrap/Form';
import { HardDrive, DatabaseZap, LockKeyhole, Check, Database, Eye, EyeOff, Layers2, FolderOpen, FolderTree, Plus,  Trash2, Layers, Layers3, TextSearch,  SquarePen, CircleCheck, Pencil, ChevronDown, ChevronRight} from "lucide-react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDatabase } from '@fortawesome/free-solid-svg-icons';
import RcTooltip from 'rc-tooltip';
import Modal from "react-bootstrap/Modal";
import $ from 'jquery';
import {POWER_BI_CONNECTOR, QUALDO_DOCUMENTATION,
    AZURE_SYNAPSE_DS_CONNECTOR, VERSION_FORMATS, FILE_TYPE_FORMATS} from "../../utils/constant";
import DynamicDatasourceForm from './DynamicDatasourceForm';
import datasourceConfig from './datasourceConfig.json';
import { testDataSource, createDataSource, updateDataSource, updateIntegrationById, editDataSource } from '../../utils/configureEventHandling';
import {getDatasourceIcon, getDatasourceStatus} from '../../utils/configure_utils';
import { DeleteWarningModal } from '../../components/DeleteWarningModal';

const groupStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
};
const groupBadgeStyles = {
  backgroundColor: '#EBECF0',
  borderRadius: '2em',
  color: '#172B4D',
  display: 'inline-block',
  fontSize: 12,
  fontWeight: 'normal',
  lineHeight: '1',
  minWidth: 1,
  padding: '0.16666666666667em 0.5em',
  textAlign: 'center',
};

const customSelectDatasource = ({ children, icon, ...props }) => (
    <components.Control {...props} className="has-icon">
        {/* {icon} */}
        {children}
    </components.Control>
);
const customSelectSchema = ({ children, ...props }) => (
    <components.Control {...props} className="has-icon">
        <FolderTree size={18} color="#A4A7AE" />
        {children}
    </components.Control>
);
const customSelectDataset = ({ children, ...props }) => (
    <components.Control {...props} className="has-icon">
        <Layers3 size={18} color="#A4A7AE" />
        {children}
    </components.Control>
);

const formatGroupLabel = data => (
  <div style={groupStyles}>
    <span>{data.label}</span>
    <span style={groupBadgeStyles}>{data.options.length}</span>
  </div>
);

export const isEditSchemaModeTransitionAllowed = (originalDetails, schemaModeSelection, configurationMode) => {
        if (!originalDetails) return true;

        const configData = originalDetails.datasource_config || originalDetails.integration_config || originalDetails;
        const originalSchemaMode = configData.schemaToBeProcessed || configData.auto_config_type;
        const originalSchemaSelection = ['specifiedSchema', 'specifiedBucket', 'specifiedDataset', 'specificSchemas', 'specificBuckets'].includes(originalSchemaMode)
                ? 'specificSchemas'
                : 'allSchemas';
        const originalConfigurationMode = originalDetails.mode === 'manualConfig' ? 'manual' : 'autoconfig';

        // Manual configuration requires an explicit schema selection.
        if (schemaModeSelection === 'allSchemas' && configurationMode === 'manual') {
            return false;
        }

        const isSchemaSelectionAllowed = schemaModeSelection === 'specificSchemas'
            ? originalSchemaSelection === 'specificSchemas' || originalSchemaSelection === 'allSchemas'
            : originalSchemaSelection === 'allSchemas';

        return isSchemaSelectionAllowed &&
            !(schemaModeSelection === 'allSchemas' && configurationMode === 'manual') &&
            !(originalConfigurationMode === 'manual' && configurationMode === 'autoconfig');
};


class Datasource extends React.Component {
    constructor(props) {
        super(props);
        this.setForm = this.setForm.bind(this);
        this.closeTestConnection = this.closeTestConnection.bind(this);
        this.setIntegrationData = this.setIntegrationData.bind(this);
        this.setSubmitButton = this.setSubmitButton.bind(this);
        this.setData = this.setData.bind(this);
        this.fill_details= this.fill_details.bind(this);
        this.changeHelpContent = this.changeHelpContent.bind(this);
        this.getIntegrationDetail = getIntegrationDetail.bind(this);
       // this.renderForm = this.renderForm.bind(this);
        this.getQualdoIps = getQualdoIps.bind(this);
        this.editDatasourceDetails = this.editDatasourceDetails.bind(this);
        this.editSchemaAndModeSelection = this.editSchemaAndModeSelection.bind(this);
        this.handleContinueSchemaSelection = this.handleContinueSchemaSelection.bind(this);
        this.handleCreateDatasource = this.handleCreateDatasource.bind(this);
        const supportedDatasourceOptions = getSupportedDatasourceOptions();
       
        let formType = "";
        if (supportedDatasourceOptions.length > 0) {

            const snowflakeCode = supportedDatasourceOptions.flatMap(g => g.options).find(o => o.label === "Snowflake2222")?.value;
            if(snowflakeCode===undefined){
                    formType = supportedDatasourceOptions[0].options[0].value;
            }else {
                 formType = snowflakeCode;
            }
           // formType = supportedDatasourceOptions[4].options[0].value;
           // formType = supportedDatasourceOptions[3].options[0].value;

        }

        this.state = {
            datasource_id: '',
            submit_button:false,
            testConnection:null,
            data_source_options: supportedDatasourceOptions,
            formType:  "snowflake",
           //  formType_option:{"label":"Azure Blob", "value":'azure_blob'},
             formType_option:{"label":'Snowflake', "value":'snowflake'},
            helpContentKey: formType,
            integration_data:{
                integration_type:formType,
                data_store_type: "filesystem"
            },

            ex_edit_integration_details: null,
            ip_address: null,

            selected: true, // All Schemas selected by default
            specificSelect: false,
            expandIncrementalData: null,
            partitionData: null,
            showSchemeModal: false,
            schemeModalLoading: false, // Track if modal is in loading state
            configurationMode: 'autoconfig', // Autoconfig selected by default
            schemaModeSelection: 'allSchemas', // Track selected schema mode
            showSchemaConfigInfo: null, // Show schema configuration info after clicking Next
            showTestConnectionInfo: false, // Control visibility of test connection info panel
            schemaSearchText: '', // Search text for filtering schemas in modal
            
            // For DynamicDatasourceForm
            isTestingConnection: false,
            testConnectionSuccess: null,
            testConnectionResponse: null, // Store API response (schemas, stages, etc.)
            testConnectionFormData: null, // Store form data used for test connection
            selectedSchemas: [], // Store selected schemas (live, inside modal)
            confirmedSchemas: [], // Store confirmed schemas (updated only on "Confirm Selection")
            formResetKey: 0, // Key to force form reset
            isCreatingDatasource: false, // Track datasource creation status
            testConnectionError: null, // Store error message when connection fails
            
            // Manual configuration mode state
            integrationConfigurations: [], // Array of integration configurations
            datasetToBeProcessed: 'allDatasets', // 'allDatasets' or 'specifiedDatasets'
            storeDataIssues: false, // Checkbox state for storing data issues
            manualNextClicked: false, // Track if Next button in manual mode was clicked
            schemaInfoConfirmed: false, // Track if schema/mode selection has been confirmed (hides form, shows info block)
            editingIntegrationId: null,
            editingIntegrationName: "",
            integrationValidationErrors: {}, // { [configId]: { schema?: string, datasets?: { [itemId]: string } } }
            staticValidationErrorReporter: null,
            integrationToRemove: null,

            // Presentation-only state for the edit flow.  None of the form,
            // validation, or API state is coupled to these panels.
            editPanels: {
                datasource: true,
                schemaMode: true,
                integrations: true
            },

        };
    }


    handleEditIntegrationName = (id, name) => {
        this.setState({
            editingIntegrationId: id,
            editingIntegrationName: name || ""
        });
    };

    toggleEditPanel = (panel) => {
        this.setState(prevState => ({
            editPanels: {
                ...prevState.editPanels,
                [panel]: !prevState.editPanels[panel]
            }
        }));
    };

    handleIntegrationNameChange = (id, value) => {
        const __cfg = this.state.integrationConfigurations.find(c => c.id === id);
        if (__cfg && __cfg.isExisting) return;
        this.setState(prevState => ({
            integrationConfigurations: prevState.integrationConfigurations.map(config =>
                config.id === id ? { ...config, integrationName: value } : config
            ),
            editingIntegrationName: value,
            editingIntegrationId: id
        }));
    };

    isDuplicateIntegrationName = (value, configId) => {
        const integrationName = String(value || "").trim().toLowerCase();
        if (!integrationName) return false;

        const existingIntegrations = Array.isArray(this.props.existingIntegrations) ? this.props.existingIntegrations : [];
        const isDuplicateInApi = existingIntegrations.some((integration) => {
            const existingName = String(integration.integration_name || "").trim().toLowerCase();
            return existingName === integrationName;
        });

        if (isDuplicateInApi) return true;

        const duplicateInForm = this.state.integrationConfigurations.some(config => {
            if (config.id === configId) return false;
            return String(config.integrationName || "").trim().toLowerCase() === integrationName;
        });

        return duplicateInForm;
    }

    handleSaveIntegrationName = (id) => {
        const __cfg = this.state.integrationConfigurations.find(c => c.id === id);
        if (__cfg && __cfg.isExisting) return;
        
        if (__cfg && (!__cfg.integrationName || __cfg.integrationName.trim() === '' || this.isDuplicateIntegrationName(__cfg.integrationName, id))) {
            return;
        }

        this.setState({
            editingIntegrationId: null,
            editingIntegrationName: ""
        });
    };
    

    componentDidMount() {
        this.getQualdoIps();
        this.fill_details();
        window.addEventListener('trigger-datasource-save', this.handleTriggerSave);
        if (this.props.onStaticDatasourceActionsReady) {
            this.props.onStaticDatasourceActionsReady({
                testConnection: this.handleStaticDatasourceCheck,
                fetchSchemas: this.handleStaticDatasourceFetchSchemas,
                save: this.handleStaticDatasourceSave
            });
        }
    }
    
    componentWillUnmount() {
        window.removeEventListener('trigger-datasource-save', this.handleTriggerSave);
        if (this.props.onStaticDatasourceActionsReady) {
            this.props.onStaticDatasourceActionsReady(null);
        }
    }

    handleTriggerSave = () => {
        this.handleCreateDatasource();
    }

    getStaticDatasourceFormType = (datasourceType) => {
        const formTypeMap = {
            bigquery: 'big_query',
            google_cloud_storage: 'gcs',
            azure_synapse: 'azure_synapse_ds',
            databricks: 'azure_databricks_table',
            azure_cosmos_gremlin: 'azure_cosmos_db',
            spanner_graph: 'google_cloud_spanner'
        };
        return formTypeMap[datasourceType] || datasourceType || this.state.formType;
    }

    handleStaticDatasourceCheck = async (formData, datasourceType) => {
        const formType = this.getStaticDatasourceFormType(datasourceType);
        if (!formType) {
            throw new Error("Datasource type is missing; cannot build the connection configuration.");
        }
        const datasourceConfig = this.buildDatasourceConfig(formData, formType);
        if (!datasourceConfig || Object.keys(datasourceConfig).length === 0) {
            throw new Error(`Connection configuration is not supported for datasource type "${formType}".`);
        }

        this.setState({
            isTestingConnection: true,
            testConnectionSuccess: null,
            testConnectionResponse: null,
            testConnectionError: null,
            testConnectionFormData: formData
        });

        try {
            const response = await testDataSource({
                datasource_name: formData.integration_name || formData.datasource_name || "Test Dataset",
                tenant_id: localStorage.getItem('team_id'),
                env_id: this.props.env_id || 69,
                datasource_type: this.mapDatasourceType(formType),
                data_store_type: this.getDatasourceStoreType(formType),
                datasource_config: datasourceConfig,
                auth_config: await this.buildAuthConfig(formData, formType),
                ...(formData.check_type && { check_type: formData.check_type }),
                ...((formData.datasource_id || this.state.datasource_id) && {
                    datasource_id: formData.datasource_id || this.state.datasource_id
                })
            });
            const result = response?.code === 401 && response?.response?.status_code === 200
                ? response.response
                : response?.response?.status_code ? response.response : response;
            const schemas = formType === 'azure_blob' ||
                formType === 's3' ||
                formType === 'azure_data_lake_gen2'
                ? result?.buckets || []
                : result?.schemas || [];
            const normalizedResponse = { ...result, schemas };
            const succeeded = normalizedResponse?.status_code === 200;
            this.setState({
                isTestingConnection: false,
                testConnectionSuccess: succeeded,
                testConnectionResponse: normalizedResponse,
                testConnectionError: succeeded
                    ? (response?.code === 401 ? response.message || null : null)
                    : normalizedResponse?.message || normalizedResponse?.status_message || "Connection failed."
            });
            return normalizedResponse;
        } catch (error) {
            console.error("Static datasource connection check failed:", error);
            this.setState({
                isTestingConnection: false,
                testConnectionSuccess: false,
                testConnectionError: error?.message || "Connection failed."
            });
            throw error;
        }
    }

    handleStaticDatasourceFetchSchemas = (formData, datasourceType) => (
        this.handleStaticDatasourceCheck(formData, datasourceType)
    );

    handleStaticDatasourceSave = (draft) => {
        const formType = this.getStaticDatasourceFormType(draft?.datasourceType);
        if (!draft?.formData || !formType) {
            window.dispatchEvent(new CustomEvent('save-completed', {
                detail: {
                    errorMessage: !formType
                        ? "Datasource type is missing; cannot save these changes."
                        : "Datasource changes are unavailable."
                }
            }));
            return;
        }

        if (draft.contentType === "integration") {
            this.handleStaticIntegrationSave(draft, formType);
            return;
        }

        const datasourceId = draft.datasourceId ??
            draft.originalDatasource?.datasource_id ??
            draft.originalDatasource?.id ??
            this.props.ex_integration_details?.datasource_id ??
            this.props.ex_integration_details?.id ??
            this.state.datasource_id;
        if (datasourceId === undefined || datasourceId === null || datasourceId === '') {
            window.dispatchEvent(new CustomEvent('save-completed', {
                detail: { errorMessage: "Datasource ID is missing; cannot update this datasource." }
            }));
            return;
        }

        this.setState({
            datasource_id: datasourceId,
            formType,
            ex_edit_integration_details: this.state.ex_edit_integration_details || draft.originalDatasource,
            testConnectionFormData: draft.formData,
            testConnectionResponse: { schemas: draft.availableSchemas || [] },
            selected: draft.schemaModeSelection === "allSchemas",
            specificSelect: draft.schemaModeSelection === "specificSchemas",
            schemaModeSelection: draft.schemaModeSelection,
            configurationMode: draft.configurationMode,
            selectedSchemas: draft.selectedSchemas,
            integrationConfigurations: draft.integrationConfigurations,
            integrationValidationErrors: {},
            staticValidationErrorReporter: draft.reportIntegrationValidationErrors
        }, async () => {
            try {
                await this.handleCreateDatasource();
            } catch (error) {
                const errorMessage = error?.message || "Failed to save datasource changes.";
                console.error("Static datasource save failed:", error);
                window.dispatchEvent(new CustomEvent('save-completed', {
                    detail: { errorMessage }
                }));
            }
        });
    }

    handleStaticIntegrationSave = async (draft, formType) => {
        const originalIntegration = draft.originalDatasource || this.props.ex_integration_details || {};
        const integrationId = originalIntegration.integration_id;
        const integrationConfigDraft = draft.integrationConfigurations?.[0];
        if (!integrationId || !integrationConfigDraft) {
            window.dispatchEvent(new CustomEvent('save-completed', {
                detail: { errorMessage: "Integration details are missing; cannot update this integration." }
            }));
            return;
        }

        const integrationName = integrationConfigDraft.integrationName || originalIntegration.integration_name;
        const isSchemaNameType = ['snowflake', 'postgresql', 'redshift'].includes(formType);
        const tableNames = integrationConfigDraft.incrementalData.map((item) => ({
            table: item.datasetName || "",
            created_time: item.identifier || "",
            start_with: item.startingIndexCheckbox && item.startingIndexType === "incremental data identifier"
                ? item.startingIndexValue
                : "",
            match_exact: item.exactMatch ? "match_exact" : "",
            start_with_query: item.startingIndexCheckbox && item.startingIndexType === "custom query"
                ? item.startingIndexQuery
                : "",
            start_index_check_box: item.startingIndexCheckbox ? "true" : "false",
            start_index_type: item.startingIndexType || "incremental data identifier",
            partition_type: "column"
        }));
        const partitions = integrationConfigDraft.partitions.map((partition) => ({
            dataset_name: partition.datasetName || "",
            partition_type: partition.partitionBy === "Custom Query" ? "custom_query" : "column",
            partition_name: partition.partitionName || "",
            ...(partition.partitionBy === "Custom Query"
                ? { custom_query: partition.customQuery || "" }
                : { column_name: partition.partitionIdentifier || "" })
        }));
        const integrationConfig = {
            ...this.buildDatasourceConfig(draft.formData, formType),
            integration_name: integrationName,
            ...(isSchemaNameType
                ? { schema_name: integrationConfigDraft.schema || "" }
                : { schema: integrationConfigDraft.schema || "" }),
            partitions,
            table_names: tableNames,
            datasetToBeProcessed: integrationConfigDraft.datasetScope === "allDatasets"
                ? "allDataset"
                : "specifiedDataset"
        };
        if (integrationConfigDraft.datasetScope === "specifiedDatasets") {
            integrationConfig.datasets_added = [...new Set(
                integrationConfigDraft.incrementalData
                    .filter((item) => item.isNew && !item.exactMatch && (item.datasetName || "").trim())
                    .map((item) => item.datasetName.trim())
            )];
        }
        const existingDatasourceConfig = originalIntegration.datasource_config || {};
        const datasourceConfig = {
            ...existingDatasourceConfig,
            ...this.buildDatasourceConfig(draft.formData, formType),
            integration_names: (() => {
                const existingIntegrations = existingDatasourceConfig.integration_names || [];
                let replaced = false;
                const updatedIntegrations = existingIntegrations.map((integration) => {
                    if (!replaced && integration.integration_name === originalIntegration.integration_name) {
                        replaced = true;
                        return integrationConfig;
                    }
                    return integration;
                });
                return replaced ? updatedIntegrations : [...updatedIntegrations, integrationConfig];
            })()
        };
        const requestPayload = {
            integration_id: integrationId,
            integration_name: integrationName,
            tenant_id: localStorage.getItem("team_id"),
            user_id: localStorage.getItem("user_id"),
            env_id: originalIntegration.env_id || this.props.env_id,
            datasource_id: originalIntegration.datasource_id || draft.datasourceId,
            datasource_name: originalIntegration.datasource_name || draft.formData.datasource_name || "",
            connector_type: originalIntegration.connector_type || this.mapDatasourceType(formType),
            integration_type: originalIntegration.integration_type || originalIntegration.connector_type || this.mapDatasourceType(formType),
            datasource_type: this.mapDatasourceType(formType),
            data_store_type: this.getDatasourceStoreType(formType),
            mode: draft.configurationMode === "manual" ? "manualConfig" : "autoConfig",
            config_type: draft.configurationMode === "manual" ? "manualConfig" : "autoConfig",
            integration_config: integrationConfig,
            datasource_config: datasourceConfig
        };

        this.setState({ isCreatingDatasource: true });
        try {
            requestPayload.auth_config = await this.buildAuthConfig(draft.formData, formType);
            const response = await updateIntegrationById(requestPayload);
            if (response?.code !== 200) {
                if (response?.code === 401 && ["invalid_dataset", "dataset_invalid"].includes(response?.response?.key)) {
                    const schemaName = integrationConfigDraft.schema || integrationConfig.schema_name || integrationConfig.schema;
                    const errorMessage = schemaName
                        ? `Specified dataset doesn't exist in "${schemaName}"`
                        : response?.message || response?.status_message || "Specified dataset does not exist.";
                    const failedDatasets = Object.entries(response.response)
                        .filter(([key, value]) => key !== "key" && Array.isArray(value))
                        .flatMap(([, datasets]) => datasets);
                    const datasetErrors = {};
                    const incrementalData = integrationConfigDraft.incrementalData || [];

                    failedDatasets.forEach((failedDataset) => {
                        let targetItem = incrementalData.find((item) =>
                            (item.datasetName || "").trim().toLowerCase() === String(failedDataset || "").trim().toLowerCase()
                        );
                        if (!targetItem) {
                            targetItem = incrementalData.find((item) => item.isNew) || incrementalData[incrementalData.length - 1];
                        }
                        if (targetItem) datasetErrors[targetItem.id] = errorMessage;
                    });

                    if (Object.keys(datasetErrors).length === 0 && incrementalData.length > 0) {
                        const targetItem = incrementalData.find((item) => item.isNew) || incrementalData[incrementalData.length - 1];
                        datasetErrors[targetItem.id] = errorMessage;
                    }

                    if (typeof draft.reportIntegrationValidationErrors === "function") {
                        draft.reportIntegrationValidationErrors({
                            [integrationConfigDraft.id]: { datasets: datasetErrors }
                        });
                    }
                    window.dispatchEvent(new CustomEvent("save-completed", {
                        detail: { errorMessage }
                    }));
                    return;
                }
                throw new Error(response?.message || response?.status_message || "Failed to update integration.");
            }

            this.props.showToast && this.props.showToast("alert-success", "Integration saved successfully", null, null, false);
            this.props.onIntegrationSaved && this.props.onIntegrationSaved({
                ...originalIntegration,
                ...(response.integration || {}),
                integration_id: integrationId,
                integration_name: integrationName,
                integration_config: integrationConfig,
                datasource_config: datasourceConfig,
                mode: requestPayload.mode,
                config_type: requestPayload.config_type
            });
            this.props.setEnvData && this.props.setEnvData(requestPayload.env_id);
            window.dispatchEvent(new Event("save-completed"));
            this.props.closeModal && this.props.closeModal();
        } catch (error) {
            const errorMessage = error?.message || "Failed to update integration.";
            console.error("Static integration save failed:", error);
            window.dispatchEvent(new CustomEvent("save-completed", {
                detail: { errorMessage }
            }));
        } finally {
            this.setState({ isCreatingDatasource: false });
        }
    };

    async getDatasourceDetailById(datasource_id, env_id) {
        if (datasource_id !== undefined && datasource_id !== null) {
            let teamId = localStorage.getItem('team_id');
            let userId = localStorage.getItem('user_id');
            let data = {datasource_id:datasource_id, tenant_id:teamId,user_id:userId,env_id:env_id};
           // data = {"user_id":3 , "env_id" : 1, "tenant_id" : 1, "datasource_id":11}

            let response =  await editDataSource(data);
             if (response.code === 200) {
                    let integration_details = response.datasource;
                    
                    // Get datasource type from response (could be datasource_type or connector_type)
                    const datasourceType = integration_details.datasource_type || integration_details.connector_type;
                    
                    // Map the response to form data format for pre-filling
                    const formData = this.mapDatasourceResponseToFormData(integration_details, datasourceType);
                    
                    // Extract the saved schema/bucket scope. Keep this independent
                    // from integration_names so an incomplete saved configuration can
                    // be corrected in the edit form.
                    let schemas = [];
                    const configData = integration_details.datasource_config || integration_details.integration_config || integration_details;
                    const toSchemaList = (value) => Array.isArray(value)
                        ? value.filter(Boolean)
                        : (value ? [value] : []);
                    if (toSchemaList(configData.schema_names).length || toSchemaList(configData.buckets).length) {
                        // Specified schemas (buckets for file-based connectors)
                        schemas = toSchemaList(configData.schema_names).length
                            ? toSchemaList(configData.schema_names)
                            : toSchemaList(configData.buckets);
                    } else if (configData.integration_names || configData.integration_config) {
                        // Manual config mode fallback - extract unique schemas from integration_names/config
                        const rawIntegrations = configData.integration_names || configData.integration_config;
                        const arr = Array.isArray(rawIntegrations) ? rawIntegrations : [rawIntegrations];
                        schemas = [...new Set(
                            arr.map(config => config.bucket || config.schema_name || config.schema)
                                .filter(Boolean)
                        )];
                    } else if (configData.schema || configData.bucket) {
                        // Single schema/bucket case
                        schemas = toSchemaList(configData.schema || configData.bucket);
                    }
                    
                    // Determine configuration mode from response
                    const configMode = integration_details.mode === 'manualConfig' ? 'manual' : 'autoconfig';
                    
                    // Determine schema mode selection
                    const schemaToBeProcessed = configData.schemaToBeProcessed || configData.auto_config_type;
                    // For manualConfig with integration_names, infer specificSchemas
                    const hasManualIntegrations = integration_details.mode === 'manualConfig' &&
                        (configData.integration_names?.length > 0 || configData.integration_config);
                    const schemaModeSelection = (schemaToBeProcessed === 'specifiedSchema' || schemaToBeProcessed === 'specifiedBucket' || schemaToBeProcessed === 'specifiedDataset' || schemaToBeProcessed === 'specificSchemas' || schemaToBeProcessed === 'specificBuckets' || hasManualIntegrations)
                        ? 'specificSchemas'
                        : 'allSchemas';
                    const isAllSchemas = schemaModeSelection === 'allSchemas';
                    const isSpecificSchemas = schemaModeSelection === 'specificSchemas';
                    
                    // Map integration_names from API to component state format
                    // const integrationConfigs = this.mapIntegrationConfigToState(
                    //     integration_details.datasource_config?.integration_names || []
                    // );
                    
                    // For edit mode, set test connection as successful since connection was already validated
                    const testConnectionResponse = {
                        message: "Connection already validated",
                        schemas: schemas // Use extracted schemas array
                    };

                    const integrationConfigs = this.mapIntegrationConfigToState(
                        integration_details.datasource_config?.integration_names || []
                    );
                    
                    this.setState({
                        ex_edit_integration_details: integration_details,
                        testConnectionFormData: formData,
                        formType: this.mapApiDatasourceTypeToFormType(datasourceType),
                        formType_option: this.getFormTypeOption(datasourceType),
                        testConnectionSuccess: true,
                        testConnectionResponse: testConnectionResponse,
                        showTestConnectionInfo: true,
                        selectedSchemas: schemas, // Use extracted schemas array
                        confirmedSchemas: schemas, // Mirror to confirmed so button reflects initial selection
                        configurationMode: configMode, // Set configuration mode
                        schemaModeSelection: schemaModeSelection, // Set schema mode
                        selected: isAllSchemas, // Set All Schemas radio
                        specificSelect: isSpecificSchemas, // Set Specific Schemas radio
                        showSchemaConfigInfo: true, // Show schema config section
                        manualNextClicked: configMode === 'manual', // Show manual config section if manual mode
                        schemaInfoConfirmed: true, // Pre-confirmed since loaded from existing data
                        integrationConfigurations: integrationConfigs, // Set manual configuration details
                        datasource_id: datasource_id
                    });

                    // Sync the refreshed auto_config_status back to the main datasources table
                    if (this.props.onAutoConfigStatusUpdate && integration_details.auto_config_status !== undefined) {
                        this.props.onAutoConfigStatusUpdate(datasource_id, integration_details.auto_config_status);
                    }
            }
    }   
}

    // Map API datasource type to form type
    mapApiDatasourceTypeToFormType = (apiType) => {
        // Safety check for undefined/null
        if (!apiType) {
            console.warn('mapApiDatasourceTypeToFormType: apiType is undefined or null');
            return 'snowflake'; // Default fallback
        }
        
        const mapping = {
            'MySQL': 'mysql',
            'PostgreSQL': 'postgresql', 
            'Snowflake': 'snowflake',
            'snow_flake': 'snowflake', // Handle API format
            'Azure Blob': 'azure_blob',
            'Azure Data Lake Gen2': 'azure_data_lake_gen2',
            'AWS S3': 's3',
            'Google Cloud Storage': 'google_cloud_storage',
            'BigQuery': 'bigquery',
            'Redshift': 'redshift',
            'Azure Synapse': 'azure_synapse',
            'Azure SQL': 'azure_sql',
            'Databricks': 'databricks'
        };
        return mapping[apiType] || apiType.toLowerCase().replace(/\s+/g, '_');
    }

    // Get form type option object
    getFormTypeOption = (apiType) => {
    
        if (!apiType) {
            return { label: 'Snowflake', value: 'snowflake' }; // Default fallback
        }
        
        const formType = this.mapApiDatasourceTypeToFormType(apiType);
        
        // Map back to display label
        const labelMapping = {
            'snowflake': 'Snowflake',
            'snow_flake': 'Snowflake',
            'mysql': 'MySQL',
            'postgresql': 'PostgreSQL',
            'azure_blob': 'Azure Blob',
            'azure_data_lake_gen2': 'Azure Data Lake Gen2',
            's3': 'AWS S3',
            'aws_s3': 'AWS S3',
            'google_cloud_storage': 'Google Cloud Storage',
            'bigquery': 'BigQuery',
            'redshift': 'Redshift',
            'azure_synapse': 'Azure Synapse',
            'azure_sql': 'Azure SQL',
            'databricks': 'Databricks'
        };
        
        return {
            label: labelMapping[formType] || apiType,
            value: formType
        };
    }

    // Map datasource response to form data format
    mapDatasourceResponseToFormData = (datasource, datasourceType) => {
        const config = datasource.datasource_config || {};
        const authConfig = datasource.auth_config || {};
        
        // Normalize datasource type (could be from datasource_type or connector_type)
        const normalizedType = this.mapApiDatasourceTypeToFormType(datasourceType);
        
        // Base form data
        const formData = {
            datasource_name: datasource.datasource_name || '',
        };

        // Map based on normalized datasource type
        if (normalizedType === 'snowflake') {
            // Snowflake mapping
            const hostValue = config.host_url || config.url || config.host || config.account || '';
            const databaseValue = config.database_name || config.database || '';
            formData.host_url = hostValue;
            formData.host = hostValue;
            formData.warehouse = config.ware_house || config.warehouse || '';
            formData.database_name = databaseValue;
            formData.database = databaseValue;
            formData.schema = config.schema || '';
            formData.username = authConfig.user || authConfig.username || '';
            formData.user_name = authConfig.user_name || authConfig.user || authConfig.username || '';
            formData.password = authConfig.password || '';
            formData.role = config.role || '';
            
            // Set auth method based on available credentials
            if (authConfig.private_key && authConfig.private_key.trim() !== '') {
                formData.authMethod = 'Private Key';
                formData.privateKey = authConfig.private_key || '';
                formData.privateKeyPassphrase = authConfig.private_key_pwd || '';
            } else {
                formData.authMethod = 'Username & Password';
            }
        } else if (normalizedType === 'mysql' || normalizedType === 'postgresql') {
            // MySQL/PostgreSQL mapping
            const hostValue = config.host_url || config.host || '';
            const databaseValue = config.database_name || config.database || '';
            formData.host = hostValue;
            formData.host_url = hostValue;
            formData.database = databaseValue;
            formData.database_name = databaseValue;
            formData.user_name = authConfig.user_name || authConfig.user || authConfig.username || '';
            formData.password = authConfig.password || '';
            formData.ssl_mode = config.ssl_mode || 'disable';
        } else if (normalizedType === 'azure_blob') {
            // Azure Blob mapping
            const integration = config.integration_names && config.integration_names.length > 0 ? config.integration_names[0] : {};
            formData.storage_name = config.storage_name || integration.storage_name || '';
            formData.fileType = config.filetype || config.fileType || integration.filetype || integration.fileType || '';
            formData.refreshType = config.refresh_type || integration.refresh_type || 'file_replace';
            
            const rawVersionFormat = config.version_format || integration.version_format || config.version_type || integration.version_type || '';
            let parsedVersionFormat = rawVersionFormat;
            let parsedRegex = '';
            
            // Check if it's one of the known predefined regexes
            const knownKey = Object.keys(VERSION_FORMATS || {}).find(key => VERSION_FORMATS[key] === rawVersionFormat);
            if (knownKey) {
                parsedVersionFormat = knownKey;
            } else if (rawVersionFormat !== 'none' && rawVersionFormat !== '' && !['dd-mm-yyyy', 'yyyy-mm-dd', 'dd-mm-yy'].includes(rawVersionFormat)) {
                parsedVersionFormat = 'custom';
                parsedRegex = rawVersionFormat;
            }
            
            formData.versionFormat = parsedVersionFormat === 'none' ? '' : parsedVersionFormat;
            formData.versionFormatRegex = parsedRegex;
            formData.versionOccurence = config.version_occurence || integration.version_occurence || 'prefix';
            
            formData.error_storage = config.error_storage || '';
            formData.storeDataIssues = config.default_error_storage === false;
            formData.blob_secret = authConfig.secret_key || authConfig.blob_secret || '';
        }  else if (normalizedType === 'azure_data_lake_gen2') {
            // Azure Data Lake Gen2 mapping
            const integration = config.integration_names && config.integration_names.length > 0 ? config.integration_names[0] : {};
            formData.storage_name = config.storage_name || integration.storage_name || '';
            formData.fileType = config.filetype || config.fileType || integration.filetype || integration.fileType || '';
            formData.refreshType = config.refresh_type || integration.refresh_type || 'file_replace';
            
            const rawVersionFormat = config.version_format || integration.version_format || config.version_type || integration.version_type || '';
            let parsedVersionFormat = rawVersionFormat;
            let parsedRegex = '';
            
            // Check if it's one of the known predefined regexes
            const knownKey = Object.keys(VERSION_FORMATS || {}).find(key => VERSION_FORMATS[key] === rawVersionFormat);
            if (knownKey) {
                parsedVersionFormat = knownKey;
            } else if (rawVersionFormat !== 'none' && rawVersionFormat !== '' && !['dd-mm-yyyy', 'yyyy-mm-dd', 'dd-mm-yy'].includes(rawVersionFormat)) {
                parsedVersionFormat = 'custom';
                parsedRegex = rawVersionFormat;
            }
            
            formData.versionFormat = parsedVersionFormat === 'none' ? '' : parsedVersionFormat;
            formData.versionFormatRegex = parsedRegex;
            formData.versionOccurence = config.version_occurence || integration.version_occurence || 'prefix';
            
            formData.error_storage = config.error_storage || '';
            formData.storeDataIssues = config.default_error_storage === false;
            formData.blob_secret = authConfig.secret_key || authConfig.blob_secret || '';
        } else if (normalizedType === 's3' || normalizedType === 'aws_s3') {
            // AWS S3 mapping
            const integration = config.integration_names && config.integration_names.length > 0 ? config.integration_names[0] : {};
            formData.fileType = config.filetype || config.fileType || integration.filetype || integration.fileType || '';
            formData.refreshType = config.refresh_type || integration.refresh_type || 'file_replace';

            const rawVersionFormat = config.version_format || integration.version_format || config.version_type || integration.version_type || '';
            const knownKey = Object.keys(VERSION_FORMATS || {}).find(key => VERSION_FORMATS[key] === rawVersionFormat);
            if (knownKey) {
                formData.versionFormat = knownKey;
                formData.versionFormatRegex = '';
            } else if (rawVersionFormat !== 'none' && rawVersionFormat !== '' && !['dd-mm-yyyy', 'yyyy-mm-dd', 'dd-mm-yy'].includes(rawVersionFormat)) {
                formData.versionFormat = 'custom';
                formData.versionFormatRegex = rawVersionFormat;
            } else {
                formData.versionFormat = rawVersionFormat === 'none' ? '' : rawVersionFormat;
                formData.versionFormatRegex = '';
            }

            formData.versionOccurence = config.version_occurence || integration.version_occurence || 'prefix';
            formData.error_storage = config.error_storage || '';
            formData.storeDataIssues = config.default_error_storage === false;
            formData.accessKey = authConfig.access_key || authConfig.accessKey || authConfig.access_key_id || '';
            formData.secretAccessKey = authConfig.secret_access_key || authConfig.secretAccessKey || '';
        } else if (normalizedType === 'google_cloud_storage') {
            // Google Cloud Storage mapping
            formData.bucket_name = config.bucket_name || '';
            formData.project_id = config.project_id || '';
            formData.credentials_json = authConfig.credentials_json || '';
        } else if (normalizedType === 'bigquery') {
            // BigQuery mapping
            formData.project_id = config.project_id || '';
            formData.dataset_id = config.dataset_id || '';
            formData.json_file = authConfig.json_file || '';
        } else if (normalizedType === 'redshift') {
            // Redshift mapping
            formData.host = config.host || '';
            formData.port = config.port || '';
            formData.database = config.database || '';
            formData.username = authConfig.user || authConfig.username || '';
            formData.password = authConfig.password || '';
            formData.cluster_identifier = config.cluster_identifier || '';
        } else if (normalizedType === 'azure_synapse') {
            // Azure Synapse mapping
            formData.server = config.server || '';
            formData.database = config.database || '';
            formData.username = authConfig.user || authConfig.username || '';
            formData.password = authConfig.password || '';
            formData.authentication_method = authConfig.authentication_method || 'SQL';
        } else if (normalizedType === 'azure_sql') {
            // Azure SQL mapping
            formData.server = config.server || '';
            formData.database = config.database || '';
            formData.port = config.port || '';
            formData.username = authConfig.user || authConfig.username || '';
            formData.password = authConfig.password || '';
            formData.driver = config.driver || '';
        } else if (normalizedType === 'databricks') {
            // Databricks mapping
            formData.host = config.host || '';
            formData.http_path = config.http_path || '';
            formData.catalog = config.catalog || '';
            formData.schema = config.schema || '';
            formData.access_token = authConfig.access_token || '';
        } else {
            // Generic mapping for other datasource types
            Object.keys(config).forEach(key => {
                if (key !== 'error_storage' && key !== 'default_error_storage' && key !== 'schemaToBeProcessed' && key !== 'integration_names') {
                    formData[key] = config[key];
                }
            });
            Object.keys(authConfig).forEach(key => {
                // Map common auth field names
                if (key === 'user') {
                    formData.username = authConfig[key];
                } else {
                    formData[key] = authConfig[key];
                }
            });
        }

        return formData;
    }

    // Map integration_names from API response to component state format
    mapIntegrationConfigToState = (integrationConfigArray) => {
        if (!Array.isArray(integrationConfigArray) || integrationConfigArray.length === 0) {
            return [];
        }

        // console.log('mapIntegrationConfigToState - Input:', integrationConfigArray);

        return integrationConfigArray.map((apiConfig, index) => {

            // Always ensure schema_name/schema and table_names fields exist
            const schemaValue = apiConfig.bucket || apiConfig.schema_name || apiConfig.schema || null;
            const tableNamesValue = Array.isArray(apiConfig.table_names) ? apiConfig.table_names : [];

            // Map table_names to incrementalData format, always include all required fields with defaults
            const incrementalData = tableNamesValue.map((tableItem, tableIndex) => {
                const mapped = {
                    id: Date.now() + index * 1000 + tableIndex, // Generate unique ID
                    datasetName: tableItem.table || '',
                   // identifier: tableItem.created_time || '',
                    identifier: tableItem.identifier || tableItem.created_time || '',
                    startingIndexCheckbox: tableItem.start_index_check_box === 'true' || tableItem.start_index_check_box === true || tableItem.start_index_check_box === 'match_exact',
                    startingIndexType: tableItem.start_index_type || 'incremental data identifier',
                    startingIndexValue: tableItem.start_with || '',
                    startingIndexQuery: tableItem.start_with_query || '',
                    exactMatch: tableItem.match_exact === 'match_exact' || tableItem.match_exact === true,
                    isNew: false,
                    // Always include all required fields for edit/add consistency
                    created_time: tableItem.created_time || '',
                    match_exact: tableItem.match_exact || '',
                    partition_type: tableItem.partition_type || 'column',
                    start_index_check_box: tableItem.start_index_check_box || '',
                    start_index_type: tableItem.start_index_type || 'incremental data identifier',
                    start_with: tableItem.start_with || '',
                    start_with_query: tableItem.start_with_query || '',
                    table: tableItem.table || ''
                };
                return mapped;
            });

            // Map partitions to component format
            const partitions = (apiConfig.partitions || []).map((partitionItem, partitionIndex) => ({
                id: Date.now() + index * 1000 + 500 + partitionIndex, // Generate unique ID
                datasetName: partitionItem.dataset_name || partitionItem.datasetName || '',
                partitionName: partitionItem.partition_name || partitionItem.partitionName || '',
                partitionBy: partitionItem.partition_type === 'custom_query' ? 'Custom Query' : 'Column',
                partitionIdentifier: partitionItem.column_name || partitionItem.partition_identifier || partitionItem.partitionIdentifier || partitionItem.columnName || '',
                customQuery: partitionItem.custom_query || partitionItem.partition_query || partitionItem.customQuery || '',
                isNew: false
            }));

            // Map datasetToBeProcessed to datasetScope
            let datasetScope = 'allDatasets';
            if (apiConfig.datasetToBeProcessed === 'specifiedDataset') {
                datasetScope = 'specifiedDatasets';
            } else if (apiConfig.datasetToBeProcessed === 'allDataset') {
                datasetScope = 'allDatasets';
            }

            const result = {
                id: Date.now() + index * 10000, // Generate unique ID for integration
                schema: schemaValue,
                schema_name: schemaValue, // Always include schema_name for robustness
                sub_path: apiConfig.sub_path || apiConfig.subPath || '',
                table_names: tableNamesValue, // Always include table_names for robustness
                database: apiConfig.database || null,
                integrationName: apiConfig.integration_name || '',
                datasetScope: datasetScope,
                incrementalData: incrementalData,
                partitions: partitions,
                errorStorage: apiConfig.error_storage || '',
                status_code: apiConfig.status_code,
                isExisting: true,
                defaultErrorStorage: apiConfig.default_error_storage !== false
            };
            
            // console.log(`Mapped Integration Config [${index}]:`, result);
            return result;
        });
    }
    

    editDatasourceDetails(){
        this.setState({
            testConnectionSuccess: null,
            testConnectionError: null, // Clear error when editing
            testConnectionResponse: null, // Clear test connection response and stages
            isTestingConnection: false, // Reset testing state
            showTestConnectionInfo: false, // Hide test connection info panel to show datasource form again
            showSchemaConfigInfo: null, // Hide schema & mode selection panel
            // Note: Don't reset formResetKey - keep the form fields as they are
            // Keep testConnectionFormData for form refilling
        });
        // Notify EditActions to disable Save Changes while re-editing datasource details
        window.dispatchEvent(new CustomEvent('datasource-editing-details', { detail: { editing: true } }));
    }

    handleContinueSchemaSelection = () => {
        this.setState({
            showTestConnectionInfo: true,
            showSchemaConfigInfo: true,
        });
        // Re-enable Save Changes in EditActions once we're back to the info view
        window.dispatchEvent(new CustomEvent('datasource-editing-details', { detail: { editing: false } }));
    }

    editSchemaAndModeSelection(){
        this.setState({
            showSchemaConfigInfo: true,
            showTestConnectionInfo: true,
            manualNextClicked: false,
            schemaInfoConfirmed: false, // Re-show the form selection section
        });  
    }


    handleSchemaModeSelectionNext= (event) => {
        if (event) {
            event.preventDefault();
        }
        
        const { selectedSchemas, specificSelect } = this.state;
        
        if (specificSelect && selectedSchemas.length === 0) {
            this.setState({ schemaSelectionError: true });
            return;
        }

        this.setState({
            showSchemaConfigInfo: true,
            manualNextClicked: true,
            schemaInfoConfirmed: true,
            schemaSelectionError: false
        }, this.focusAddIntegrationButton);
        
    }

    focusAddIntegrationButton = () => {
        window.requestAnimationFrame(() => {
            const element = document.getElementById("datasource-add-integrations-button");

            if (element) {
                element.scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                });

                try {
                    element.focus({ preventScroll: true });
                } catch (error) {
                    element.focus();
                }

                element.click();
            }
        });
    }

    handleSchemaModeSelection = (event) => {
        const value = event.target.value;
        if (this.state.ex_edit_integration_details && !isEditSchemaModeTransitionAllowed(this.state.ex_edit_integration_details, value, this.state.configurationMode)) {
            return;
        }
        if (value === 'allSchemas') {
            this.setState(prevState => ({
                selected: true,
                specificSelect: false,
                schemaModeSelection: value,
                schemaSelectionError: false,
                configurationMode: prevState.configurationMode === 'autoconfig' ? 'autoconfig' : 'autoconfig'
            }));
        } else if (value === 'specificSchemas') {
            this.setState({
                selected: false,
                specificSelect: true,
                schemaSelectionError: false,
                schemaModeSelection: value,
                manualNextClicked: false,
                schemaInfoConfirmed: false
            });
        }
    }

    handleConfigurationModeChange = (event) => {
        const mode = event.target.value;
        if (this.state.schemaModeSelection === 'allSchemas' && mode === 'manual') {
            return;
        }
        if (this.state.ex_edit_integration_details && !isEditSchemaModeTransitionAllowed(this.state.ex_edit_integration_details, this.state.schemaModeSelection, mode)) {
            return;
        }
        this.setState({ configurationMode: mode });
    }

    handleExpandIncrementalData = (id) => {
        this.setState({ expandIncrementalData: id});
    }
    handleAddPartition = (id) => {
        this.setState({ partitionData: id });
    }
    handleCloseSchemeModal = () => {
        this.setState({showSchemeModal: false, schemeModalLoading: false});
    }

    handleConfirmSchemaSelection = () => {
        // A datasource must retain at least one schema/bucket. This also
        // prevents confirming a change that removes every existing selection.
        if (this.state.selectedSchemas.length === 0) {
            return;
        }

        // Persist the in-modal selections and close
        this.setState({
            showSchemeModal: false,
            schemeModalLoading: false,
            confirmedSchemas: [...this.state.selectedSchemas]
        });
    }
    handleShowSchemeModal = async () => {
        // Pre-seed selectedSchemas from last confirmed state so modal checkboxes
        // always start from what was previously confirmed
        this.setState({showSchemeModal : true, schemeModalLoading: true, selectedSchemas: [...this.state.confirmedSchemas]});
        
        if (this.state.testConnectionFormData) {
            try {
                const formData = this.state.testConnectionFormData;
                const requestPayload = {
                    datasource_name: formData.integration_name || formData.datasource_name || "Test Dataset",
                    tenant_id: localStorage.getItem('team_id'), 
                    env_id: this.props.env_id || 69,
                    datasource_type: this.mapDatasourceType(this.state.formType),
                    data_store_type: this.getDatasourceStoreType(this.state.formType),
                    datasource_config: this.buildDatasourceConfig(formData, this.state.formType),
                    auth_config: await this.buildAuthConfig(formData, this.state.formType),
                    // ...(formData.check_type && { check_type: formData.check_type }),
                    ...(formData.datasource_id && { datasource_id: formData.datasource_id })
                };
                
                const testDataSourceResponse = await testDataSource(requestPayload);
                if (testDataSourceResponse?.status_code === 200) {
                    const normalizedResponse = {
                        ...testDataSourceResponse,
                        schemas: this.state.formType === 'azure_blob' || this.state.formType ==='s3' || this.state.formType === 'azure_data_lake_gen2'
                            ? testDataSourceResponse?.buckets || []
                            : testDataSourceResponse?.schemas || []
                    };
                    
                    this.setState({
                        testConnectionResponse: normalizedResponse,
                        testConnectionSuccess: true,
                        testConnectionError: null,
                        schemeModalLoading: false
                    });
                } else {
                    // Store the failed response too so stages can be displayed in the modal
                    const normalizedResponse = {
                        ...testDataSourceResponse,
                        schemas: this.state.formType === 'azure_blob'|| this.state.formType ==='s3' || this.state.formType === 'azure_data_lake_gen2'
                            ? testDataSourceResponse?.buckets || []
                            : testDataSourceResponse?.schemas || []
                    };
                    this.setState({ 
                        schemeModalLoading: false,
                        testConnectionResponse: normalizedResponse,
                        testConnectionSuccess: false,
                        testConnectionError: testDataSourceResponse?.message || testDataSourceResponse?.status_message || 'Connection Failed. Please check your credentials.'
                    });
                }
            } catch (error) {
                console.error("Error fetching schemas:", error);
                this.setState({ 
                    schemeModalLoading: false,
                    testConnectionSuccess: false,
                    testConnectionError: error?.message || 'Connection Failed. Please check your credentials.'
                });
            }
        } else {
            // Switch to success state after 5 seconds
            setTimeout(() => {
                this.setState({schemeModalLoading: false});
            }, 5000);
        }
    }

    handleSchemaSelect = (schemaName) => {
        const { selectedSchemas } = this.state;
        if (selectedSchemas.includes(schemaName)) {
            // Remove schema if already selected
            this.setState({
                selectedSchemas: selectedSchemas.filter(s => s !== schemaName)
            });
        } else {
            // Add schema if not selected
            this.setState({
                selectedSchemas: [...selectedSchemas, schemaName]
            });
        }
    }

    handleSelectAllSchemas = () => {
        const schemas = this.state.testConnectionResponse?.schemas || [];
        const { selectedSchemas } = this.state;
        
        if (selectedSchemas.length === schemas.length) {
            // Deselect all if all are selected
            this.setState({ selectedSchemas: [] });
        } else {
            // Select all
            this.setState({ selectedSchemas: [...schemas] });
        }
    }

    handleAddIntegration = () => {
        const newIntegration = {
            id: Date.now(), // Unique ID for each integration
            schema: null,
            sub_path: '',
            datasetScope: 'allDatasets',
            incrementalData: [],
            partitions: []
        };
        
        this.setState({
            integrationConfigurations: [...this.state.integrationConfigurations, newIntegration]
        });
    }

    getIntegrationSchemaName = (config) => {
        const value = config?.bucket || config?.schema || config?.schema_name;
        return typeof value === 'string' ? value.trim() : value;
    }

    getRequiredManualSchemas = () => {
        const { schemaModeSelection, selectedSchemas, testConnectionResponse } = this.state;
        return schemaModeSelection === 'allSchemas'
            ? (testConnectionResponse?.schemas || [])
            : (selectedSchemas || []);
    }

    getManualSchemasWithoutIntegration = () => {
        const requiredSchemas = this.getRequiredManualSchemas();
        return requiredSchemas.filter(schema =>
            !this.state.integrationConfigurations.some(config =>
                this.getIntegrationSchemaName(config) === schema
            )
        );
    }

    hasIntegrationForEveryRequiredSchema = () => {
        const requiredSchemas = this.getRequiredManualSchemas();
        return requiredSchemas.length > 0 && this.getManualSchemasWithoutIntegration().length === 0;
    }

    removeIntegrationAndOrphanedSchema = (integrationId) => {
        this.setState(prevState => {
            const remainingIntegrations = prevState.integrationConfigurations.filter(
                config => config.id !== integrationId
            );

            // Schema cleanup is deferred to save time (handleCreateDatasource).
            // selectedSchemas/confirmedSchemas are intentionally left unchanged here
            // so the schema chip remains visible in the UI until Save Changes is clicked.
            return {
                integrationConfigurations: remainingIntegrations,
                integrationToRemove: null
            };
        });
    }

    handleRemoveIntegration = (integrationId) => {
        if (this.state.integrationConfigurations.length <= 1) return;
        this.removeIntegrationAndOrphanedSchema(integrationId);
    }

    handleShowRemoveIntegration = (integrationId) => {
        if (this.state.integrationConfigurations.length <= 1) return;

        const index = this.state.integrationConfigurations.findIndex(config => config.id === integrationId);
        if (index === -1) return;

        const config = this.state.integrationConfigurations[index];
        if (!config.integrationName || config.integrationName.trim() === '') {
            this.handleRemoveIntegration(integrationId);
            return;
        }

        this.setState({
            integrationToRemove: {
                id: integrationId,
                integrationName: config.integrationName
            }
        });
    }

    handleCloseRemoveIntegration = () => {
        this.setState({ integrationToRemove: null });
    }

    handleConfirmRemoveIntegration = () => {
        const integrationId = this.state.integrationToRemove?.id;
        if (integrationId === undefined || integrationId === null) return;
        if (this.state.integrationConfigurations.length <= 1) {
            this.setState({ integrationToRemove: null });
            return;
        }

        this.removeIntegrationAndOrphanedSchema(integrationId);
    }

    handleAddIncrementalData = (integrationId) => {
        const __cfg = this.state.integrationConfigurations.find(c => c.id === integrationId);
        if (__cfg && __cfg.isExisting) return;
        // Find the configuration
        const config = this.state.integrationConfigurations.find(c => c.id === integrationId);
        
        if (!config) return;
        
        // Validate existing incremental data rows
        if (config.incrementalData.length > 0) {
            const lastItem = config.incrementalData[config.incrementalData.length - 1];
            let hasError = false;
            //let errorMessage = '';
            
            // Check required fields
            if (!lastItem.datasetName || lastItem.datasetName.trim() === '') {
                hasError = true;
                //errorMessage = 'Please fill Dataset Name in the previous row';
            } else if (lastItem.startingIndexCheckbox) {
                // If starting index is enabled, validate based on type
                if (lastItem.startingIndexType === 'incremental data identifier') {
                    if (!lastItem.startingIndexValue || lastItem.startingIndexValue.trim() === '') {
                        hasError = true;
                        //errorMessage = 'Please fill Starting Index Value in the previous row';
                    }
                } else if (lastItem.startingIndexType === 'custom query') {
                    if (!lastItem.startingIndexQuery || lastItem.startingIndexQuery.trim() === '') {
                        hasError = true;
                        //errorMessage = 'Please fill Starting Index Query in the previous row';
                    }
                }
            }
            
            if (hasError) {
                return;
            }
        }
        
        const newIncrementalData = {
            id: Date.now(),
            datasetName: '',
            identifier: '',
            startingIndexCheckbox: false,
            startingIndexType: 'incremental data identifier',
            startingIndexValue: '',
            startingIndexQuery: '',
            exactMatch: true,
            isNew: true
        };
        
        this.setState({
            integrationConfigurations: this.state.integrationConfigurations.map(config =>
                config.id === integrationId
                    ? { ...config, incrementalData: [...config.incrementalData, newIncrementalData] }
                    : config
            )
        });
    }

    handleRemoveIncrementalData = (integrationId, incrementalDataId) => {
        const __cfg = this.state.integrationConfigurations.find(c => c.id === integrationId);
        if (__cfg && __cfg.isExisting) return;
        this.setState({
            integrationConfigurations: this.state.integrationConfigurations.map(config =>
                config.id === integrationId
                    ? { ...config, incrementalData: config.incrementalData.filter(data => data.id !== incrementalDataId) }
                    : config
            )
        });
    }

    handleStartingIndexCheckbox = (integrationId, incrementalDataId, checked) => {
        const __cfg = this.state.integrationConfigurations.find(c => c.id === integrationId);
        if (__cfg && __cfg.isExisting) return;
        this.setState({
            integrationConfigurations: this.state.integrationConfigurations.map(config =>
                config.id === integrationId
                    ? {
                        ...config,
                        incrementalData: config.incrementalData.map(data =>
                            data.id === incrementalDataId
                                ? { ...data, startingIndexCheckbox: checked }
                                : data
                        )
                    }
                    : config
            )
        });
    }

    handleStartingIndexTypeChange = (integrationId, incrementalDataId, type) => {
        const __cfg = this.state.integrationConfigurations.find(c => c.id === integrationId);
        if (__cfg && __cfg.isExisting) return;
        this.setState({
            integrationConfigurations: this.state.integrationConfigurations.map(config =>
                config.id === integrationId
                    ? {
                        ...config,
                        incrementalData: config.incrementalData.map(data =>
                            data.id === incrementalDataId
                                ? { ...data, startingIndexType: type }
                                : data
                        )
                    }
                    : config
            )
        });
    }

    handleExactMatchChange = (integrationId, incrementalDataId, checked) => {
        const __cfg = this.state.integrationConfigurations.find(c => c.id === integrationId);
        if (__cfg && __cfg.isExisting) return;
        this.setState({
            integrationConfigurations: this.state.integrationConfigurations.map(config =>
                config.id === integrationId
                    ? {
                        ...config,
                        incrementalData: config.incrementalData.map(data =>
                            data.id === incrementalDataId
                                ? { ...data, exactMatch: checked }
                                : data
                        )
                    }
                    : config
            )
        });
    }

    handleIncrementalDataFieldChange = (integrationId, incrementalDataId, fieldName, value) => {
        const __cfg = this.state.integrationConfigurations.find(c => c.id === integrationId);
        if (__cfg && __cfg.isExisting) return;
        this.setState(prevState => {
            const updatedConfigs = prevState.integrationConfigurations.map(config =>
                config.id === integrationId
                    ? {
                        ...config,
                        incrementalData: config.incrementalData.map(data =>
                            data.id === incrementalDataId
                                ? { ...data, [fieldName]: value }
                                : data
                        )
                    }
                    : config
            );
            // Clear dataset-level validation error when user changes datasetName
            let updatedErrors = prevState.integrationValidationErrors;
            if (fieldName === 'datasetName') {
                const cfgErrors = updatedErrors[integrationId];
                if (cfgErrors && cfgErrors.datasets && cfgErrors.datasets[incrementalDataId]) {
                    const newDatasets = { ...cfgErrors.datasets };
                    delete newDatasets[incrementalDataId];
                    updatedErrors = {
                        ...updatedErrors,
                        [integrationId]: { ...cfgErrors, datasets: newDatasets }
                    };
                }
            }
            return {
                integrationConfigurations: updatedConfigs,
                integrationValidationErrors: updatedErrors
            };
        });
    }

    handleDatasetScopeChange = (integrationId, scope) => {
        const __cfg = this.state.integrationConfigurations.find(c => c.id === integrationId);
        if (__cfg && __cfg.isExisting) return;
        this.setState({
            integrationConfigurations: this.state.integrationConfigurations.map(config => {
                if (config.id === integrationId) {
                    // If changing to "Specified Datasets" and no incremental data exists, add one
                    if (scope === 'specifiedDatasets' && config.incrementalData.length === 0) {
                        const newIncrementalData = {
                            id: Date.now(),
                            datasetName: '',
                            identifier: '',
                            startingIndexCheckbox: false,
                            startingIndexType: 'incremental data identifier',
                            startingIndexValue: '',
                            startingIndexQuery: '',
                            exactMatch: true
                        };
                        return { ...config, datasetScope: scope, incrementalData: [newIncrementalData] };
                    }
                    return { ...config, datasetScope: scope };
                }
                return config;
            })
        });
    }

    handleSchemaSelectForConfig = (integrationId, selectedOption) => {
        const __cfg = this.state.integrationConfigurations.find(c => c.id === integrationId);
        if (__cfg && __cfg.isExisting) return;
        this.setState(prevState => {
            // Clear schema-level validation error when user picks a new schema
            const updatedErrors = { ...prevState.integrationValidationErrors };
            if (updatedErrors[integrationId]) {
                const { schema: _removed, ...rest } = updatedErrors[integrationId];
                if (Object.keys(rest).length === 0) {
                    delete updatedErrors[integrationId];
                } else {
                    updatedErrors[integrationId] = rest;
                }
            }
            return {
                integrationConfigurations: prevState.integrationConfigurations.map(config =>
                    config.id === integrationId
                        ? { ...config, schema: selectedOption?.value || null }
                        : config
                ),
                integrationValidationErrors: updatedErrors
            };
        });
    }

    handleIntegrationConfigFieldChange = (integrationId, fieldName, value) => {
        const __cfg = this.state.integrationConfigurations.find(c => c.id === integrationId);
        if (__cfg && __cfg.isExisting) return;
        this.setState({
            integrationConfigurations: this.state.integrationConfigurations.map(config =>
                config.id === integrationId
                    ? { ...config, [fieldName]: value }
                    : config
            )
        });
    }

    normalizeUniqueValue = (value) => String(value || '').trim().toLowerCase();

    getEditEntityId = () => this.state.ex_edit_integration_details?.integration_id
        || this.state.ex_edit_integration_details?.datasource_id;

    getIntegrationEntityId = (integration) => integration?.integration_id || integration?.datasource_id;

    getIntegrationConfigsFromPayload = (integration) => {
        const payload = integration?.datasource_config || integration || {};
        const configs = payload.integration_config || payload.integration_names || [];
        return Array.isArray(configs) ? configs : (configs ? [configs] : []);
    }

    isExistingIntegrationBeingEdited = (integration) => {
        const editId = this.getEditEntityId();
        const integId = this.getIntegrationEntityId(integration);
        return Boolean(editId && integId && String(integId) === String(editId));
    }

    getSchemasWithAllDatasetsIntegration = (currentConfigId = null) => {
        const existingIntegrations = Array.isArray(this.props.existingIntegrations)
            ? this.props.existingIntegrations : [];
        const schemas = new Set();
        existingIntegrations.forEach(integration => {
            if (this.isExistingIntegrationBeingEdited(integration)) return;
            this.getIntegrationConfigsFromPayload(integration).forEach(cfg => {
                if (cfg.datasetToBeProcessed === 'allDataset') {
                    const schemaName = cfg.schema_name || cfg.schema;
                    if (schemaName) schemas.add(schemaName);
                }
            });
        });
        this.state.integrationConfigurations.forEach(config => {
            if (currentConfigId !== null && config.id === currentConfigId) return;
            if (config.datasetScope === 'allDatasets' && config.schema) {
                schemas.add(config.schema);
            }
        });
        return schemas;
    }

    schemaHasSpecifiedDatasetsIntegration = (schemaName, currentConfigId = null) => {
        if (!schemaName) return false;
        const existingIntegrations = Array.isArray(this.props.existingIntegrations)
            ? this.props.existingIntegrations : [];

        const hasExistingSpecified = existingIntegrations.some(integration => {
            if (this.isExistingIntegrationBeingEdited(integration)) return false;
            return this.getIntegrationConfigsFromPayload(integration).some(cfg => {
                const cfgSchema = cfg.schema_name || cfg.schema;
                return cfgSchema === schemaName && cfg.datasetToBeProcessed !== 'allDataset' && (cfg.table_names || []).length > 0;
            });
        });
        if (hasExistingSpecified) return true;

        return this.state.integrationConfigurations.some(config => {
            if (currentConfigId !== null && config.id === currentConfigId) return false;
            return config.schema === schemaName &&
                config.datasetScope === 'specifiedDatasets' &&
                (config.incrementalData || []).some(item => (item.datasetName || '').trim());
        });
    }

    getUsedDatasetsForSchema = (schemaName, currentConfigId = null, currentRowId = null) => {
        if (!schemaName) return [];
        const existingIntegrations = Array.isArray(this.props.existingIntegrations)
            ? this.props.existingIntegrations : [];
        const used = new Set();
        existingIntegrations.forEach(integration => {
            if (this.isExistingIntegrationBeingEdited(integration)) return;
            this.getIntegrationConfigsFromPayload(integration).forEach(cfg => {
                const cfgSchema = cfg.schema_name || cfg.schema;
                if (cfgSchema !== schemaName) return;
                (cfg.table_names || []).forEach(t => {
                    if (t.table) used.add(this.normalizeUniqueValue(t.table));
                });
            });
        });
        this.state.integrationConfigurations.forEach(config => {
            if (config.schema !== schemaName) return;
            if (config.id === currentConfigId && currentRowId === null) return;
            (config.incrementalData || []).forEach(item => {
                if (config.id === currentConfigId && item.id === currentRowId) return;
                if (item.datasetName) used.add(this.normalizeUniqueValue(item.datasetName));
            });
        });
        return Array.from(used);
    }

    isDatasetAssignedToAnotherIntegration = (config, item) => {
        const datasetName = (item?.datasetName || '').trim();
        if (!datasetName) return false;
        return this.getUsedDatasetsForSchema(config.schema, config.id, item.id)
            .includes(this.normalizeUniqueValue(datasetName));
    }

    getDatasetsForPartitionOptions = (config, currentPartition = null) => {
        const usedDatasets = new Set(this.getUsedDatasetsForSchema(config.schema, config.id, null));
        const currentDataset = this.normalizeUniqueValue(currentPartition?.datasetName);
        return (config.incrementalData || [])
            .map(item => item.datasetName)
            .filter(Boolean)
            .filter(datasetName => {
                const normalized = this.normalizeUniqueValue(datasetName);
                return normalized === currentDataset || !usedDatasets.has(normalized);
            })
            .map(ds => ({ label: ds, value: ds }));
    }

    // Validates dataset assignment rules for schema/integration combinations.
    validateSchemaDatasetUniqueness = () => {
        const { integrationConfigurations } = this.state;
        const isAzureBlob = this.state.formType === 'azure_blob'|| this.state.formType ==='s3' || this.state.formType === 'azure_data_lake_gen2';
        // Build a structured error map: { [configId]: { schema?: string, datasets?: { [itemId]: string } } }
        const errorMap = {};
        let hasErrors = false;

        integrationConfigurations.forEach((config) => {
            const schema = config.schema;
            if (!schema) return;

            const configErrors = {};

            if (isAzureBlob) {
                // For Azure Blob, only flag if two integrations share identical bucket + sub_path
                const duplicate = integrationConfigurations.find(
                    c => c.id !== config.id && c.schema === schema && (c.sub_path || '') === (config.sub_path || '')
                );
                if (duplicate) {
                    configErrors.schema = `Bucket "${schema}" with subpath "${config.sub_path || '(none)'}" is already used by another integration.`;
                    hasErrors = true;
                }
            } else {
                // Rule: schema already has an All Datasets integration — no more allowed
                if (this.getSchemasWithAllDatasetsIntegration(config.id).has(schema)) {
                    configErrors.schema = `Schema "${schema}" already has an All Datasets integration. No additional integrations can be created for this schema.`;
                    hasErrors = true;
                } else if (config.datasetScope === 'allDatasets' && this.schemaHasSpecifiedDatasetsIntegration(schema, config.id)) {
                    configErrors.schema = `Schema "${schema}" already has Specified Datasets integrations. All Datasets cannot be combined with Specified Datasets.`;
                    hasErrors = true;
                } else if (config.datasetScope !== 'allDatasets') {
                    const datasetErrors = {};
                    (config.incrementalData || []).forEach((item) => {
                        const dsName = (item.datasetName || '').trim();
                        if (dsName && this.isDatasetAssignedToAnotherIntegration(config, item)) {
                            datasetErrors[item.id] = `Dataset Name "${dsName}" is already associated with another integration in schema "${schema}".`;
                            hasErrors = true;
                        }
                    });
                    if (Object.keys(datasetErrors).length > 0) {
                        configErrors.datasets = datasetErrors;
                    }
                }
            }

            if (Object.keys(configErrors).length > 0) {
                errorMap[config.id] = configErrors;
            }
        });

        this.setState({ integrationValidationErrors: errorMap }, () => {
            if (hasErrors) {
                setTimeout(() => {
                    const firstError = document.querySelector('.error-text');
                    if (firstError) {
                        firstError.scrollIntoView({
                            behavior: "smooth",
                            block: "center"
                        });
                    }
                }, 100);
            }
        });
        return hasErrors;
    }

    isCreateDatasourceEnabled = () => {
        const { configurationMode, selected, specificSelect, selectedSchemas, testConnectionSuccess, isCreatingDatasource, showSchemaConfigInfo, showTestConnectionInfo, integrationConfigurations } = this.state;

        if(testConnectionSuccess && (this.state.formType === 'neo4j' || this.state.formType === 'amazon_neptune' || this.state.formType === 'azure_cosmos_gremlin' || this.state.formType === 'spanner_graph')){
            return true
        }
        // Must have successful test connection and not be in the process of creating
        if (!testConnectionSuccess || isCreatingDatasource) {
            return false;
        }

        if(showSchemaConfigInfo===null || showTestConnectionInfo===false){
            return false;
        }
        
        // Only enable if autoconfig is selected OR manual config with schema selection completed
        if (configurationMode === 'autoconfig') {
            // All Schemas mode: enable if selected
            if ((selected && configurationMode === 'autoconfig') || configurationMode === 'manual') {
                return true;
            }
            // Specified Schemas mode: enable only if at least one schema is selected
            if (
    (specificSelect && configurationMode === 'autoconfig' && selectedSchemas.length > 0) ||
    (specificSelect && configurationMode === 'manual' && selectedSchemas.length > 0)
) {
                return true;
            }
        } else if (configurationMode === 'manual' && integrationConfigurations.length > 0 && this.isContinueSchemaSelectionEnabled() && showSchemaConfigInfo && showTestConnectionInfo) {
            if (!this.hasIntegrationForEveryRequiredSchema()) {
                return false;
            }

            // Validate all integration configurations
            const isConfigsValid = integrationConfigurations.every(config => {
                const isBaseValid = config.integrationName && config.integrationName.trim() !== '' && 
                                    config.schema && config.schema.trim() !== '';
                if (!isBaseValid) return false;

                // Validate incrementalData
                if (config.incrementalData && config.incrementalData.length > 0) {
                    const isIncrementalValid = config.incrementalData.every(item => {
                        if (!item.datasetName || item.datasetName.trim() === '') return false;
                        if (item.startingIndexCheckbox) {
                            if (item.startingIndexType === 'incremental data identifier' && (!item.startingIndexValue || item.startingIndexValue.trim() === '')) return false;
                            if (item.startingIndexType === 'custom query' && (!item.startingIndexQuery || item.startingIndexQuery.trim() === '')) return false;
                        }
                        return true;
                    });
                    if (!isIncrementalValid) return false;
                }

                // Validate partitions
                if (config.partitions && config.partitions.length > 0) {
                    const isPartitionsValid = config.partitions.every(partition => {
                        if (!partition.datasetName || partition.datasetName.trim() === '') return false;
                        if (!partition.partitionName || partition.partitionName.trim() === '') return false;
                        if (partition.partitionBy === 'Custom Query') {
                            if (!partition.customQuery || partition.customQuery.trim() === '') return false;
                        } else {
                            // Column mode (default)
                            if (!partition.partitionIdentifier || partition.partitionIdentifier.trim() === '') return false;
                        }
                        return true;
                    });
                    if (!isPartitionsValid) return false;
                }

                return true;
            });
            return isConfigsValid;
        }
        return false;
    }

    isContinueSchemaSelectionEnabled = () => {
        const { configurationMode, testConnectionFormData, testConnectionSuccess, schemaModeSelection, selectedSchemas } = this.state;
        
        // Only enable for manual configuration mode
        if (configurationMode !== 'manual') {
            return false;
        }

        if(schemaModeSelection===null){
            return false;
        }
        
        // Must have form data (form submitted) and successful test connection
        if (!testConnectionFormData || !testConnectionSuccess) {
            return false;
        }
        
        // Must have schema mode selected
        if (!schemaModeSelection) {
            return false;
        }

        // Check if schemas are selected when in specified schemas mode
        if (schemaModeSelection === 'specificSchemas' && selectedSchemas.length === 0) {
            return false;
        }
        
        return true;
    }

    handleAddPartitionToConfig = (integrationId) => {
        const __cfg = this.state.integrationConfigurations.find(c => c.id === integrationId);
        if (__cfg && __cfg.isExisting) return;
        // Find the configuration
        const config = this.state.integrationConfigurations.find(c => c.id === integrationId);
        
        if (!config) return;
        
        // Validate existing partition rows
        if (config.partitions.length > 0) {
            const lastPartition = config.partitions[config.partitions.length - 1];
            let hasError = false;
            let errorMessage = '';
            
            // Check required fields
            if (!lastPartition.datasetName || lastPartition.datasetName.trim() === '') {
                hasError = true;
                errorMessage = 'Please fill Dataset Name in the previous partition row';
            } else if (!lastPartition.partitionName || lastPartition.partitionName.trim() === '') {
                hasError = true;
                errorMessage = 'Please fill Partition Name in the previous partition row';
            } else if (lastPartition.partitionBy === 'Column' || lastPartition.partitionBy === undefined) {
                // If partition by Column, check partition identifier
                if (!lastPartition.partitionIdentifier || lastPartition.partitionIdentifier.trim() === '') {
                    hasError = true;
                    errorMessage = 'Please fill Partition Identifier in the previous partition row';
                }
            } else if (lastPartition.partitionBy === 'Custom Query') {
                // If partition by Custom Query, check custom query
                if (!lastPartition.customQuery || lastPartition.customQuery.trim() === '') {
                    hasError = true;
                    errorMessage = 'Please fill Custom Query in the previous partition row';
                }
            }
            
            if (hasError) {
                this.props.showToast && this.props.showToast('error', errorMessage);
                return;
            }
        }
        
        const newPartition = {
            id: Date.now(),
            datasetName: '',
            partitionName: '',
            partitionBy: 'Column',
            partitionIdentifier: '',
            customQuery: '',
            isNew: true
        };
        
        this.setState({
            integrationConfigurations: this.state.integrationConfigurations.map(config =>
                config.id === integrationId
                    ? { ...config, partitions: [...config.partitions, newPartition] }
                    : config
            )
        });
    }

    handleRemovePartition = (integrationId, partitionId) => {
        const __cfg = this.state.integrationConfigurations.find(c => c.id === integrationId);
        if (__cfg && __cfg.isExisting) return;
        this.setState({
            integrationConfigurations: this.state.integrationConfigurations.map(config =>
                config.id === integrationId
                    ? { ...config, partitions: config.partitions.filter(partition => partition.id !== partitionId) }
                    : config
            )
        });
    }

    handlePartitionByChange = (integrationId, partitionId, value) => {
        const __cfg = this.state.integrationConfigurations.find(c => c.id === integrationId);
        if (__cfg && __cfg.isExisting) return;
        this.setState({
            integrationConfigurations: this.state.integrationConfigurations.map(config =>
                config.id === integrationId
                    ? {
                        ...config,
                        partitions: config.partitions.map(partition =>
                            partition.id === partitionId
                                ? { ...partition, partitionBy: value }
                                : partition
                        )
                    }
                    : config
            )
        });
    }

    handlePartitionFieldChange = (integrationId, partitionId, fieldName, value) => {
        const __cfg = this.state.integrationConfigurations.find(c => c.id === integrationId);
        if (__cfg && __cfg.isExisting) return;
        this.setState({
            integrationConfigurations: this.state.integrationConfigurations.map(config =>
                config.id === integrationId
                    ? {
                        ...config,
                        partitions: config.partitions.map(partition =>
                            partition.id === partitionId
                                ? { ...partition, [fieldName]: value }
                                : partition
                        )
                    }
                    : config
            )
        });
    }

    handleCreateDatasource = async () => {
        const { testConnectionFormData, schemaModeSelection, configurationMode, selectedSchemas, integrationConfigurations } = this.state;
        if (this.state.formType === 'microsoft_purview' || this.state.formType === 'microsoft purview' || this.state.formType === 'unity_catalog' || this.state.formType === 'azure_microsoft_fabric' || this.state.formType === 'neo4j' || this.state.formType === 'amazon_neptune' || this.state.formType === 'azure_cosmos_gremlin' || this.state.formType === 'spanner_graph' || this.state.formType === 'pinecone' || this.state.formType === 'elasticsearch' || this.state.formType === 'postgres_vector') {
            this.props.showToast && this.props.showToast("alert-success", "Datasource created successfully", null, null, false);
            this.props.setPage(false)
            window.dispatchEvent(new Event('save-completed'));
            return;
        }


        if (!testConnectionFormData) {
            this.props.showToast && this.props.showToast('error', 'Please test the connection first');
            window.dispatchEvent(new CustomEvent('save-completed', {
                detail: { errorMessage: 'Please test the connection first' }
            }));
            return;
        }

        const isAzureBlob = this.state.formType === 'azure_blob'|| this.state.formType ==='s3' || this.state.formType === 'azure_data_lake_gen2';

        // Validate manual configuration mode requirements
        if (configurationMode === 'manual') {
            if (integrationConfigurations.length === 0) {
                this.props.showToast && this.props.showToast('error', 'Please add at least one integration configuration');
                window.dispatchEvent(new CustomEvent('save-completed', {
                    detail: { errorMessage: 'Please add at least one integration configuration' }
                }));
                return;
            }

            // Schemas without a corresponding integration are silently excluded from the
            // saved schema_names list (the effective list is derived from integrationConfigurations
            // further below), so no blocking validation is needed here.

            // Check each integration configuration
            let hasFormErrors = false;
            const formErrors = { ...this.state.integrationValidationErrors };

            for (let i = 0; i < integrationConfigurations.length; i++) {
                const config = integrationConfigurations[i];

                if (formErrors[config.id]) {
                    delete formErrors[config.id].incrementalDataRequired;
                }

                if (isAzureBlob) {
                    if (!config.schema) {
                        this.props.showToast && this.props.showToast('error', `Integration configuration ${i + 1}: Bucket is required`);
                        return;
                    }
                    continue;
                }
                
                // If dataset scope is "Specified Datasets", incremental data is mandatory
                if (config.datasetScope === 'specifiedDatasets' && config.incrementalData.length === 0) {
                    formErrors[config.id] = {
                        ...(formErrors[config.id] || {}),
                        incrementalDataRequired: 'Add Incremental Data Identification is required for Specified Datasets'
                    };
                    hasFormErrors = true;
                }
                
                // Validate all incremental data rows have required fields
                for (let j = 0; j < config.incrementalData.length; j++) {
                    const incrementalItem = config.incrementalData[j];
                    if (!incrementalItem.datasetName || incrementalItem.datasetName.trim() === '') {
                        hasFormErrors = true;
                    }
                    if (config.datasetScope !== 'specifiedDatasets' && (!incrementalItem.identifier || incrementalItem.identifier.trim() === '')) {
                        hasFormErrors = true;
                    }
                    if (incrementalItem.startingIndexCheckbox) {
                        if (incrementalItem.startingIndexType === 'incremental data identifier' && (!incrementalItem.startingIndexValue || incrementalItem.startingIndexValue.trim() === '')) {
                            hasFormErrors = true;
                        }
                        if (incrementalItem.startingIndexType === 'custom query' && (!incrementalItem.startingIndexQuery || incrementalItem.startingIndexQuery.trim() === '')) {
                            hasFormErrors = true;
                        }
                    }
                }

                // Validate partition fields
                if (config.partitions && config.partitions.length > 0) {
                    for (let k = 0; k < config.partitions.length; k++) {
                        const partition = config.partitions[k];
                        if (!partition.datasetName || partition.datasetName.trim() === '') {
                            hasFormErrors = true;
                        }
                        if (!partition.partitionName || partition.partitionName.trim() === '') {
                            hasFormErrors = true;
                        }
                        if (partition.partitionBy === 'Column' || partition.partitionBy === undefined) {
                            if (!partition.partitionIdentifier || partition.partitionIdentifier.trim() === '') {
                                hasFormErrors = true;
                            }
                        } else if (partition.partitionBy === 'Custom Query') {
                            if (!partition.customQuery || partition.customQuery.trim() === '') {
                                hasFormErrors = true;
                            }
                        }
                    }
                }
            }

            if (hasFormErrors) {
                this.setState({ integrationValidationErrors: formErrors }, () => {
                    setTimeout(() => {
                        const firstError = document.querySelector('.error-text');
                        if (firstError) {
                            firstError.scrollIntoView({
                                behavior: "smooth",
                                block: "center"
                            });
                        }
                    }, 100);
                });
                window.dispatchEvent(new Event('save-completed'));
                return;
            }

            // Validate uniqueness of dataset names, identifiers, and partition fields
            const hasUniquenessErrors = this.validateSchemaDatasetUniqueness();
            if (hasUniquenessErrors) {
                window.dispatchEvent(new Event('save-completed'));
                return;
            }
        }

        // Determine schemaToBeProcessed based on schema mode selection
        let schemaToBeProcessed = 'allSchema';
        let schemaList = [];
        
        if (schemaModeSelection === 'specificSchemas') {
            if (selectedSchemas.length === 0) {
                this.props.showToast && this.props.showToast('error', 'Please select at least one schema');
                window.dispatchEvent(new Event('save-completed'));
                return;
            }
            schemaToBeProcessed = 'specifiedSchema';
            schemaList = selectedSchemas;
        }

        // Determine config_type based on configuration mode
        const configType = configurationMode === 'autoconfig' ? 'autoConfig' : 'manualConfig';
        const isEditingDatasource = this.state.datasource_id > 0 && this.state.ex_edit_integration_details;
        const selectedSchemaSet = new Set(selectedSchemas);
        const integrationConfigurationsForPayload = configType === 'manualConfig' && isEditingDatasource && schemaToBeProcessed === 'specifiedSchema'
            ? integrationConfigurations.filter(config => {
                const schema = this.getIntegrationSchemaName(config);
                return schema && selectedSchemaSet.has(schema);
            })
            : integrationConfigurations;
        const effectiveManualSchemas = configType === 'manualConfig' && isEditingDatasource
            ? [...new Set(
                integrationConfigurationsForPayload
                    .map(config => this.getIntegrationSchemaName(config))
                    .filter(Boolean)
              )]
            : schemaList;

        // Build datasource_config based on configuration mode
        let datasourceConfig = {
            ...this.buildDatasourceConfig(testConnectionFormData, this.state.formType),
            error_storage: "",
            default_error_storage: true
        };

        if (isAzureBlob && configType === 'autoConfig') {
            datasourceConfig.auto_config_type = schemaToBeProcessed === 'specifiedSchema'
                ? 'specifiedBucket'
                : 'allBuckets';
        } else if (!isAzureBlob) {
            datasourceConfig.schemaToBeProcessed = schemaToBeProcessed;
        }

        // Add schema_names for specified schemas
        if (schemaToBeProcessed === 'specifiedSchema') {
            if (isAzureBlob) {
                datasourceConfig.buckets = schemaList;
            } else {
                datasourceConfig.schema_names = schemaList;
            }

            // Calculate added and removed schemas for edit mode
            if (this.state.datasource_id > 0 && this.state.ex_edit_integration_details) {
                const originalDetails = this.state.ex_edit_integration_details;
                let originalSchemas = [];
                if (originalDetails.datasource_config?.schema_names || originalDetails.datasource_config?.buckets) {
                    originalSchemas = originalDetails.datasource_config.schema_names || originalDetails.datasource_config.buckets;
                } else if (originalDetails.datasource_config?.integration_names) {
                    originalSchemas = [...new Set(
                        originalDetails.datasource_config.integration_names
                            .map(config => config.bucket || config.schema_name || config.schema)
                            .filter(schema => schema)
                    )];
                } else if (originalDetails.datasource_config?.schema) {
                    originalSchemas = [originalDetails.datasource_config.schema];
                }

                // Compare the schemas selected in the dialog, rather than the effective
                // manual schemas. The latter is derived from integrationConfigurations,
                // which omits a newly selected schema when it has no integration and
                // would prevent the validation below from ever seeing it.
                const addedSchemas = schemaList.filter(s => !originalSchemas.includes(s));
                const removedSchemas = originalSchemas.filter(s => !effectiveManualSchemas.includes(s));

                // If any newly added schema lacks an integration, block the save
                if (configType === 'manualConfig') {
                    for (const newSchema of addedSchemas) {
                        const hasIntegration = integrationConfigurations.some(
                            config => this.getIntegrationSchemaName(config) === newSchema
                        );
                        if (!hasIntegration) {
                            window.dispatchEvent(new CustomEvent('save-completed', { 
                                detail: { errorMessage: `Schema ${newSchema} doesn't have any integrations` } 
                            }));
                            return;
                        }
                    }
                }

                if (addedSchemas.length > 0) {
                    if (this.state.formType === 'azure_blob' || this.state.formType === 's3' || this.state.formType === 'azure_data_lake_gen2') {
                        datasourceConfig.added_buckets = addedSchemas;
                    } else {
                        datasourceConfig.added_schemas = addedSchemas;
                    }
                }
                if (removedSchemas.length > 0) {
                    if (this.state.formType === 'azure_blob' || this.state.formType === 's3' || this.state.formType === 'azure_data_lake_gen2') {
                        datasourceConfig.removed_buckets = removedSchemas;
                    } else {
                        datasourceConfig.removed_schemas = removedSchemas;
                    }
                }
            }
        } else if (schemaToBeProcessed === 'allSchema') {
            datasourceConfig.schema_names = this.state.testConnectionResponse?.schemas || [];
        }

        // Add integration_names for manual config
        if (configType === 'manualConfig') {
        if (isAzureBlob) {
            // console.log("testConnectionformdata",testConnectionFormData);

            // For edit mode: derive effective buckets from remaining integrationConfigurations
            // so that any integration removed via the UI causes its bucket to be excluded.
            const effectiveBuckets = this.state.datasource_id > 0
                ? [...new Set(
                    integrationConfigurations
                        .map(config => config.schema || config.bucket)
                        .filter(Boolean)
                  )]
                : (selectedSchemas.length > 0 ? selectedSchemas : undefined);

            datasourceConfig = {
                storage_name: testConnectionFormData.storage_name || "",
                buckets: effectiveBuckets,
                integration_names: integrationConfigurations.map((config, index) => ({
                    integration_name:
                        config.integrationName ||
                        `integration${integrationConfigurations.length - index}`,
                    storage_name: testConnectionFormData.storage_name || "",
                    bucket: config.schema || "",
                    sub_path: config.sub_path || config.subPath || "",
                    filetype: testConnectionFormData.fileType || "",
                    refresh_type: testConnectionFormData.refreshType || "file_replace",

                    version_format:
                        testConnectionFormData.versionFormat === "custom"
                            ? (testConnectionFormData.versionFormatRegex || "none")
                            : (testConnectionFormData.versionFormat || "none"),

                    version_occurence:
                        testConnectionFormData.versionOccurence || 0,
                })),
                error_storage: "",
                default_error_storage: true,
            };
            } else {
                const isSchemaNameType = ['snowflake', 'postgresql', 'redshift'].includes(this.state.formType);
                datasourceConfig.integration_names = integrationConfigurationsForPayload.map((config, index) => {
                // Build table_names (incremental data) array
                const tableNames = config.incrementalData.map(item => ({
                    table: item.datasetName || "",
                    created_time: item.identifier || "",
                    start_with: item.startingIndexCheckbox && item.startingIndexType === 'incremental data identifier' ? item.startingIndexValue : "",
                    match_exact: item.exactMatch ? "match_exact" : "",
                    start_with_query: item.startingIndexCheckbox && item.startingIndexType === 'custom query' ? item.startingIndexQuery : "",
                    start_index_check_box: item.startingIndexCheckbox ? "true" : "false",
                    start_index_type: item.startingIndexType || "incremental data identifier",
                    partition_type: "column"
                }));

                // Build partitions array
                const partitions = config.partitions.map(partition => {
                    const partitionObj = {
                        dataset_name: partition.datasetName || "",
                        partition_type: partition.partitionBy === 'Custom Query' ? "custom_query" : "column",
                        partition_name: partition.partitionName || ""
                    };

                    if (partition.partitionBy === 'Column' || partition.partitionBy === undefined) {
                        partitionObj.column_name = partition.partitionIdentifier || "";
                    } else if (partition.partitionBy === 'Custom Query') {
                        partitionObj.custom_query = partition.customQuery || "";
                    }

                    return partitionObj;
                });

                return {
                  ...this.buildDatasourceConfig(testConnectionFormData, this.state.formType),
                  integration_name: config.integrationName || `integration${integrationConfigurations.length - index}`,
                  // schema: config.schema || "",
                  [isSchemaNameType ? 'schema_name' : 'schema']:config.schema,
                  //postgres, snowflake, redshift - schema_name
                  //others - schema
                    partitions: partitions,
                    table_names: tableNames,
                    datasetToBeProcessed: config.datasetScope === 'allDatasets' ? 'allDataset' : 'specifiedDataset',
                    datasets_added: config.incrementalData
                        .filter(item => item.isNew && !item.exactMatch && item.datasetName)
                        .map(item => item.datasetName.trim())
                        .filter(Boolean)
                };
                });

                // For edit mode: derive effective schema_names from the remaining integrationConfigurations
                // so any integration removed via the UI causes its schema to be excluded from the payload.
                if (isEditingDatasource) {
                    const effectiveSchemaNames = effectiveManualSchemas;
                    datasourceConfig.schema_names = effectiveSchemaNames;
                    datasourceConfig.schemaToBeProcessed = 'specifiedSchema';
                }
            }

            // Calculate added and removed integrations for edit mode
            if (this.state.datasource_id > 0 && this.state.ex_edit_integration_details) {
                const originalDetails = this.state.ex_edit_integration_details;

                let originalIntegrationObjs = [];
                if (originalDetails.datasource_config?.integration_names) {
                    originalIntegrationObjs = originalDetails.datasource_config.integration_names;
                }

                let newIntegrationObjs = [];
                if (datasourceConfig.integration_names) {
                    newIntegrationObjs = datasourceConfig.integration_names;
                }

                const originalIntegrationNames = originalIntegrationObjs.map(i => i.integration_name).filter(Boolean);
                const newIntegrationNames = newIntegrationObjs.map(i => i.integration_name).filter(Boolean);

                const addedIntegrations = newIntegrationNames.filter(name => !originalIntegrationNames.includes(name));
                const removedIntegrations = originalIntegrationNames.filter(name => !newIntegrationNames.includes(name));
                
                if (addedIntegrations.length > 0) {
                    datasourceConfig.added_integrations = addedIntegrations;
                }
                if (removedIntegrations.length > 0) {
                    datasourceConfig.removed_integrations = removedIntegrations;
                }

                // Derive removed_schemas from removed integrations so the backend
                // removes those schemas from the datasource schema_names list.
                if (!isAzureBlob) {
                    const removedIntegrationSchemas = originalIntegrationObjs
                        .filter(i => removedIntegrations.includes(i.integration_name))
                        .map(i => i.schema_name || i.schema)
                        .filter(Boolean);
                    const uniqueRemovedSchemas = [...new Set(removedIntegrationSchemas)]
                        .filter(s => !(datasourceConfig.schema_names || []).includes(s));
                    if (uniqueRemovedSchemas.length > 0) {
                        datasourceConfig.removed_schemas = [...new Set([
                            ...(datasourceConfig.removed_schemas || []),
                            ...uniqueRemovedSchemas
                        ])];
                    }
                } else {
                    const removedIntegrationBuckets = originalIntegrationObjs
                        .filter(i => removedIntegrations.includes(i.integration_name))
                        .map(i => i.bucket)
                        .filter(Boolean);
                    const uniqueRemovedBuckets = [...new Set(removedIntegrationBuckets)]
                        .filter(b => !(datasourceConfig.buckets || []).includes(b));
                    if (uniqueRemovedBuckets.length > 0) {
                        datasourceConfig.removed_buckets = [
                            ...(datasourceConfig.removed_buckets || []),
                            ...uniqueRemovedBuckets
                        ];
                    }
                }
            }
        }

        // Build the request payload
        const requestPayload = {
            datasource_name: testConnectionFormData.datasource_name || testConnectionFormData.integration_name || "New Datasource",
            tenant_id: localStorage.getItem('team_id'), // You may want to get this from props or auth
            env_id: this.props.env_id || 69,
            datasource_type: this.mapDatasourceType(this.state.formType),
            data_store_type: this.getDatasourceStoreType(this.state.formType),
            config_type: configType,
            datasource_config: datasourceConfig,
            auth_config: await this.buildAuthConfig(testConnectionFormData, this.state.formType)
        };

      //  alert(JSON.stringify(requestPayload));
        // console.log('Creating datasource with payload:', requestPayload);
        // return;
        // Set creating state
        this.setState({ isCreatingDatasource: true, createDatasourceError: null });

        // console.log("*****************")
        // console.log(this.state.datasource_id)
        // console.log(requestPayload);
        // console.log("*****************")
        // return;
        let saveErrorMessage = '';
        try {
            // Call the createDataSource API
             let response;
            if(this.state.datasource_id > 0){
                requestPayload.datasource_id = this.state.datasource_id;
                response  = await updateDataSource(requestPayload);
            }else {
                response = await createDataSource(requestPayload);
            }
            
            if (response?.code === 200 ) {
                // console.log('Datasource created successfully:', response);
                // When editing (datasource_id > 0), reload data so that removed integrations
                // are immediately reflected in the Configured Integrations and DataSources tables.
                const isEdit = this.state.datasource_id > 0;
                const toastMessage = isEdit ? "Datasource edited successfully" : "Datasource created successfully";
                this.props.showToast && this.props.showToast("alert-success", toastMessage, null, null, isEdit);
                
                // Refresh the environment data if callback exists
                //if (this.props.setEnvData) {
                    this.props.setEnvData(this.props.env_id);
                //}
                // Close modal if callback exists
                if(this.state.datasource_id > 0){
                    this.props.closeModal()
                }else {
                    this.props.setPage(false)
                }
                  
            } else if (response?.code === 401) {
                const isInvalidDataset = ['invalid_dataset', 'dataset_invalid'].includes(response?.response?.key);
                const integrationConfigurations = this.state.integrationConfigurations || [];
                const failedIntegrations = response?.response;
                const failedConfig = isInvalidDataset && failedIntegrations && typeof failedIntegrations === 'object'
                    ? integrationConfigurations.find(config => (
                        (config.integrationName || config.integration_name) && Object.prototype.hasOwnProperty.call(failedIntegrations, config.integrationName || config.integration_name)
                    ))
                    : null;
                const failedSchema = failedConfig?.schema || failedConfig?.schema_name || failedConfig?.bucket;
                const errorMessage = isInvalidDataset && failedSchema
                    ? `Specified dataset doesn't exist in "${failedSchema}"`
                    : response?.message || response?.status_message || response?.response?.message || response?.response?.status_message || 'Specified dataset already exists in datasource';
                const getDatasetValidationMessage = (config) => (
                    isInvalidDataset && (config?.schema || config?.schema_name || config?.bucket)
                        ? `Specified dataset doesn't exist in "${config.schema || config.schema_name || config.bucket}"`
                        : errorMessage
                );
                saveErrorMessage = errorMessage;
                const formErrors = { ...this.state.integrationValidationErrors };
                let errorMapped = false;

                if (failedIntegrations && typeof failedIntegrations === 'object' && Object.keys(failedIntegrations).length > 0) {
                    for (let i = 0; i < integrationConfigurations.length; i++) {
                        const config = integrationConfigurations[i];
                        const integrationName = config.integrationName;
                        if (integrationName && failedIntegrations[integrationName] && config.incrementalData) {
                            const failedDatasets = failedIntegrations[integrationName];
                            for (const failedDataset of failedDatasets) {
                                let targetItem = config.incrementalData.find(item => item.datasetName && item.datasetName.toLowerCase() === failedDataset.toLowerCase());
                                if (!targetItem) {
                                    targetItem = config.incrementalData.find(item => item.isNew) || config.incrementalData[config.incrementalData.length - 1];
                                }
                                if (targetItem) {
                                    formErrors[config.id] = {
                                        ...(formErrors[config.id] || {}),
                                        datasets: {
                                            ...(formErrors[config.id]?.datasets || {}),
                                            [targetItem.id]: getDatasetValidationMessage(config)
                                        }
                                    };
                                    errorMapped = true;
                                }
                            }
                        }
                    }
                }
                
                if (!errorMapped) {
                    for (let i = 0; i < integrationConfigurations.length; i++) {
                        const config = integrationConfigurations[i];
                        if (config && config.incrementalData && config.incrementalData.length > 0) {
                            let targetItem = config.incrementalData.find(item => item.datasetName && response?.message && response.message.includes(item.datasetName));
                            if (!targetItem) {
                                targetItem = config.incrementalData.find(item => item.isNew) || config.incrementalData[config.incrementalData.length - 1];
                            }
                            if (targetItem) {
                                formErrors[config.id] = {
                                    ...(formErrors[config.id] || {}),
                                    datasets: {
                                        ...(formErrors[config.id]?.datasets || {}),
                                        [targetItem.id]: getDatasetValidationMessage(config)
                                    }
                                };
                                errorMapped = true;
                            }
                        }
                    }
                }

                if (errorMapped) {
                    if (typeof this.state.staticValidationErrorReporter === 'function') {
                        this.state.staticValidationErrorReporter(formErrors);
                    }
                    this.setState({ integrationValidationErrors: formErrors, createDatasourceError: errorMessage }, () => {
                        setTimeout(() => {
                            const firstError = document.querySelector('.error-text');
                            if (firstError) {
                                firstError.scrollIntoView({
                                    behavior: 'smooth',
                                    block: 'center'
                                });
                            }
                        }, 100);
                    });
                } else {
                    this.setState({ createDatasourceError: errorMessage });
                    this.props.showToast && this.props.showToast('alert-danger', errorMessage, '', undefined, false);
                }
            } else {
                console.error('Failed to create datasource:', response);
                const errorMessage = response?.message || response?.status_message || response?.response?.message || response?.response?.status_message || 'Failed to create datasource';
                saveErrorMessage = errorMessage;
                    this.setState({ createDatasourceError: errorMessage });
               // this.props.showToast && this.props.showToast('error', errorMessage);
            }
        } catch (error) {
            console.error('Error creating datasource:', error);
            const errorMessage = error?.message || 'An error occurred while creating datasource';
            saveErrorMessage = errorMessage;
            this.setState({ createDatasourceError: errorMessage });
            this.props.showToast && this.props.showToast('error', errorMessage);
        } finally {
            // Reset creating state
            this.setState({ isCreatingDatasource: false });
            window.dispatchEvent(new CustomEvent('save-completed', { detail: { errorMessage: saveErrorMessage } }));
        }
    }

    fill_details() {
        // Removed defaultValues as we given default value directly inside the state variable
        if (this.props.ex_integration_details !== undefined) {
            let values = this.FillFormDetails(this.props.ex_integration_details);
            //eslint-disable-next-line
            this.state.formType = values[1];
            //eslint-disable-next-line
            this.state.formType_option = values[0];
        }
    }

    setForm = (selectedOption) => {
        this.setState ({
            formType: selectedOption["value"],
            formType_option: selectedOption,
            helpContentKey: selectedOption["value"]
        });
        this.closeTestConnection();
    }

    closeTestConnection() {
        this.setState ({
            testConnection: null
        });
    }

    setIntegrationData(data) {
        this.setState ({
            integration_data: data
        });
    }

    setData(integration_data,testConnection_data) {
       this.setState({testConnection:testConnection_data,
                      integration_data:integration_data,
       });
    }

    setSubmitButton(value) {
        this.setState({submit_button:value});
    }

    // Handler methods for manual configuration mode
   handleDatasetChange = (event) => {
    this.setState({ datasetToBeProcessed: event.target.value });
    };

    handleStoreDataIssuesChange = (e) => {
        this.setState({ storeDataIssues: e.target.checked });
    }

    addIntegrationConfiguration = () => {
        const newConfig = {
            id: Date.now(),
            integrationName: `Integration ${this.state.integrationConfigurations.length + 1}`,
            specificDatasets: [],
            incrementalData: [],
            partitions: []
        };
        this.setState({
            integrationConfigurations: [...this.state.integrationConfigurations, newConfig]
        });
    }

    removeIntegrationConfiguration = (id) => {
        if (this.state.integrationConfigurations.length <= 1) return;

        this.setState({
            integrationConfigurations: this.state.integrationConfigurations.filter(config => config.id !== id)
        });
    }

    addSpecificDataset = (configId) => {
        const configs = this.state.integrationConfigurations.map(config => {
            if (config.id === configId) {
                return {
                    ...config,
                    specificDatasets: [...config.specificDatasets, '']
                };
            }
            return config;
        });
        this.setState({ integrationConfigurations: configs });
    }

    removeSpecificDataset = (configId, index) => {
        const configs = this.state.integrationConfigurations.map(config => {
            if (config.id === configId) {
                return {
                    ...config,
                    specificDatasets: config.specificDatasets.filter((_, i) => i !== index)
                };
            }
            return config;
        });
        this.setState({ integrationConfigurations: configs });
    }

    changeDatasetText = (configId, index, value) => {
        const configs = this.state.integrationConfigurations.map(config => {
            if (config.id === configId) {
                const newDatasets = [...config.specificDatasets];
                newDatasets[index] = value;
                return {
                    ...config,
                    specificDatasets: newDatasets
                };
            }
            return config;
        });
        this.setState({ integrationConfigurations: configs });
    }

    addIncrementalData = (configId) => {
        const configs = this.state.integrationConfigurations.map(config => {
            if (config.id === configId) {
                return {
                    ...config,
                    incrementalData: [...config.incrementalData, { column: '', startDate: '', endDate: '' }]
                };
            }
            return config;
        });
        this.setState({ integrationConfigurations: configs });
    }

    removeIncrementalData = (configId, index) => {
        const configs = this.state.integrationConfigurations.map(config => {
            if (config.id === configId) {
                return {
                    ...config,
                    incrementalData: config.incrementalData.filter((_, i) => i !== index)
                };
            }
            return config;
        });
        this.setState({ integrationConfigurations: configs });
    }

    changeIncrementalColumn = (configId, index, value) => {
        const configs = this.state.integrationConfigurations.map(config => {
            if (config.id === configId) {
                const newIncremental = [...config.incrementalData];
                newIncremental[index] = { ...newIncremental[index], column: value };
                return {
                    ...config,
                    incrementalData: newIncremental
                };
            }
            return config;
        });
        this.setState({ integrationConfigurations: configs });
    }

    changeIncrementalStartDate = (configId, index, value) => {
        const configs = this.state.integrationConfigurations.map(config => {
            if (config.id === configId) {
                const newIncremental = [...config.incrementalData];
                newIncremental[index] = { ...newIncremental[index], startDate: value };
                return {
                    ...config,
                    incrementalData: newIncremental
                };
            }
            return config;
        });
        this.setState({ integrationConfigurations: configs });
    }

    changeIncrementalEndDate = (configId, index, value) => {
        const configs = this.state.integrationConfigurations.map(config => {
            if (config.id === configId) {
                const newIncremental = [...config.incrementalData];
                newIncremental[index] = { ...newIncremental[index], endDate: value };
                return {
                    ...config,
                    incrementalData: newIncremental
                };
            }
            return config;
        });
        this.setState({ integrationConfigurations: configs });
    }

    addPartition = (configId) => {
        const configs = this.state.integrationConfigurations.map(config => {
            if (config.id === configId) {
                return {
                    ...config,
                    partitions: [...config.partitions, { dataset: '', partitionName: '', partitionBy: '' }]
                };
            }
            return config;
        });
        this.setState({ integrationConfigurations: configs });
    }

    removePartition = (configId, index) => {
        const configs = this.state.integrationConfigurations.map(config => {
            if (config.id === configId) {
                return {
                    ...config,
                    partitions: config.partitions.filter((_, i) => i !== index)
                };
            }
            return config;
        });
        this.setState({ integrationConfigurations: configs });
    }

    changePartitionDataset = (configId, index, value) => {
        const configs = this.state.integrationConfigurations.map(config => {
            if (config.id === configId) {
                const newPartitions = [...config.partitions];
                newPartitions[index] = { ...newPartitions[index], dataset: value };
                return {
                    ...config,
                    partitions: newPartitions
                };
            }
            return config;
        });
        this.setState({ integrationConfigurations: configs });
    }

    changePartitionName = (configId, index, value) => {
        const configs = this.state.integrationConfigurations.map(config => {
            if (config.id === configId) {
                const newPartitions = [...config.partitions];
                newPartitions[index] = { ...newPartitions[index], partitionName: value };
                return {
                    ...config,
                    partitions: newPartitions
                };
            }
            return config;
        });
        this.setState({ integrationConfigurations: configs });
    }

    changePartitionBy = (configId, index, value) => {
        const configs = this.state.integrationConfigurations.map(config => {
            if (config.id === configId) {
                const newPartitions = [...config.partitions];
                newPartitions[index] = { ...newPartitions[index], partitionBy: value };
                return {
                    ...config,
                    partitions: newPartitions
                };
            }
            return config;
        });
        this.setState({ integrationConfigurations: configs });
    }

    handleFormSubmit = (formData) => {
        // console.log('Form submitted:', formData);
        // Add your form submission logic here
        // You can call your API to save the datasource configuration
    }

    handleTestConnection = async (formData) => {
        // Set testing state and save form data
        this.setState({ 
            isTestingConnection: true, 
            testConnectionSuccess: null, 
            testConnectionResponse: null,
            testConnectionError: null, // Clear previous errors
            testConnectionFormData: formData // Save form data for display
        });
        // console.log('Testing connection with data:', formData);
        // Prepare request payload based on datasource type
        const requestPayload = {
            datasource_name: formData.integration_name || formData.datasource_name || "Test Dataset",
            tenant_id: localStorage.getItem('team_id'), // You may want to get this from props or auth
            env_id: this.props.env_id || 69,
            datasource_type: this.mapDatasourceType(this.state.formType),
            data_store_type: this.getDatasourceStoreType(this.state.formType),
            datasource_config: this.buildDatasourceConfig(formData, this.state.formType),
            auth_config: await this.buildAuthConfig(formData, this.state.formType),
            ...(formData.check_type && { check_type: formData.check_type }),
            ...(formData.datasource_id && { datasource_id: formData.datasource_id })
        };
        let testDataSourceResponse;
        if (this.state.formType === 'microsoft_purview' || this.state.formType === 'microsoft purview' || this.state.formType === 'unity_catalog' || this.state.formType === 'azure_microsoft_fabric' || this.state.formType === 'neo4j' || this.state.formType === 'amazon_neptune' || this.state.formType === 'azure_cosmos_gremlin' || this.state.formType === 'spanner_graph' || this.state.formType === 'pinecone' || this.state.formType === 'elasticsearch' || this.state.formType === 'postgres_vector') {
            let formTypeKey = this.state.formType === 'microsoft purview' ? 'microsoft_purview' : this.state.formType;
            let mockStages = [];
            
            if (TEST_CONNECTION_MESSAGES[formTypeKey] && TEST_CONNECTION_MESSAGES[formTypeKey].stages) {
                mockStages = TEST_CONNECTION_MESSAGES[formTypeKey].stages.map(s => ({
                    name: s.name,
                    stage: s.stage,
                    status: true // Mock all stages as completely successful
                }));
            }
            await new Promise(resolve => setTimeout(resolve, 3000));
            testDataSourceResponse = {
                status_code: 200,
                status_message: "Connection Successful",
                schemas: [], // You can leave this empty or mock fake schemas if your UI requires them
                stages: mockStages.length > 0 ? mockStages : [{"name":"Validate Connection","stage":1,"status":true}]
            };
            if (testDataSourceResponse.status_code === 200){
            this.isCreateDatasourceEnabled();
            }
        } else {
            testDataSourceResponse = await testDataSource(requestPayload);
        }
        // Unwrap nested response: { code: 401, response: { status_code: 200, ... } }
        // This happens when the datasource already exists but credentials are valid.
        // Preserve the outer message to show it in the UI after unwrapping.
        let datasourceExistsMessage = null;
        if (
            testDataSourceResponse?.code === 401 &&
            testDataSourceResponse?.response?.status_code === 200
        ) {
            datasourceExistsMessage = testDataSourceResponse.message || null;
            testDataSourceResponse = testDataSourceResponse.response;
        }

        if (testDataSourceResponse?.status_code === 200) {
              console.log('Test connection response:', testDataSourceResponse);
                const normalizedTestConnectionResponse = {
                    ...testDataSourceResponse,
                    schemas: this.state.formType === 'azure_blob'|| this.state.formType ==='s3' || this.state.formType === 'azure_data_lake_gen2'
                        ? testDataSourceResponse?.buckets || []
                        : testDataSourceResponse?.schemas || []
                };
                
                // Automatically select all schemas by default
                // eslint-disable-next-line
                const allSchemas = normalizedTestConnectionResponse.schemas || [];
                
                this.setState({ 
                    isTestingConnection: false, 
                    testConnectionSuccess: true,
                    testConnectionResponse: normalizedTestConnectionResponse, // Store full response for further use
                 //   selectedSchemas: allSchemas, // Auto-select all schemas by default
                    testConnectionError: datasourceExistsMessage // Show outer 401 message if present, null otherwise
                });

          }

        else {
                console.error('Test connection error:', testDataSourceResponse);
                const normalizedTestConnectionResponse = testDataSourceResponse ? {
                    ...testDataSourceResponse,
                    schemas: this.state.formType === 'azure_blob'|| this.state.formType ==='s3' || this.state.formType === 'azure_data_lake_gen2'
                        ? testDataSourceResponse?.buckets || []
                        : testDataSourceResponse?.schemas || []
                } : null;

                // If the response already contains stages, suppress the generic error banner —
                // the stages themselves communicate what failed. Only show the banner when
                // there are no stages to display (e.g. a plain network/auth error).
                const hasStages = Array.isArray(testDataSourceResponse?.stages) && testDataSourceResponse.stages.length > 0;
                const errorMessage = hasStages
                    ? null
                    : (testDataSourceResponse?.message || testDataSourceResponse?.status_message || 'Connection Failed. Please check your credentials.');
                
                this.setState({ 
                    isTestingConnection: false, 
                    testConnectionSuccess: false,
                    testConnectionResponse: normalizedTestConnectionResponse || testDataSourceResponse?.response || testDataSourceResponse || null,
                    testConnectionError: errorMessage
                });
            };
    }

    // Map form type to API datasource_type
    mapDatasourceType = (formType) => {
        const typeMap = {
            'snowflake': 'snow_flake',
            'mysql': 'mysql',
            'postgresql': 'postgresql',
            'azure_synapse_ds': 'azure_synapse_ds',
            'big_query': 'big_query',
            'redshift': 'redshift',
            'azure_blob': 'azure_blob',
            's3': 's3',
            'azure_sql': 'azure_sql',
            'azure_data_lake_gen2': 'azure_data_lake_gen2',
            'gcp_sql': 'gcp_sql'
            // Add more mappings as needed
        };
        return typeMap[formType] || formType;
    }

    // Get data store type based on datasource
    getDatasourceStoreType = (formType) => {
        const dbTypes = ['snowflake', 'mysql', 'postgresql','azure_synapse_ds','big_query','redshift','azure_sql','gcp_sql','athena','azure_databricks_table','neo4j','amazon_neptune','azure_cosmos_db','azure_cosmos_gremlin','google_cloud_spanner','spanner_graph','pinecone','elasticsearch','postgres_vector'];
        return dbTypes.includes(formType) ? 'database' : 'filesystem';
    }

    normalizeHostUrl = (host) => {
        if (!host || typeof host !== 'string') {
            return "";
        }
        let normalized = host.trim();
        normalized = normalized.replace(/^(https?:\/\/)/i, '');
        normalized = normalized.replace(/\/+$/g, '');
        return normalized;
    }

    // Build datasource_config from form data
    buildDatasourceConfig = (formData, formType) => {
        if (formType === 'snowflake') {
            return {
                url: formData.host_url || formData.host || "",
                database: formData.database_name || formData.database || "",
                schema: formData.schema || "",
                ware_house: formData.warehouse || "",
                table_name: ""
            };
        } else if (formType === 'postgresql') {
            return {
                host_url: this.normalizeHostUrl(formData.host || formData.host_url || ""),
                database_name: formData.database || formData.database_name || "",
                schema_name: formData.schema_name || formData.schema || ""

            };
        } else if (formType === 'mysql') {
            return {
                host: this.normalizeHostUrl(formData.host || ""),
                port: formData.port || "",
                database: formData.database || "",
                schema: formData.schema || ""
            };
        } else if (formType === 'gcs' || formType === 'azure_data_lake') {
            const refreshType = formData.refreshType || "file_replace";
            const versionFormat = formData.versionFormat || "";
            return {
                bucket_name: formData.bucket_name || "",
                sub_path: formData.sub_path || "",
                filetype: formData.fileType || "",
                refresh_type: refreshType,
                version_format: versionFormat === 'custom'
                    ? formData.versionFormatRegex || ""
                    : VERSION_FORMATS[versionFormat] || "",
                version_occurence: refreshType === "file_replace"
                    ? "default"
                    : formData.versionOccurence || "default"
            };
        } else if (formType === 'azure_blob') {
            const refreshType = formData.refreshType || "file_replace";
            const versionFormat = formData.versionFormat || "";
            const config = {
                storage_name: formData.storage_name || "",
                filetype: formData.fileType || "",
                refresh_type: refreshType,
                version_format: versionFormat === 'custom'
                    ? formData.versionFormatRegex || ""
                    : VERSION_FORMATS[versionFormat] || "",
                version_occurence: refreshType === "file_replace"
                    ? "default"
                    : formData.versionOccurence || "default"
            };

            if (formData.error_storage) {
                config.error_storage = formData.error_storage;
            }

            if (typeof formData.storeDataIssues === 'boolean') {
                config.default_error_storage = !formData.storeDataIssues;
            }

            return config;
        
        } 
        else if (formType === 'azure_data_lake_gen2') {
            const refreshType = formData.refreshType || "file_replace";
            const versionFormat = formData.versionFormat || "";
            const config = {
                storage_name: formData.storage_name || "",
                filetype: formData.fileType || "",
                refresh_type: refreshType,
                version_format: versionFormat === 'custom'
                    ? formData.versionFormatRegex || ""
                    : VERSION_FORMATS[versionFormat] || "",
                version_occurence: refreshType === "file_replace"
                    ? "default"
                    : formData.versionOccurence || "default"
            };

            if (formData.error_storage) {
                config.error_storage = formData.error_storage;
            }

            if (typeof formData.storeDataIssues === 'boolean') {
                config.default_error_storage = !formData.storeDataIssues;
            }

            return config;
        
        } 

        else if (formType === 's3') {
            const refreshType = formData.refreshType || "file_replace";
            const versionFormat = formData.versionFormat || "";

            const config = {
                auto_config_type: "allBuckets",
                filetype: formData.fileType || "",
                error_storage: formData.error_storage || "",
                refresh_type: refreshType,
                version_format: versionFormat === 'custom'
                    ? formData.versionFormatRegex || ""
                    : VERSION_FORMATS[versionFormat] || "",
                version_occurence: refreshType === "file_replace"
                    ? "default"
                    : formData.versionOccurence || "default"
            };

            if (typeof formData.storeDataIssues === 'boolean') {
                config.default_error_storage = !formData.storeDataIssues;
            } else {
                config.default_error_storage = true;
            }

            return config;
        }
        else if (formType === 'neo4j') {
            const config = {
                graph_db_type: 'Neo4j',
                host: formData.host || "",
                port: formData.port || "",
                protocol: formData.protocol || "bolt",
                database: formData.database || "neo4j",
                username: formData.username || "",
                password: formData.password || "",
            };
            if (formData.error_storage) {
                config.error_storage = formData.error_storage;
            }
            if (typeof formData.storeDataIssues === 'boolean') {
                config.default_error_storage = !formData.storeDataIssues;
            }
            return config;
        }
        else if (formType === 'amazon_neptune') {
            const config = {
                graph_db_type: 'Amazon Neptune',
                host: formData.host || "",
                port: formData.port || "8182",
                aws_region: formData.aws_region || "",
                database: formData.database || "",
                use_iam_auth: formData.use_iam_auth || false,
            };
            if (formData.error_storage) {
                config.error_storage = formData.error_storage;
            }
            if (typeof formData.storeDataIssues === 'boolean') {
                config.default_error_storage = !formData.storeDataIssues;
            }
            return config;
        }
        else if (formType === 'azure_cosmos_db') {
            const config = {
                graph_db_type: 'Azure Cosmos DB',
                host: formData.host || "",
                port: formData.port || "443",
                database: formData.database || "",
                graph: formData.graph || "",
                account_key: formData.account_key || "",
            };
            if (formData.error_storage) {
                config.error_storage = formData.error_storage;
            }
            if (typeof formData.storeDataIssues === 'boolean') {
                config.default_error_storage = !formData.storeDataIssues;
            }
            return config;
        }
        else if (formType === 'google_cloud_spanner') {
            const config = {
                graph_db_type: 'Google Cloud Spanner',
                project_id: formData.project_id || "",
                instance_id: formData.instance_id || "",
                database: formData.database || "",
                graph_name: formData.graph_name || "",
                credentials: formData.credentials || "",
            };
            if (formData.error_storage) {
                config.error_storage = formData.error_storage;
            }
            if (typeof formData.storeDataIssues === 'boolean') {
                config.default_error_storage = !formData.storeDataIssues;
            }
            return config;
        }
        else if (formType === 'pinecone') {
            const config = {
                vector_db_type: 'Pinecone',
                api_key: formData.api_key || "",
                index_name: formData.index_name || "",
                namespace: formData.namespace || "",
                cloud_provider: formData.cloud_provider || "",
                region: formData.region || "",
                environment: formData.environment || "",
            };
            if (formData.error_storage) {
                config.error_storage = formData.error_storage;
            }
            if (typeof formData.storeDataIssues === 'boolean') {
                config.default_error_storage = !formData.storeDataIssues;
            }
            return config;
        }
        else if (formType === 'elasticsearch') {
            const config = {
                vector_db_type: 'Elasticsearch',
                host: formData.host || "",
                port: formData.port || "9200",
                api_key: formData.api_key || "",
                username: formData.username || "",
                password: formData.password || "",
                index_name: formData.index_name || "",
                cloud_provider: formData.cloud_provider || "",
                region: formData.region || "",
            };
            if (formData.error_storage) {
                config.error_storage = formData.error_storage;
            }
            if (typeof formData.storeDataIssues === 'boolean') {
                config.default_error_storage = !formData.storeDataIssues;
            }
            return config;
        }
        else if (formType === 'postgres_vector') {
            const config = {
                vector_db_type: 'Postgres Vector',
                host: formData.host || "",
                port: formData.port || "5432",
                database: formData.database || "",
                table_name: formData.table_name || "",
                username: formData.username || "",
                password: formData.password || "",
                schema: formData.schema || "public",
            };
            if (formData.error_storage) {
                config.error_storage = formData.error_storage;
            }
            if (typeof formData.storeDataIssues === 'boolean') {
                config.default_error_storage = !formData.storeDataIssues;
            }
            return config;
        }
        else if (formType === 'azure_synapse_ds') {
            return {
                synapse_sql_host: formData.synapse_sql_host || "",
                database_name: formData.database_name || "",
                schema: formData.schema || "",
                synapse_table_name: formData.synapse_table_name || ""
            };
        }
        else if (formType === 'azure_sql') {
            return {
                host: formData.host || "",
                database: formData.database || "",
            };
        }

        else if(formType === 'redshift'){ 
            return {
                host_url: this.normalizeHostUrl(formData.host || formData.host_url || ""),
                database_name: formData.database || formData.database_name || "",
            };
        }

        else if (formType === 'gcp_sql') {
            return {
                host: this.normalizeHostUrl(formData.host || ""),
                database: formData.database || ""
            }
        }
        else if(formType === 'azure_databricks_table') {
            return {
                host: formData.host || "",
                http_path: formData.http_path || "",
                catalog: formData.catalog || "",
            }
        }
        else if(formType === 'athena') {
            return {
                output_location: formData.output_location || "",
                region_name: formData.region || "",
                database_name: formData.database_name || "",
                catalog: formData.catalog || ""
            }
        }

        else if(formType === 'big_query'){
            return {
                project_id: formData.project_id || "",
            }
        }

        return {};
    }

    // Build auth_config from form data
    buildAuthConfig = async (formData, formType) => {
        if (formType === 'big_query' || formType === 'gcs') {
            if (!formData.json_file || typeof formData.json_file.text !== 'function') {
                throw new Error("Upload the connector service account JSON file before testing the connection.");
            }
            const content = await formData.json_file.text();
            return JSON.parse(content);
        
        }

        if (formType === 'postgresql') {
            return {
                tenant_id: localStorage.getItem('team_id') || "",
                user_name: formData.user_name || formData.username || "",
                password: formData.password || ""
            };
        
        
        } 
        
        else if (formType === 'redshift') {
            // console.log("redshift type");
            return {
                tenant_id: localStorage.getItem('team_id') || "",
                user_name: formData.user_name || formData.username || "",
                password: formData.password || ""
            }
        }
        
        else if (formType === 'azure_synapse_ds') {
            return {
                tenant_id: localStorage.getItem('team_id') || "",
                synapse_user: formData.synapse_user || "",
                synapse_password: formData.synapse_password || ""
            };
        } else if (formType === 'azure_blob') {
            return {
                secret_key: formData.blob_secret || formData.secret_key || ""
            };
        }
        else if (formType === 'azure_data_lake') {
            return {
                adl_client_id: formData.adl_client_id || "",
                adl_tenant_id: formData.adl_tenant_id || "",
                secret_key: formData.secret_key || ""
            };
        }
        else if (formType === 'azure_data_lake_gen2') {
            return {
                secret_key: formData.blob_secret || formData.secret_key || ""
            };
        }
        else if(formType === 'gcp_sql') {
                return {    
                    user: formData.user_name || formData.username || formData.user || "",
                    password: formData.password || ""
                }
            }
        
        else if(formType === 'azure_databricks_table') {
            return {
                tenant_id: localStorage.getItem('team_id') || "",
                secret_key: formData.secret_key || "",
            }
        }

        else if(formType === 'athena') {
            return {
                tenant_id: localStorage.getItem('team_id') || "",
                access_key: formData.accessKey || "",
                secret_access_key: formData.secretAccessKey || ""
            }
        }

        else if(formType === 's3'){
            return{
                tenant_id: localStorage.getItem('team_id') || "",
                access_key: formData.accessKey || "",
                secret_access_key: formData.secretAccessKey || ""
            }
        }
        return {
            tenant_id: localStorage.getItem('team_id') || "",
            user: formData.user_name || formData.username || formData.user || "",
            password: formData.password || "",
            private_key: formData.privateKey || "",
            private_key_pwd: formData.privateKeyPassphrase || formData.privateKeyPassword || ""
        };
    };

    // Get datasource label for display
    getDatasourceLabel = (formType) => {
        const labelMap = {
            'snowflake': 'Snowflake',
            'mysql': 'MySQL',
            'postgresql': 'PostgreSQL',
            'azure_blob': 'Azure Blob',
            'azure_data_lake_gen2': 'Azure Data Lake Gen2',
            's3': 'AWS S3'
        };
        return labelMap[formType] || formType;
    }

    toggleSecretVisibility = (fieldKey) => {
        this.setState(prevState => {
            const currentSecrets = prevState.showSecret || {};
            return {
                showSecret: {
                    ...currentSecrets,
                    [fieldKey]: !currentSecrets[fieldKey]
                }
            };
        });
    };

    // Render icon dynamically based on icon name from config
    renderDynamicIcon = (iconName, size = 16) => {
        const IconComponent = require('lucide-react')[iconName];
        return IconComponent ? <IconComponent size={size} color="#A4A7AE" /> : null;
    }

    // Dynamically render integration info fields based on datasourceConfig
    renderIntegrationInfoFields = () => {
        const { formType, testConnectionFormData } = this.state;
        const datasourceConfig = require('./datasourceConfig.json');
        const config = datasourceConfig.datasourceTypes[formType];
        
        if (!config || !testConnectionFormData) return null;

        const renderedGroups = [];
        
        config.fieldGroups.forEach((group, groupIndex) => {
            const groupFields = [];
            
            // Skip credential groups - they will be rendered separately with Auth Method
            const isCredentialGroup = group.fields.some(field => 
                field.name === 'username' || field.name === 'password' || field.name === 'privateKey' || field.input === 'radio' || field.input === 'password'
            );
            
            if (isCredentialGroup) return;
            
            group.fields.forEach((field) => {
                // Skip datasource_name - it's rendered in the same row as Type
                if (field.name === 'datasource_name') return;
                
                // Skip fields that shouldn't be shown based on showWhen condition
                if (field.showWhen) {
                    const key = Object.keys(field.showWhen)[0];
                    const condition = field.showWhen[key];
                    const actualValue = testConnectionFormData[key];
                    const conditionMet = Array.isArray(condition)
                        ? condition.includes(actualValue)
                        : actualValue === condition;
                    if (!conditionMet) return;
                }
                
                // Skip if value doesn't exist
                const value = testConnectionFormData[field.name];
                if (!value) return;
                
                const displayValue =
                    value instanceof File ? value.name : value;

                groupFields.push(
                    <div key={field.name} className="qd-configure-integration-info__item">
                        <label className='qd-configure-integration-info__label'>{field.label}</label>
                        <span className="qd-configure-integration-info__value">
                            <i>{this.renderDynamicIcon(field.icon)}</i>
                            <RcTooltip
                                placement="top"
                                overlay={<span>{displayValue}</span>}
                                arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                            >
                                <span>{displayValue}</span>
                            </RcTooltip>
                        </span>
                    </div>
                );
            });
            
            if (groupFields.length > 0) {
                // Add separator before group if it has separator property and it's not the first group
                if (group.separator && renderedGroups.length > 0) {
                    renderedGroups.push(<hr key={`separator-${groupIndex}`} />);
                }
                
                renderedGroups.push(
                    <>
                    <hr className='tw-block tw-my-3' />
                    <div key={`group-${groupIndex}`} className="qd-configure-integration-info__list">
                        {groupFields}
                    </div>
                    </>
                );
            }
        });
        
        return renderedGroups;
    }

    // Render credential fields with Auth Method
    renderCredentialFields = () => {
        const { formType, testConnectionFormData } = this.state;
        const datasourceConfig = require('./datasourceConfig.json');
        const config = datasourceConfig.datasourceTypes[formType];
        
        if (!config || !testConnectionFormData) return null;

        const credentialFields = [];
        
        // Find the credential group — matches groups with username/password/privateKey
        // OR any group that contains a password-type input field (e.g. blob_secret)
        const credentialGroup = config.fieldGroups.find(group => 
            group.fields.some(field => 
                field.name === 'username' || 
                field.name === 'password' || 
                field.name === 'privateKey' || 
                field.input === 'password'
            )
        );
        
        if (!credentialGroup) return null;

        // Add Auth Method first (for Snowflake with authMethod)
        if (testConnectionFormData.authMethod) {
            credentialFields.push(
                <div key="authMethod" className="qd-configure-integration-info__item">
                    <label className='qd-configure-integration-info__label'>Auth Method</label>
                    <span className="qd-configure-integration-info__value">
                        <i><LockKeyhole size={16} color="#A4A7AE" /></i>
                        <span>{testConnectionFormData.authMethod}</span>
                    </span>
                </div>
            );
        }

        // Add credential fields based on config
        credentialGroup.fields.forEach((field) => {
            // Skip radio button field itself
            if (field.input === 'radio') return;
            
            // Skip fields that shouldn't be shown based on showWhen condition
            if (field.showWhen) {
                const key = Object.keys(field.showWhen)[0];
                const condition = field.showWhen[key];
                const actualValue = testConnectionFormData[key];
                const conditionMet = Array.isArray(condition)
                    ? condition.includes(actualValue)
                    : actualValue === condition;
                if (!conditionMet) return;
            }
            
            // Skip if value doesn't exist
            const value = testConnectionFormData[field.name];
            if (!value) return;
            
            // Handle password fields (by input type — catches blob_secret, password, etc.)
            if (field.input === 'password' || field.name === 'password') {
                const isVisible = this.state.showSecret?.[field.name];
                credentialFields.push(
                    <div key={field.name} className="qd-configure-integration-info__item">
                        <label className='qd-configure-integration-info__label'>{field.label}</label>
                        <span className="qd-configure-integration-info__value">
                            <i>{this.renderDynamicIcon(field.icon)}</i>
                            {isVisible ? (
                                <RcTooltip placement="top" overlay={<span>{value}</span>} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
                                    <span>{value}</span>
                                </RcTooltip>
                            ) : (
                                <span>••••••••</span>
                            )}
                            <i className='cursor-pointer' onClick={() => this.toggleSecretVisibility(field.name)}>
                                {isVisible ? <EyeOff size={16} color="#A4A7AE" /> : <Eye size={16} color="#A4A7AE" />}
                            </i>
                        </span>
                    </div>
                );
                return;
            }
            
            // Handle privateKey field
            if (field.name === 'privateKey') {
                credentialFields.push(
                    <div key={field.name} className="qd-configure-integration-info__item">
                        <label className='qd-configure-integration-info__label'>{field.label}</label>
                        <span className="qd-configure-integration-info__value">
                            <i>{this.renderDynamicIcon(field.icon)}</i>
                            <span>Configured</span>
                        </span>
                    </div>
                );
                return;
            }
            
            // Regular fields (username, etc.)
            credentialFields.push(
                <div key={field.name} className="qd-configure-integration-info__item">
                    <label className='qd-configure-integration-info__label'>{field.label}</label>
                    <span className="qd-configure-integration-info__value">
                        <i>{this.renderDynamicIcon(field.icon)}</i>
                        <RcTooltip
                            placement="top"
                            overlay={<span>{value}</span>}
                            arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                        >
                            <span>{value}</span>
                        </RcTooltip>
                    </span>
                </div>
            );
        });

        if (credentialFields.length === 0) return null;

        return (
            <>
                <hr className='tw-block tw-my-3' />
                <div className="qd-configure-integration-info__list">
                    {credentialFields}
                </div>
            </>
        );
    }

   

    renderTest() {
        if (this.state.testConnection != null) {
            return <TestConnection integration_data={this.state.integration_data}
                                   testConnection_data={this.state.testConnection}
                                   submit_button={this.state.submit_button}
                                   closeTestConnection={this.closeTestConnection}
                                   src_page={this.props.src_page}
                                   setPage={this.props.setPage}
                                   showToast={this.props.showToast}
                                   closeModal={this.props.closeModal}
                                   existingIntegrations={this.props.existingIntegrations}
                                   setEnvData={this.props.setEnvData}
                                   env_id={this.props.env_id}
                                   ip_address={this.state.ip_address}
                />;
        }
    }


    FillFormDetails(integration_details) {
        let defaultValue, formType = null;
        const integration_type = integration_details["integration_type"];
        if (integration_type === undefined){
            return [null, null];
        }
        if(integration_type === "azure_blob") {
            formType = "azure_blob";
            defaultValue = {"label":"Azure Blob", "value":'azure_blob'};
        } else if(integration_type === "azure_data_lake_gen2") {
            formType = "azure_data_lake_gen2";
            defaultValue = {"label":"Azure Data Lake Gen2", "value":'azure_data_lake_gen2'};
        } else if (integration_type === "azure_data_lake") {
             formType = "azure_data_lake";
            defaultValue = {"label":'Azure Data Lake', "value":'azure_data_lake'};
        } else if (integration_type === "azure_databricks_table") {
            formType = "azure_databricks_table";
            defaultValue = {"label":'Azure Databricks Table', "value":'azure_databricks_table'};             
        } else if (integration_type.includes("snow_flake")) {
             formType = "snowflake";
             defaultValue = {"label":'Snowflake', "value":'snowflake'};
        }  else if (integration_type.includes("s3")) {
             formType = "s3";
             defaultValue = {"label":'AWS S3', "value":'s3'};
        } else if (integration_type.includes("azure_sql")) {
             formType = "azure_sql";
             defaultValue = {"label":"Azure SQLServer", "value":'azure_sql'};
        }else if (integration_type.includes("gcp_sql")) {
             formType = "gcp_sql";
             defaultValue = {"label":"GCP SQLServer", "value":'gcp_sql'};
        }else if (integration_type.includes("big_query")) {
             formType = "big_query";
             defaultValue = {"label":"Google BigQuery", "value":'big_query'};
        } else if (integration_type.includes("postgresql")) {
             formType = "postgresql";
             defaultValue = {"label":"Postgres", "value":'postgresql'};
        } else if (integration_type.includes("mysql")) {
             formType = "mysql";
             defaultValue = {"label":"MySQL", "value":'mysql'};
        }else if (integration_type.includes("gcs")) {
            formType = "gcs";
            defaultValue = {"label":"GCS", "value":'gcs'};
        }  else if (integration_type.includes("redshift")) {
            formType = "redshift";
            defaultValue = {"label":'AWS redshift', "value":'redshift'};
        } else if (integration_type.includes("athena")) {
            formType = "athena";
            defaultValue = {"label":'Athena', "value":'AWS Athena'};
        }
        // Graph DB Types
        else if (integration_type.includes("neo4j")) {
            formType = "neo4j";
            defaultValue = {"label": 'Neo4j', "value": 'neo4j'};
        }
        else if (integration_type.includes("amazon_neptune")) {
            formType = "amazon_neptune";
            defaultValue = {"label": 'Amazon Neptune', "value": 'amazon_neptune'};
        }
        else if (integration_type.includes("azure_cosmos_db")) {
            formType = "azure_cosmos_db";
            defaultValue = {"label": 'Azure Cosmos DB', "value": 'azure_cosmos_db'};
        }
        else if (integration_type.includes("google_cloud_spanner")) {
            formType = "google_cloud_spanner";
            defaultValue = {"label": 'Google Cloud Spanner', "value": 'google_cloud_spanner'};
        }
        // Vector DB Types
        else if (integration_type.includes("pinecone")) {
            formType = "pinecone";
            defaultValue = {"label": 'Pinecone', "value": 'pinecone'};
        }
        else if (integration_type.includes("elasticsearch")) {
            formType = "elasticsearch";
            defaultValue = {"label": 'Elasticsearch', "value": 'elasticsearch'};
        }
        else if (integration_type.includes("postgres_vector")) {
            formType = "postgres_vector";
            defaultValue = {"label": 'Postgres Vector', "value": 'postgres_vector'};
        }
        else if (integration_type.includes(POWER_BI_CONNECTOR)) {
            formType = POWER_BI_CONNECTOR;
            defaultValue = {"label":'Power Bi', "value":POWER_BI_CONNECTOR};
        }
        else if (integration_type === AZURE_SYNAPSE_DS_CONNECTOR) {
            formType = AZURE_SYNAPSE_DS_CONNECTOR;
            defaultValue = {"label":'Azure Synapse', "value":AZURE_SYNAPSE_DS_CONNECTOR};
        }
        else {
             formType = "AWS";
             defaultValue = {"label":'AWS', "value":'AWS'};
        }
        return [defaultValue, formType];
    }

    changeHelpContent(key) {
        this.setState({helpContentKey: key});
    }

    renderHelpContent() {
        let content = [];
        let info = [];
        if(this.state.formType === "AWS" ) {
            info = helpContent["aws"];
        } else if (this.state.formType === "snowflake") {
            info = helpContent["snowflake"];
        } else if(this.state.helpContentKey === "azure_blob") {
            info = helpContent["azure_blob"];
        } else if(this.state.helpContentKey === "azure_data_lake") {
            info = helpContent["azure_data_lake"];
        } else if(this.state.helpContentKey === "azure_databricks_table") {
            info = helpContent["azure_databricks_table"];     
        } // Graph DB Types
        else if(this.state.helpContentKey === "neo4j") {
            info = helpContent["neo4j"];
        } else if(this.state.helpContentKey === "amazon_neptune") {
            info = helpContent["amazon_neptune"];
        } else if(this.state.helpContentKey === "azure_cosmos_gremlin") {
            info = helpContent["azure_cosmos_gremlin"];
        } else if(this.state.helpContentKey === "spanner_graph") {
            info = helpContent["spanner_graph"];
        } // Vector DB Types
        else if(this.state.helpContentKey === "pinecone") {
            info = helpContent["pinecone"];
        } else if(this.state.helpContentKey === "elasticsearch") {
            info = helpContent["elasticsearch"];
        } else if(this.state.helpContentKey === "postgres_vector") {
            info = helpContent["postgres_vector"];
        } else if(this.state.formType === "s3" ) {
            info = helpContent["aws"];
        } else if(this.state.formType === "redshift" ) {
            info = helpContent["redshift"];
        } else if(this.state.formType === "athena" ) {
            info = helpContent["athena"];
        } else if(this.state.formType === "azure_sql" ) {
            info = helpContent["azure_sql"];
        }else if(this.state.formType === "gcp_sql" ) {
            info = helpContent["gcp_sql"];
        }else if(this.state.formType === "big_query" ) {
            info = helpContent["big_query"];
        } else if (this.state.formType === "postgresql"){
            info = helpContent["postgresql"];
        }else if (this.state.formType === "mysql"){
            info = helpContent["mysql"];
        }
        else if (this.state.formType === "gcs"){
            info = helpContent["gcs"];
        }
        else if (this.state.formType === "azure_synapse_ds"){
            info = helpContent["azure_synapse_ds"];
        }
        else if(this.state.formType === "azure_microsoft_fabric"){
            info = helpContent["azure_microsoft_fabric"]
        }
        else if (this.state.formType === "microsoft_purview"){
            info = helpContent["microsoft_purview"]
        }
        else if (this.state.formType === "unity_catalog"){
            info = helpContent["unity_catalog"]
        }
        else {
            info = helpContent["azure_blob"];
        }
        let k=0;
        for (k=0; k < info.length; k++) {
            if(k=== (info.length-1) && this.state.formType !== 'big_query'){
                content.push(<li>Make sure Qualdo's IP : <strong> {this.state.ip_address} </strong> is added to your authorised network(s).</li>);
                content.push(<li>{info[k]} Refer to the <a href={get_document_link("data_source")} rel="noopener noreferrer" target="_blank">{QUALDO_DOCUMENTATION}</a> for more details.</li>);
                }
                else if(k=== (info.length-1) && this.state.formType === 'big_query'){
                    content.push(<li>{info[k]} Refer to the <a href={get_document_link("data_source")} rel="noopener noreferrer" target="_blank">{QUALDO_DOCUMENTATION}</a> for more details.</li>);
                    content.push(<li>Make sure Qualdo's IP : <strong> {this.state.ip_address} </strong> is added to your authorised network(s).</li>);

                }
                else {
                    if (this.state.formType === 'azure_databricks_table') {
                        if ((k >= 4 && k <= 7) || (k >= 9 && k <= 12)) {
                            content.push(
                                <div key={k} style={{ marginLeft: '25px' }}>
                                    {info[k]}
                                </div>
                            );
                        } else {
                            content.push(
                                <li key={k}>{info[k]}</li>
                            );
                        }
                    }
                    else if ( this.state.formType === 'unity_catalog'){
                    if ((k >= 5 && k <= 7) || (k >= 9 && k <= 11)) {
                        content.push(<ol start="1">{info[k]}</ol>);
                    }
                    else {
                        content.push(<li>{info[k]}</li>);
                    }
                    }
                    else if ( this.state.formType === 'neo4j'){
                    if ((k >= 4 && k <= 7) || (k >= 10 && k <= 11)) {
                        content.push(<ol start="1">{info[k]}</ol>);
                    }
                    else {
                        content.push(<li>{info[k]}</li>);
                    }
                    }
                    else if ( this.state.formType === 'amazon_neptune'){
                    if ((k >= 6 && k <= 7)) {
                        content.push(<ol start="1">{info[k]}</ol>);
                    }
                    else {
                        content.push(<li>{info[k]}</li>);
                    }
                    }
                    else if ( this.state.formType === 'azure_cosmos_gremlin'){
                    if ((k >= 6 && k <= 7)) {
                        content.push(<ol start="1">{info[k]}</ol>);
                    }
                    else {
                        content.push(<li>{info[k]}</li>);
                    }
                    }
                    else if ( this.state.formType === 'spanner_graph'){
                    if ((k >= 6 && k <= 8) || (k >= 10 && k <= 11)) {
                        content.push(<ol start="1">{info[k]}</ol>);
                    }
                    else {
                        content.push(<li>{info[k]}</li>);
                    }
                    }
                    else if (this.state.formType === 'pinecone'){
                    if ((k >= 4 && k <= 5) || (k >= 9 && k <= 11)) {
                        content.push(<ol start="1">{info[k]}</ol>);
                    }
                    else {
                        content.push(<li>{info[k]}</li>);
                    }
                    }                    
                    else if (this.state.formType === 'elasticsearch'){
                    if ((k >= 4 && k <= 5) || (k >= 8 && k <= 9) || (k>=11 && k <=13)) {
                        content.push(<ol start="1">{info[k]}</ol>);
                    }
                    else {
                        content.push(<li>{info[k]}</li>);
                    }
                    }                    
                    else if (this.state.formType === 'postgres_vector'){
                    if ((k >= 6 && k <= 7) || (k===9) || (k>=11 && k <=12)) {
                        content.push(<ol start="1">{info[k]}</ol>);
                    }
                    else {
                        content.push(<li>{info[k]}</li>);
                    }
                    }
                    else{
                        content.push(<li>{info[k]}</li>);
                    }                    
                   }
        }   

        if($( window ).width() > 768){
            let addheight = $('#add-datasource').height();
            $('#add-datasource_help').height(addheight - 26);
        }    
        return content;
    }
getAddIntegrationContent(data_source_option){
    return (
            <>
                <div className = "portlet portlet-2col" id="add_data_source_panel">
                    <div className="portlet-title">
                        <div className="caption">
                            <span className="text-uppercase font-dark">{this.props.src_page === "setup" ? "Add your first DataSource" : "Add DataSource"}</span>
                            <p className="!tw-text-[#535862] dark:tw-text-[#787B86] mt-1">Manage your team members and their account permissions here.</p>
                        </div>
                        <div className="actions"></div>
                    </div>
                    <div className = "portlet-body d-none">
                        <div className="row">
                            <div className={this.props.ex_integration_details !== undefined ? "col-md-12" : "col-md-8"}>
                                <div className="portlet-body"id="add-datasource">
                                    <div className="form-row">
                                        <div className="form-group col-md-6 hello">
                                            <label>Choose a Datasource type </label>
                                            <Select
                                                id="choose_datasource_type_add"
                                                filterOption={({label}, query) => label.toLowerCase().includes(query.toLowerCase())}
                                                onChange={this.setForm}
                                                value={this.state.formType_option}
                                                options={data_source_option}
                                                placeholder="Choose Data Source"
                                                classNamePrefix='select-control'
                                                formatGroupLabel={formatGroupLabel}
                                            />
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                                <div className="col-md-4">
                                    <div className="portlet border-0 mb-0">
                                        <div className="portlet-title">
                                            <div className="caption">
                                                <span className="text-uppercase">Help</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="portlet-body p-0">
                                        {/* <h4 id="tooltipupdate">
                                            <div>
                                                <code className="highlighter-rouge">Steps to enable access from your storage to Qualdo™: </code>
                                                <a className="anchorjs-link " href="#tooltipupdate"
                                                    aria-label="Anchor" data-anchorjs-icon="#" style={{paddingLeft: "0.375em"}}>
                                                </a>
                                            </div>
                                        </h4> */}
                                        {/* <figure className="highlight" style={{"height": "250px","overflow-y": "auto"}}>
                                            {this.renderHelpContent()}
                                        </figure> */}

                                        <div id="add-datasource_help" class="qd-helpGuide">
                                        <div class="qd-helpGuide__content">
                                             <h4 class="qd-helpGuide__title">Steps to enable access from your storage to Qualdo™: </h4>
                                             <ol class="qd-helpGuide__info">
                                             {this.renderHelpContent()}
                                             </ol>
                                        </div>
                                        </div>


                                    </div>
                                </div>
                        </div>
                    </div>
                    <div className='portlet-body'>
                        <div className="row">
                            <div class="col-md-8">
                                <div className="d-flex flex-column h-100">
                                   <div class="qd-configure-integration-steps">
                                        <div className="vertical-stepper vertical-stepper-sm w-100 border-0">
                                            <div className="vertical-stepper__heading !tw-pb-2 sm:!tw-pb-1">
                                                <span className="vs-heading__circle">3</span>
                                                <div className="vs-heading__title">Datasource Details</div>
                                            </div>
                                            <div className="vertical-stepper__content">
                                                {!this.state.showTestConnectionInfo && (
                                                <div >
                                                    {/* className={this.state.testConnectionSuccess === null ? "" : "d-none"} */}
                                                    <div class="form-row">
                                                        <div class="form-group col-lg-6">
                                                            <label>Choose a Datasource type <span className='text-primary'>*</span></label>
                                                            <Select
                                                                id="choose_datasource_type_add"
                                                                filterOption={({label}, query) => label.toLowerCase().includes(query.toLowerCase())}
                                                                onChange={this.setForm}
                                                                value={this.state.formType_option}
                                                                options={data_source_option}
                                                                placeholder="Choose Data Source"
                                                                classNamePrefix='select-control'
                                                                formatGroupLabel={formatGroupLabel}
                                                                components={{ Control: (props) => customSelectDatasource({ ...props, icon: data_source_option }) }}
                                                            />
                                                        </div>
                                                        {/* {console.log("Selected form type:", this.state.formType)} */}
                                                    </div>
                                                    <DynamicDatasourceForm
                                                    key={this.state.formResetKey}
                                                    config={datasourceConfig}
                                                    selectedDatasource={this.state.formType}
                                                    onSubmit={this.handleFormSubmit}
                                                    onTestConnection={this.handleTestConnection}
                                                    isTestingConnection={this.state.isTestingConnection}
                                                    testConnectionSuccess={this.state.testConnectionSuccess}
                                                    testConnectionResponse={this.state.testConnectionResponse}
                                                    testConnectionError={this.state.testConnectionError}
                                                    onContinueSchemaSelection={this.handleContinueSchemaSelection}
                                                    initialFormData={this.state.testConnectionFormData}
                                                    existingDatasources={this.props.existingDatasources || []}
                                                    existingIntegrations={this.props.existingIntegrations || []}
                                                    ip_address={this.state.ip_address}
                                                    isEditMode={false}
                                                    />
                                                </div>
                                                )}
                                                
                                                {this.state.showTestConnectionInfo && this.state.testConnectionSuccess!==null && this.state.testConnectionFormData && (
                                                <div className="qd-configure-integration-info">
                                                    <div className="qd-configure-integration-info__content" id="test_connection_info">
                                                        <div className="qd-configure-integration-info__list">
                                                            <div className="qd-configure-integration-info__item">
                                                                <label className='qd-configure-integration-info__label'>Type</label>
                                                                <span className="qd-configure-integration-info__value">
                                                                    <i>
                                                                        <Database size={16} color="#A4A7AE" />
                                                                    </i>
                                                                    <span>{this.getDatasourceLabel(this.state.formType)}</span>
                                                                </span>
                                                            </div>
                                                            {this.state.testConnectionFormData.datasource_name && (
                                                                <div className="qd-configure-integration-info__item">
                                                                    <label className='qd-configure-integration-info__label'>Datasource Name</label>
                                                                    <span className="qd-configure-integration-info__value">
                                                                        <i>
                                                                            <Database size={16} color="#A4A7AE" />
                                                                        </i>
                                                                        <RcTooltip
                                                                            placement="top"
                                                                            overlay={<span>{this.state.testConnectionFormData.datasource_name}</span>}
                                                                            arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                                                                        >
                                                                            <span>{this.state.testConnectionFormData.datasource_name}</span>
                                                                        </RcTooltip>
                                                                    </span>
                                                                </div>
                                                            )}
                                                        </div>
                                                        {/* Dynamically render fields from datasourceConfig.json */}
                                                        {this.renderIntegrationInfoFields()}
                                                        {/* Render Auth Method and Credential fields together */}
                                                        {this.renderCredentialFields()}
                                                        <hr className='tw-block tw-my-3' />
                                                        <div className="qd-configure-integration-info__action">
                                                        {/* Show error message if connection failed */}
                                                        {this.state.testConnectionError ? (
                                                            <div className="tw-flex tw-items-center tw-gap-2">
                                                                <button className="btn btn-sm btn-circle tw-border-[#FCA5A5] tw-bg-[#FEF2F2] tw-text-[#DC2626] tw-mr-3 !tw-px-2 hover:tw-text-[#DC2626] hover:!tw-shadow-none">
                                                                    {this.state.testConnectionError}
                                                                </button>
                                                                <button className="btn btn-sm btn-outline btn-circle btn-grey !tw-px-2" onClick={this.editDatasourceDetails}>Edit</button>
                                                            </div>
                                                        ) : (
                                                            <div className="tw-flex tw-items-center tw-justify-end tw-gap-3">
                                                                {getDatasourceStatus(this.state.ex_edit_integration_details?.auto_config_status || this.props.ex_integration_details?.auto_config_status || 'completed')}
                                                                <button className="tw-flex tw-items-center tw-rounded-full tw-border tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40] tw-bg-white dark:tw-bg-[#1E1E2D] tw-text-xs tw-pl-2 tw-pr-3 tw-py-[5px] tw-text-[#414651] dark:tw-text-[#B2B5BE] tw-font-medium hover:tw-text-[#414651] dark:hover:tw-text-[#B2B5BE] dark:tw-text-[#B2B5BE] hover:tw-border-[#D5D7DA] dark:hover:tw-border-[#2B2B40] dark:tw-border-[#2B2B40] hover:tw-bg-[#F4F5F5] dark:hover:tw-bg-[#2B2B40]" onClick={this.editDatasourceDetails}>
                                                                    <i className='tw-flex tw-items-center tw-justify-center tw-w-4 tw-h-4 tw-mr-1'><SquarePen size={12} color="#A4A7AE" /></i>
                                                                    Edit
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>
                                                    </div>
                                                </div>
                                                )}
                                            </div>
                                            {this.state.showSchemaConfigInfo && (
                                            <>
                                            <div className="vertical-stepper__heading !tw-pb-2 sm:!tw-pb-1">{/* Add this class for inactive state - vertical-stepper__heading--inactive */}
                                                <span className="vs-heading__circle">4</span>
                                                <div className="vs-heading__title-wrap">
                                                    <div className="vs-heading__title">{(this.state.formType === "azure_blob"|| this.state.formType ==='s3')? "Bucket & Mode Selection" : "Schema & Mode Selection"}</div>
                                                    {/* <p className='m-0'>Choose your schema scope and configuration mode</p> */}
                                                </div>
                                            </div>
                                            <div
                                                className={`vertical-stepper__content`}
                                                > 
                                                     <div id="qd-configure-integration-form-selection"
                                                // className={` ${
                                                //     this.state.showSchemaConfigInfo === null ? "" : "d-none"
                                                // }`}
                                                   className={` ${
                                                    (this.state.manualNextClicked === true) ||
                                                    (this.state.configurationMode === 'autoconfig' && this.state.specificSelect && this.state.schemaInfoConfirmed)
                                                        ? "d-none" : ""
                                                }`}
                                                
                                                >
                                                <div
                                                    className={`tw-border tw-border-solid tw-rounded-xl tw-p-4 tw-mb-4 transition-card ${
                                                    this.state.selected ? "border-primary shadow-sm" : "tw-border-[#E9EAEB] dark:tw-border-[#2B2B40]"
                                                    }`}
                                                >
                                                    {/* Top Card Body */}
                                                    <div className={`d-flex ${this.state.selected ? "tw-pb-4" : ""}`}>
                                                        <Form.Check 
                                                            custom
                                                            name='schema_mode_selection'
                                                            type={'radio'}
                                                            id={`allSchemas`}
                                                            value="allSchemas"
                                                            className="md:tw-mr-3"
                                                            checked={this.state.selected}
                                                            onChange={this.handleSchemaModeSelection}
                                                        />
                                                        <div>
                                                            <h5 className="tw-mb-1 tw-font-[400] tw-text-black">
                                                                <i className='tw-me-1'>
                                                                    <Layers2 size={16} color="#A4A7AE" />
                                                                </i>
                                                                {this.state.formType === "azure_blob"|| this.state.formType ==='s3' ? "All Buckets" : "All Schemas"}
                                                            </h5>
                                                            <p className="tw-mb-0 tw-text-[#535862] dark:tw-text-[#787B86] tw-text-xs">
                                                                {this.state.formType === "azure_blob"|| this.state.formType ==='s3'
                                                                    ? "Process all available buckets automatically"
                                                                    : "Process all available schemas automatically"}
                                                            </p>
                                                        </div>
                                                    </div>

                                                    {/* Expandable Section */}
                                                   
                                                    <div className={`integration-collapse-content ${this.state.selected ? "open tw-ps-5 md:tw-ps-8" : ""}`}>
                                                        {this.state.specificSelect === false ? <div className='md:tw-pe-8 tw-py-4 tw-border-0 tw-border-t tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40]'>
                                                            <Form.Label>Configuration Mode <span className="text-danger">*</span></Form.Label>
                                                            <div className='custom-control custom-radio xl:tw-flex pl-0'>
                                                                <label className="d-flex align-items-center tw-mr-8 tw-mb-0">
                                                                    <input 
                                                                        type="radio" 
                                                                        name="mode" 
                                                                        value="autoconfig"
                                                                        className="mr-2" 
                                                                        checked={this.state.configurationMode === 'autoconfig'}
                                                                        onChange={this.handleConfigurationModeChange}
                                                                    />
                                                                    Autoconfig <span className='tw-text-[#535862] dark:tw-text-[#787B86] tw-ms-1'>(Recommended)</span>
                                                                </label>
                                                                <label className={`d-flex align-items-center tw-mb-0 ${this.state.selected ? 'text-muted' : ''}`}>
                                                                    <input 
                                                                        type="radio" 
                                                                        className="mr-2" 
                                                                        disabled={true}
                                                                    />
                                                                Manual Config <span className='tw-ms-1 tw-hidden sm:tw-inline-block'>(Not available for {this.state.formType === "azure_blob"|| this.state.formType ==='s3' ? "All Buckets" : "All Schemas"})</span>                                                                </label>
                                                            </div>
                                                            
                                                        </div> : "" }
                                                    </div>
                                                </div>
                                                <div
                                                    className={`tw-border tw-border-solid tw-rounded-xl tw-p-4 transition-card ${
                                                    this.state.specificSelect ? "border-primary shadow-sm" : "tw-border-[#E9EAEB] dark:tw-border-[#2B2B40]"
                                                  
                                                    }`
                                                
                                                }
                                                >
                                                    {/* Top Card Body */}
                                                    <div className={`d-flex ${this.state.specificSelect ? "tw-pb-4" : ""}`}>
                                                        <Form.Check 
                                                            custom
                                                            type={'radio'}
                                                            id={`specificSchemas`}
                                                            name='schema_mode_selection'
                                                            value="specificSchemas"
                                                            className="md:tw-mr-3"
                                                            checked={this.state.specificSelect}
                                                            onChange={this.handleSchemaModeSelection}
                                                        />
                                                        <div>
                                                            <h5 className="tw-mb-1 tw-font-[400] tw-text-black">
                                                                <i className='tw-me-1'>
                                                                    <FolderOpen size={16} color="#A4A7AE" />
                                                                </i>
                                                                        Specified {this.state.formType === "azure_blob" || this.state.formType ==='s3'? "Buckets" : "Schemas"}
                                                            </h5>
                                                            <p className="tw-mb-0 tw-text-[#535862] dark:tw-text-[#787B86] tw-text-xs">Select specific {(this.state.formType === "azure_blob" || this.state.formType ==='s3') ? "buckets" : "schemas"} from your {(this.state.formType === "azure_blob" || this.state.formType ==='s3') ? "filesystem" : "database"} </p>
                                                        </div>
                                                    </div>

                                                    {/* Expandable Section */}
                                                    <div className={`integration-collapse-content ${this.state.specificSelect ? "open tw-ps-5 md:tw-ps-8" : ""}`}>
                                                       {this.state.specificSelect ?
                                                        <div className='md:tw-pe-8 tw-py-4 tw-border-0 tw-border-t tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40]'>
                                                            <button className={this.state.confirmedSchemas.length > 0 && this.state.testConnectionResponse?.schemas?.length > 0 ? "btn !tw-border-[#ABEFC6] tw-bg-[#F6FEF9] tw-text-black btn-block tw-mb-4 hover:!tw-shadow-none" : "btn btn-light btn-block tw-mb-4 hover:!tw-shadow-none"} onClick={this.handleShowSchemeModal}>{/* Replace this class "btn-light" to "!tw-border-[#ABEFC6] !tw-bg-[#F6FEF9] !tw-text-black" */}
                                                                <i className='tw-mr-1'>
                                                                    <FolderTree size={16} color="#A4A7AE" />
                                                                </i>
                                                            {this.state.confirmedSchemas.length > 0 && this.state.testConnectionResponse?.schemas?.length > 0 ? `${this.state.formType === "azure_blob"|| this.state.formType ==='s3' ? "Selected Bucket" : "Selected Schema"} (${this.state.confirmedSchemas.length})` : this.state.formType === "azure_blob" || this.state.formType ==='s3' ? "Fetch Available Buckets" : "Fetch Available Schemas"}                                                            
                                                            </button>
                                                            {this.state.schemaSelectionError && this.state.confirmedSchemas.length === 0 && <div className="text-danger tw-text-sm tw-mt-[-10px] tw-mb-4">{this.state.formType === "azure_blob" || this.state.formType === "s3" ? "Bucket is required" : "Schema is required"}</div>}
                                                            <div className='sm:tw-flex tw-items-center tw-justify-between'>
                                                                <div>
                                                                        <Form.Label className='tw-block'>Configuration Mode<span className="text-danger">*</span></Form.Label>                                                                    <div className='custom-control custom-radio xl:tw-flex pl-0'>
                                                                        <label className="d-flex align-items-center tw-mr-8 tw-mb-0">
                                                                            <input 
                                                                        type="radio" 
                                                                        name="mode" 
                                                                        value="autoconfig"
                                                                        className="mr-2" 
                                                                        checked={this.state.configurationMode === 'autoconfig'}
                                                                        onChange={this.handleConfigurationModeChange}
                                                                    />
                                                                            Autoconfig
                                                                        </label>
                                                                        <label className="d-flex align-items-center text-muted tw-mb-0">
                                                                            <input 
                                                                        type="radio" 
                                                                        name="mode"
                                                                        value="manual"
                                                                        className="mr-2"
                                                                        checked={this.state.configurationMode === 'manual'}
                                                                        onChange={this.handleConfigurationModeChange}
                                                                    />
                                                                            Manual Config
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                                
                                                            </div>
                                                        </div> :"" }
                                                    </div>
                                                </div> 
                                                {this.state.configurationMode === 'manual' && (
                                                    <div className='tw-flex tw-items-center tw-justify-end tw-my-4'>
                                                        <button
                                                            name="specifiedSchemasNext"
                                                            onClick={this.handleSchemaModeSelectionNext}
                                                            className='btn btn-outline-primary tw-mt-3 sm:tw-mt-0 tw-inline-flex tw-items-center'>
                                                            Continue Manual Configuration
                                                            <i className='tw-ms-1'>
                                                                <svg
                                                                    width="20"
                                                                    height="20"
                                                                    viewBox="0 0 20 20"
                                                                    fill="none"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    >
                                                                    <mask
                                                                        id="mask0_26824_209148"
                                                                        style={{ maskType: "alpha" }}
                                                                        maskUnits="userSpaceOnUse"
                                                                        x="0"
                                                                        y="0"
                                                                        width="20"
                                                                        height="20"
                                                                    >
                                                                        <rect width="20" height="20" fill="#D9D9D9" />
                                                                    </mask>

                                                                    <g mask="url(#mask0_26824_209148)">
                                                                        <path
                                                                        d="M11.6673 15L10.5007 13.7917L13.459 10.8333H3.33398V9.16667H13.459L10.5007 6.20833L11.6673 5L16.6673 10L11.6673 15Z"
                                                                        fill="currentColor"
                                                                        />
                                                                    </g>
                                                                    </svg>
                                                            </i>
                                                        </button>
                                                    </div>
                                                )}
                                                </div>
                                                {this.state.showSchemaConfigInfo && this.state.testConnectionResponse && this.state.confirmedSchemas.length > 0 && this.state.schemaInfoConfirmed && (
                                                    (this.state.configurationMode === 'manual' && this.state.manualNextClicked === true) ||
                                                    (this.state.configurationMode === 'autoconfig' && this.state.specificSelect)
                                                ) && (
                                                    <div className="qd-configure-integration-info" id="qd-configure-integration-info-manual-schema">
                                                        <div className="qd-configure-integration-info__content">
                                                            <div className="qd-configure-integration-info__list !tw-grid-cols-2">
                                                                <div className="qd-configure-integration-info__item">
                                                                    <label className='qd-configure-integration-info__label'>
                                                                        {`${this.state.schemaModeSelection === "allSchemas" ? "All" : "Specified"} ${(this.state.formType === "azure_blob" || this.state.formType === "s3") ? "Buckets" : "Schemas"}`}
                                                                    </label>
                                                                    <span className="qd-configure-integration-info__value">
                                                                        {this.state.schemaModeSelection === 'allSchemas' ? (
                                                                            <span className='tw-text-[#535862] dark:tw-text-[#787B86]'>{`Process all available ${this.state.formType === "azure_blob" || this.state.formType === "s3" ? "buckets" : "schemas"} automatically`}</span>
                                                                        ) : (
                                                                            <>
                                                                                {this.state.confirmedSchemas.length > 0 ? (
                                                                                    this.state.confirmedSchemas.map((schema, index) => (
                                                                                        <span key={index} className='tw-py-[2px] tw-px-2 tw-rounded-full tw-border tw-border-solid tw-border-[#C7D7FE] tw-bg-[#EEF4FF] tw-text-[#3538CD] tw-text-xs tw-font-medium tw-flex tw-items-center'>
                                                                                            <i className="tw-me-[2px]">
                                                                                                <FolderTree className="d-block" size={12} color="#175CD3" />
                                                                                            </i>
                                                                                            {schema}
                                                                                        </span>
                                                                                    ))
                                                                                ) : (
                                                                                    <span className='tw-text-[#535862] dark:tw-text-[#787B86]'>No schemas selected</span>
                                                                                )}
                                                                            </>
                                                                        )}
                                                                    </span>
                                                                </div>
                                                                <div className="qd-configure-integration-info__item">
                                                                    <label className='qd-configure-integration-info__label'>Configuration Mode</label>
                                                                    <span className="qd-configure-integration-info__value">
                                                                        <Form.Check 
                                                                            disabled={true}
                                                                            custom
                                                                            type={'radio'}
                                                                            id={`configMode_${this.state.configurationMode}`}
                                                                            label={this.state.configurationMode === 'autoconfig' ? 'Autoconfig' : 'Manual Config'}
                                                                            checked={true}
                                                                            className="mr-4"
                                                                        />
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <span className="tw-text-xs tw-text-[#6B7280] dark:tw-text-[#9CA3AF]  tw-italic">Note: Each Schema must have atleast one Integration</span>
                                                            <hr class="tw-block tw-my-3"></hr>
                                                            <div className="qd-configure-integration-info__action">
                                                                <div className='tw-flex tw-items-center tw-justify-end tw-gap-3'>
                                                                    <span className="tw-text-xs tw-text-[#6B7280] dark:tw-text-[#9CA3AF]"></span>
                                                                    {getDatasourceStatus(this.state.ex_edit_integration_details?.auto_config_status || this.props.ex_integration_details?.auto_config_status || 'completed')}
                                                                    <button className="tw-flex tw-items-center tw-rounded-full tw-border tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40] tw-bg-white dark:tw-bg-[#1E1E2D] tw-text-xs tw-pl-2 tw-pr-3 tw-py-[5px] tw-text-[#414651] dark:tw-text-[#B2B5BE] tw-font-medium hover:tw-text-[#414651] dark:hover:tw-text-[#B2B5BE] dark:tw-text-[#B2B5BE] hover:tw-border-[#D5D7DA] dark:hover:tw-border-[#2B2B40] dark:tw-border-[#2B2B40] hover:tw-bg-[#F4F5F5] dark:hover:tw-bg-[#2B2B40]" onClick={this.editSchemaAndModeSelection}>
                                                                        <i className='tw-flex tw-items-center tw-justify-center tw-w-4 tw-h-4 tw-mr-1'><SquarePen size={12} color="#A4A7AE" /></i>
                                                                        Edit
                                                                    </button>
                                                                    {/* <button className="btn btn-sm btn-circle tw-border-[#ABEFC6] tw-bg-[#ECFDF3] tw-text-[#067647] tw-mr-3 !tw-px-2 hover:tw-text-[#067647] hover:!tw-shadow-none">Completed</button>
                                                                    <button className="btn btn-sm btn-outline btn-circle btn-grey !tw-px-2" onClick={this.editSchemaAndModeSelection}>Edit</button> */}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                            </>
                                            )}
                                            {this.state.selectedSchemas.length > 0 && this.state.testConnectionSuccess && this.state.configurationMode === 'manual' && this.state.showSchemaConfigInfo && this.state.manualNextClicked && (
                                                <>
                                                    <div className="vertical-stepper__heading !tw-pb-2 sm:!tw-pb-1">{/* Add this class for inactive state - vertical-stepper__heading--inactive */}
                                                        <span className="vs-heading__circle">5</span>
                                                        <div className="vs-heading__title-wrap">
                                                            <div className="vs-heading__title">Manual Configuration Details</div>
                                                            {/* <p className='m-0'>Configure datasets and partitions for your selected schemas</p> */}
                                                        </div>
                                                    </div>
                                                    <div className="vertical-stepper__content">
                                                {this.state.integrationConfigurations.map((config, index) => (
                                                <div key={config.id} className='tw-border-2 tw-border-solid tw-border-[#9BCBFF] tw-px-4 tw-rounded-xl tw-mb-4' style={this.state.integrationValidationErrors?.[config.id] ? { borderColor: '#FDA29B' } : undefined}>
                                                    {/* <div className='tw-flex tw-items-center tw-justify-between tw-py-3 tw-border-0 tw-border-b tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40]'>
                                                        <div className='tw-flex tw-items-center tw-gap-2'>
                                                            <h5 className='tw-font-medium tw-text-black tw-m-0'>Integration configurations {index + 1}</h5>
                                                            <div className='tw-p-[6px] tw-rounded-lg tw-flex tw-items-center tw-justify-center tw-bg-[#2F6BD6]/10'>
                                                                <Pencil size={20} color="#A4A7AE" />
                                                            </div>
                                                        </div>
                                                        <div className='tw-flex tw-items-center tw-gap-2'>
                                                            <Form.Control
                                                                type="text"
                                                                className="form-control"
                                                                name="integration_name"
                                                                value="Integration configurations 1"
                                                            />
                                                            <div className='tw-p-[6px] tw-rounded-lg tw-flex tw-items-center tw-justify-center tw-bg-[#2F6BD6]/10'>
                                                                <Check size={20} color="#17B26A" />
                                                            </div>
                                                        </div>
                                                        {this.state.integrationConfigurations.length > 1 && (
                                                            <button type="button" className='tw-border-0 tw-bg-transparent text-primary' onClick={() => this.handleRemoveIntegration(config.id)}>
                                                                <Trash2 size={16} color="currentColor" className='mr-1' /><span className='tw-hidden sm:tw-inline-block'>Remove</span>
                                                            </button>
                                                        )}
                                                    </div> */}

                                                     <div className='tw-flex tw-items-center tw-justify-between tw-py-3 tw-border-0 tw-border-b tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40]'>
                                                        <div className='tw-flex tw-items-center tw-gap-2'>
                                                            {config.isExisting ? (
                                                                <h5 className='tw-font-medium tw-text-black dark:tw-text-[#B2B5BE] tw-m-0'>
                                                                    <FontAwesomeIcon icon={faDatabase} className='tw-mr-2' />
                                                                    {config.integrationName || `Integration configurations ${index + 1}`}
                                                                </h5>
                                                            ) : (
                                                                <>
                                                                    {(this.state.editingIntegrationId === config.id || (!config.integrationName || config.integrationName.trim() === '')) ? (
                                                                        <>
                                                                            <div>
                                                                                <Form.Control
                                                                                    type="text"
                                                                                    autoFocus
                                                                                    className={
                                                                                        (!config.integrationName || config.integrationName.trim() === '' || this.isDuplicateIntegrationName(config.integrationName, config.id)) 
                                                                                            ? "form-control is-invalid" 
                                                                                            : "form-control"
                                                                                    }
                                                                                    name="integration_name"
                                                                                    value={config.integrationName || ''}
                                                                                    placeholder="Enter Integration Name"
                                                                                    onChange={(e) => this.handleIntegrationNameChange(config.id, e.target.value)}
                                                                                    onKeyDown={(e) => {
                                                                                        if (e.key === 'Enter') {
                                                                                            e.preventDefault();
                                                                                            this.handleSaveIntegrationName(config.id);
                                                                                        }
                                                                                    }}
                                                                                    onBlur={() => this.handleSaveIntegrationName(config.id)}
                                                                                    required
                                                                                />
                                                                                {this.isDuplicateIntegrationName(config.integrationName, config.id) && (
                                                                                    <div className="error-text">Integration with this name already exists.</div>
                                                                                )}
                                                                                {(!config.integrationName || config.integrationName.trim() === '') && (
                                                                                    <div className="error-text">Integration Name is required field</div>
                                                                                )}
                                                                            </div>
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <h5 className='tw-font-medium tw-text-black dark:tw-text-[#B2B5BE] tw-m-0'>
                                                                                <FontAwesomeIcon icon={faDatabase} className='tw-mr-2' />
                                                                                {config.integrationName || `Integration configurations ${index + 1}`}
                                                                            </h5>
                                                                            <div className={`tw-p-[6px] tw-rounded-lg tw-flex tw-items-center tw-justify-center tw-bg-[#2F6BD6]/10 ${(this.state.editingIntegrationId && (() => { const eCfg = this.state.integrationConfigurations.find(c => c.id === this.state.editingIntegrationId); return eCfg && (!eCfg.integrationName || eCfg.integrationName.trim() === '' || this.isDuplicateIntegrationName(eCfg.integrationName, eCfg.id)); })()) ? 'tw-opacity-50 tw-cursor-not-allowed' : 'cursor-pointer'}`} onClick={() => {
                                                                                const eCfg = this.state.integrationConfigurations.find(c => c.id === this.state.editingIntegrationId);
                                                                                const isEditingInvalid = eCfg && (!eCfg.integrationName || eCfg.integrationName.trim() === '' || this.isDuplicateIntegrationName(eCfg.integrationName, eCfg.id));
                                                                                if (!isEditingInvalid) {
                                                                                    this.handleEditIntegrationName(config.id, config.integrationName || `Integration configurations ${index + 1}`);
                                                                                }
                                                                            }}>
                                                                                <Pencil size={20} color="#A4A7AE" />
                                                                            </div>
                                                                        </>
                                                                    )}
                                                                </>
                                                            )}
                                                        </div>
                                                        {this.state.integrationConfigurations.length > 1 && (
                                                            <button type="button" className='tw-border-0 tw-bg-transparent text-primary' onClick={() => this.handleRemoveIntegration(config.id)}>
                                                                <Trash2 size={16} color="currentColor" className='mr-1' /><span className='tw-hidden sm:tw-inline-block'>Remove</span>
                                                            </button>
                                                        )}
                                                    </div>
                                                    <div className={`tw-py-4 ${config.isExisting ? 'tw-pointer-events-none' : ''}`}>
                                                        <div class="row">
                                                            <div className="col-md-6 !tw-border-0">
                                                                <Form.Label>{this.state.formType === 'azure_blob'|| this.state.formType ==='s3' || this.state.formType === 'azure_data_lake_gen2' ? 'Select Bucket' : 'Select Schema'} <span className='text-primary'>*</span></Form.Label>
                                                                <Select isDisabled={config.isExisting}
                                                                    id={`select_schema_${config.id}`}
                                                                    options={(() => {
                                                                        const isAzureBlob = this.state.formType === 'azure_blob'|| this.state.formType ==='s3' || this.state.formType === 'azure_data_lake_gen2';
                                                                        const sourceSchemas = this.state.schemaModeSelection === 'allSchemas'
                                                                            ? (this.state.testConnectionResponse?.schemas || [])
                                                                            : this.state.selectedSchemas;
                                                                        if (isAzureBlob) {
                                                                            // For Azure Blob, any bucket can be reused across integrations (different sub_paths)
                                                                            return sourceSchemas.map(schema => ({ label: schema, value: schema }));
                                                                        }
                                                                        const schemasWithAllDatasets = this.getSchemasWithAllDatasetsIntegration(config.id);
                                                                        const usedInOtherConfigs = new Set(
                                                                            this.state.integrationConfigurations
                                                                                .filter(c => c.id !== config.id && c.datasetScope === 'allDatasets' && c.schema)
                                                                                .map(c => c.schema)
                                                                        );
                                                                        return sourceSchemas
                                                                            .filter(s => !schemasWithAllDatasets.has(s) && !usedInOtherConfigs.has(s))
                                                                            .map(schema => ({ label: schema, value: schema }));
                                                                    })()}
                                                                    placeholder={this.state.formType === 'azure_blob'|| this.state.formType ==='s3' || this.state.formType === 'azure_data_lake_gen2' ? 'Select Bucket' : 'Select Schema'}
                                                                    value={config.schema ? { label: config.schema, value: config.schema } : null}
                                                                    onChange={(selectedOption) => this.handleSchemaSelectForConfig(config.id, selectedOption)}
                                                                    classNamePrefix='select-control'
                                                                    components={{ Control: customSelectSchema }}
                                                                />
                                                                {this.state.integrationValidationErrors[config.id]?.schema && (
                                                                    <div className="error-text mt-1">{this.state.integrationValidationErrors[config.id].schema}</div>
                                                                )}
                                                            </div>
                                                        </div>
                                                        {(this.state.formType === 'azure_blob'|| this.state.formType ==='s3' || this.state.formType === 'azure_data_lake_gen2') && (
                                                        <div class="row tw-mt-3">
                                                            <Form.Group className="col-md-6 !tw-border-0">
                                                                <Form.Label>Subpath</Form.Label>
                                                                <div className="icon-input-group">
                                                                    <i><FolderOpen size={18} color="#A4A7AE" /></i>
                                                                    <Form.Control
                                                                        type="text"
                                                                        name="sub_path"
                                                                        placeholder="Enter subpath"
                                                                        value={config.sub_path || ""}
                                                                        onChange={(e) => this.handleIntegrationConfigFieldChange(config.id, 'sub_path', e.target.value)}
                                                                    />
                                                                </div>
                                                            </Form.Group>
                                                        </div>
                                                        )}
                                                                    {this.state.formType !== 'azure_blob' && this.state.formType !== 's3' && this.state.formType !== 'azure_data_lake_gen2' &&  (
                                                        <>
                                                        <hr className='tw-my-3 tw-border-0 tw-border-b tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40]' />
                                                        <div class="row">
                                                            <Form.Group className="col-md-6 !tw-border-0">
                                                                <Form.Label>Dataset Scope</Form.Label>
                                                                <div>
  <div className="custom-control custom-radio custom-control-inline mt-1">
    <input
      type="radio"
      id={`allDataset_${config.id}`}
      name={`datasetGroup_${config.id}`}
      value="allDatasets"
      checked={config.datasetScope === "allDatasets"}
      onChange={() => this.handleDatasetScopeChange(config.id, 'allDatasets')}
      className="custom-control-input"
    />
    <Form.Label className="custom-control-label" htmlFor={`allDataset_${config.id}`}>
      All Datasets
    </Form.Label>
  </div>

  <div className="custom-control custom-radio custom-control-inline mt-1">
    <input
      type="radio"
      id={`specifiedDataset_${config.id}`}
      name={`datasetGroup_${config.id}`}
      value="specifiedDatasets"
      checked={config.datasetScope === "specifiedDatasets"}
      onChange={() => this.handleDatasetScopeChange(config.id, 'specifiedDatasets')}
      className="custom-control-input"
    />
    <Form.Label className="custom-control-label" htmlFor={`specifiedDataset_${config.id}`}>
      Specified Datasets
    </Form.Label>
  </div>
</div>

                                                            </Form.Group>
                                                        </div>
                                                        <div className="tw-mb-4 tw-p-3 sm:tw-p-4 tw-border tw-border-solid tw-border-[#D5D7DA] dark:tw-border-[#2B2B40] tw-rounded-lg tw-bg-[#FAFAFA] dark:tw-bg-[#161622]">
                                                            <div className='sm:tw-flex tw-items-center tw-justify-between'>
                                                                <div>
                                                                    <h5 className='tw-text-sm tw-font-medium tw-text-[#334DB7] tw-m-0'>
                                                                        Add Incremental Data Identification
                                                                        {config.datasetScope === 'specifiedDatasets' && <span className='text-danger'> *</span>}
                                                                        {config.datasetScope === 'allDatasets' && <span className='tw-text-[#6B7280]'> (Optional)</span>}
                                                                    </h5>
                                                                    <p className='tw-text-xs tw-text-[#546AC3] tw-m-0'>
                                                                        {config.datasetScope === 'specifiedDatasets' ? 'Required for specified datasets' : 'Configure incremental loading (Optional)'}
                                                                    </p>
                                                                </div>
                                                                <button type="button" className="btn tw-mt-3 sm:tw-mt-0 tw-font-semibold tw-border-0 tw-bg-[#E6E9F6] tw-text-[#334DB7] tw-whitespace-nowrap hover:tw-bg-[#D2D7EF] hover:tw-text-[#334DB7]" onClick={() => this.handleAddIncrementalData(config.id)}>
                                                                    <Plus size={18} color="#8A99D6" className='mr-1' />Add Row
                                                                </button>
                                                            </div>
                                                            <div className={`integration-collapse-content ${config.incrementalData.length > 0 ? "open" : ""}`}>
                                                                {config.incrementalData.map((incrementalItem, incrementalIndex) => (
                                                                <div key={incrementalItem.id} className="dataset-partition-card" style={this.state.integrationValidationErrors?.[config.id]?.datasets?.[incrementalItem.id] ? { border: '1px solid #FDA29B' } : undefined}>
                                                                    <div className='dp-card__head'>
                                                                        <span class="dp-card__label">Incremental Data {incrementalIndex + 1}</span>
                                                                        <button type="button" className='tw-border-0 tw-bg-transparent text-primary' onClick={() => this.handleRemoveIncrementalData(config.id, incrementalItem.id)}>
                                                                            <Trash2 size={16} color="currentColor" className='mr-1' /><span className='tw-hidden sm:tw-inline-block'>Remove</span>
                                                                        </button>
                                                                    </div>
                                                                    <hr className='tw-border-0 tw-border-b tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40] tw-m-0' />
                                                                    <div class="dp-card__content">
                                                                        <div class="form-row">                                                                            
                                                                            <div class="form-group col-md-6 col-lg-4">
                                                                                <label>
                                                                                    Dataset Name <span class="text-danger">*</span>
                                                                                    <span class="tooltip">
                                                                                        <i><img class="ml-1" width="16px" src="icon_info_circle" alt='' /></i>
                                                                                    </span>
                                                                                </label>
                                                                                <div class="icon-input-group">
                                                                                    <i>
                                                                                        <Layers size={18} color="#A4A7AE" />
                                                                                    </i>
                                                                                    <Form.Control
                                                                                        type="text"
                                                                                        className={(!incrementalItem.datasetName || incrementalItem.datasetName.trim() === '') ? "form-control is-invalid" : this.isDatasetAssignedToAnotherIntegration(config, incrementalItem) ? "form-control is-invalid" : "form-control"}
                                                                                        name="dataset_name"
                                                                                        placeholder="Dataset Name"
                                                                                        value={incrementalItem.datasetName}
                                                                                        onChange={(e) => this.handleIncrementalDataFieldChange(config.id, incrementalItem.id, 'datasetName', e.target.value)}
                                                                                    />
                                                                                </div>
                                                                                {(!incrementalItem.datasetName || incrementalItem.datasetName.trim() === '') && (
                                                                                    <div class="error-text">Dataset Name is required field</div>
                                                                                )}
                                                                                {incrementalItem.datasetName && incrementalItem.datasetName.trim() !== '' && this.isDatasetAssignedToAnotherIntegration(config, incrementalItem) && (
                                                                                    <div class="error-text">Dataset Name "{incrementalItem.datasetName}" is already associated with another integration in this schema</div>
                                                                                )}
                                                                                {this.state.integrationValidationErrors[config.id]?.datasets?.[incrementalItem.id] && (
                                                                                    <div class="error-text">{this.state.integrationValidationErrors[config.id].datasets[incrementalItem.id]}</div>
                                                                                )}
                                                                                <Form.Text className="text-muted">
                                                                                    <Form.Check
                                                                                        custom
                                                                                        type="checkbox"
                                                                                        label="Exact match only"
                                                                                        id={`exact-match_${config.id}_${incrementalItem.id}`}
                                                                                        checked={incrementalItem.exactMatch}
                                                                                        onChange={(e) => this.handleExactMatchChange(config.id, incrementalItem.id, e.target.checked)}
                                                                                    />
                                                                                </Form.Text>
                                                                            </div>                                                                            
                                                                            <div class="form-group col-md-6 col-lg-4">
                                                                                <label>Incremental Data Identifier {config.datasetScope !== 'specifiedDatasets' && <span className="text-danger">*</span>}</label>
                                                                                <div class="icon-input-group">
                                                                                    <i>
                                                                                        <HardDrive size={18} color="#A4A7AE" />
                                                                                    </i>
                                                                                    <Form.Control
                                                                                        type="text"
                                                                                        className={(config.datasetScope !== 'specifiedDatasets' && (!incrementalItem.identifier || incrementalItem.identifier.trim() === '')) ? "form-control is-invalid" : "form-control"}
                                                                                        name="incremental_identifier"
                                                                                        placeholder="Incremental data identifier"
                                                                                        value={incrementalItem.identifier}
                                                                                        onChange={(e) => this.handleIncrementalDataFieldChange(config.id, incrementalItem.id, 'identifier', e.target.value)}
                                                                                    />
                                                                                </div>
                                                                                {(config.datasetScope !== 'specifiedDatasets' && (!incrementalItem.identifier || incrementalItem.identifier.trim() === '')) && (
                                                                                    <div className="error-text">Incremental Data Identifier is required field</div>
                                                                                )}
                                                                            </div>                                                                
                                                                            <div class="form-group col-md-6 col-lg-4">
                                                                                <div className="custom-control custom-checkbox mb-2">
                                                                                    <Form.Control
                                                                                        id={`start_index_check_box_${config.id}_${incrementalItem.id}`}
                                                                                        type="checkbox"
                                                                                        checked={incrementalItem.startingIndexCheckbox}
                                                                                        className="custom-control-input"
                                                                                        onChange={(e) => this.handleStartingIndexCheckbox(config.id, incrementalItem.id, e.target.checked)}
                                                                                    />
                                                                                    <Form.Label className="custom-control-label" htmlFor={`start_index_check_box_${config.id}_${incrementalItem.id}`}>
                                                                                        Starting Index (Optional)
                                                                                    </Form.Label>
                                                                                </div>
                                                                                <div>
                                                                                    <div className="custom-control custom-radio">
                                                                                        <input
                                                                                            type="radio"
                                                                                            className="custom-control-input"
                                                                                            id={`radio_by_value_${config.id}_${incrementalItem.id}`}
                                                                                            name={`start_index_${config.id}_${incrementalItem.id}`}
                                                                                            value="incremental data identifier"
                                                                                            checked={incrementalItem.startingIndexType === 'incremental data identifier'}
                                                                                            disabled={!incrementalItem.startingIndexCheckbox}
                                                                                            onChange={() => this.handleStartingIndexTypeChange(config.id, incrementalItem.id, 'incremental data identifier')}
                                                                                        />
                                                                                        <label className="custom-control-label" htmlFor={`radio_by_value_${config.id}_${incrementalItem.id}`}>
                                                                                            By Value
                                                                                        </label>
                                                                                    </div>
                                                                                    <div className="custom-control custom-radio">
                                                                                        <input
                                                                                            type="radio"
                                                                                            className="custom-control-input"
                                                                                            id={`radio_by_query_${config.id}_${incrementalItem.id}`}
                                                                                            name={`start_index_${config.id}_${incrementalItem.id}`}
                                                                                            value="custom query"
                                                                                            checked={incrementalItem.startingIndexType === 'custom query'}
                                                                                            disabled={!incrementalItem.startingIndexCheckbox}
                                                                                            onChange={() => this.handleStartingIndexTypeChange(config.id, incrementalItem.id, 'custom query')}
                                                                                        />
                                                                                        <label className="custom-control-label" htmlFor={`radio_by_query_${config.id}_${incrementalItem.id}`}>
                                                                                            By Query
                                                                                        </label>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            {incrementalItem.startingIndexCheckbox && incrementalItem.startingIndexType === 'incremental data identifier' && (
                                                                            <Form.Group className="col-md-6 col-lg-4">
                                                                                <Form.Label>Starting Index Value</Form.Label>
                                                                                <Form.Control
                                                                                    type="text"
                                                                                    className={(!incrementalItem.startingIndexValue || incrementalItem.startingIndexValue.trim() === '') ? "form-control is-invalid" : "form-control"}
                                                                                    name="start_index_value"
                                                                                    placeholder="Starting Index Value"
                                                                                    value={incrementalItem.startingIndexValue}
                                                                                    onChange={(e) => this.handleIncrementalDataFieldChange(config.id, incrementalItem.id, 'startingIndexValue', e.target.value)}
                                                                                />
                                                                                {(!incrementalItem.startingIndexValue || incrementalItem.startingIndexValue.trim() === '') && (
                                                                                    <div class="error-text">Starting Index Value is required field</div>
                                                                                )}
                                                                            </Form.Group>
                                                                            )}
                                                                            {incrementalItem.startingIndexCheckbox && incrementalItem.startingIndexType === 'custom query' && (
                                                                            <Form.Group className="col-md-12 col-lg-8">
                                                                                <Form.Label>Starting Index Query</Form.Label>
                                                                                <Form.Control
                                                                                    as="textarea"
                                                                                    rows={2}
                                                                                    name="start_index_query"
                                                                                    className={(!incrementalItem.startingIndexQuery || incrementalItem.startingIndexQuery.trim() === '') ? "form-control is-invalid" : "form-control"}
                                                                                    placeholder="Starting Index Query"
                                                                                    value={incrementalItem.startingIndexQuery}
                                                                                    onChange={(e) => this.handleIncrementalDataFieldChange(config.id, incrementalItem.id, 'startingIndexQuery', e.target.value)}
                                                                                />
                                                                                {(!incrementalItem.startingIndexQuery || incrementalItem.startingIndexQuery.trim() === '') && (
                                                                                    <div class="error-text">Starting Index query is required field</div>
                                                                                )}
                                                                                <Form.Text className="text-muted"><strong className="mr-1">Note:</strong>This query will be used for Starting Index.</Form.Text>
                                                                            </Form.Group>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                            {this.state.integrationValidationErrors[config.id]?.incrementalDataRequired && (
                                                                <div className="error-text tw-px-3 sm:tw-px-4 tw-mt-2 tw-mb-2">{this.state.integrationValidationErrors[config.id].incrementalDataRequired}</div>
                                                            )}
                                                        <div className="tw-p-3 sm:tw-p-4 tw-border tw-border-solid tw-border-[#D5D7DA] dark:tw-border-[#2B2B40] tw-rounded-lg tw-bg-[#FAFAFA] dark:tw-bg-[#161622]">
                                                            <div className='sm:tw-flex tw-items-center tw-justify-between'>
                                                                <div>
                                                                    <h5 className='tw-text-sm tw-font-medium tw-text-[#334DB7] tw-m-0'>Add Partitions</h5>
                                                                    <p className='tw-text-xs tw-text-[#546AC3] tw-m-0'>Configure partioning dataset.</p>
                                                                </div>
                                                                <button type="button" className="btn tw-mt-3 sm:tw-mt-0 tw-font-semibold tw-border-0 tw-bg-[#E6E9F6] tw-text-[#334DB7] tw-whitespace-nowrap hover:tw-bg-[#D2D7EF] hover:tw-text-[#334DB7]" onClick={() => this.handleAddPartitionToConfig(config.id)}>
                                                                    <Plus size={18} color="#8A99D6" className='mr-1' />Add Row
                                                                </button>
                                                            </div>
                                                            <div className={`integration-collapse-content ${config.partitions.length > 0 ? "open" : ""}`}>
                                                                {config.partitions.map((partition, partitionIndex) => (
                                                                <div key={partition.id} class="dataset-partition-card">
                                                                    <div className='dp-card__head'>
                                                                        <span class="dp-card__label">Partition {partitionIndex + 1}</span>
                                                                        <button type="button" className='tw-border-0 tw-bg-transparent text-primary' onClick={() => this.handleRemovePartition(config.id, partition.id)}>
                                                                            <Trash2 size={16} color="currentColor" className='mr-1' /><span className='tw-hidden sm:tw-inline-block'>Remove</span>
                                                                        </button>
                                                                    </div>
                                                                    <hr className='tw-border-0 tw-border-b tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40] tw-m-0' />
                                                                    <div class="dp-card__content">
                                                                        <div class="form-row">                                                                            
                                                                            <Form.Group className="col-md-6 col-lg-4">
                                                                                <Form.Label>{config.datasetScope === 'allDatasets' ? 'Dataset Name' : 'Select Dataset'}</Form.Label>
                                                                                {config.datasetScope === 'allDatasets' ? (
                                                                                    <Form.Control
                                                                                        type="text"
                                                                                        className={(!partition.datasetName || partition.datasetName.trim() === '') ? "form-control is-invalid" : "form-control"}
                                                                                        name="dataset_name"
                                                                                        placeholder="Dataset Name"
                                                                                        value={partition.datasetName || ''}
                                                                                        onChange={(e) => this.handlePartitionFieldChange(config.id, partition.id, 'datasetName', e.target.value)}
                                                                                    />
                                                                                ) : null}
                                                                                {config.datasetScope === 'specifiedDatasets' ? (
                                                                                    <Select
                                                                                        name="dataset_name"
                                                                                        classNamePrefix={(!partition.datasetName || partition.datasetName.trim() === '') ? 'select-control is-invalid' : 'select-control'}
                                                                                        options={
                                                                                            this.getDatasetsForPartitionOptions(config, partition)
                                                                                        }
                                                                                        placeholder={
                                                                                            (config.incrementalData || []).length === 0
                                                                                                ? "Add Incremental Data first"
                                                                                                : "Dataset"
                                                                                        }
                                                                                        isDisabled={(config.incrementalData || []).length === 0}
                                                                                        value={partition.datasetName ? { label: partition.datasetName, value: partition.datasetName } : null}
                                                                                        onChange={(selectedOption) => this.handlePartitionFieldChange(config.id, partition.id, 'datasetName', selectedOption?.value || '')}
                                                                                        components={{ Control: customSelectDataset }}
                                                                                        styles={{
                                                                                            control: (base, state) => ({
                                                                                                ...base,
                                                                                                ...(state.isDisabled && (!partition.datasetName || partition.datasetName.trim() === '') ? { fontSize: '11px' } : {})
                                                                                            })
                                                                                        }}
                                                                                    />
                                                                                ) : null}
                                                                                {(!partition.datasetName || partition.datasetName.trim() === '') && (
                                                                                    <div className="error-text">Dataset Name is required field</div>
                                                                                )}
                                                                            </Form.Group>                                                              
                                                                            <Form.Group className="col-md-6 col-lg-4">
                                                                                <Form.Label>Partition Name</Form.Label>
                                                                                <div class="icon-input-group">
                                                                                    <i>
                                                                                        <svg width="18" height="18" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                            <g clip-path="url(#clip0_26832_241553)">
                                                                                            <path d="M1.33464 10.668C1.70249 10.669 1.9993 10.9681 1.9987 11.3359L6.66927 13.4596C6.68835 13.8731 6.80116 14.2621 6.98763 14.6055C7.02875 14.6812 7.07374 14.7545 7.12175 14.8255C7.23043 14.9864 7.35652 15.1343 7.49675 15.2676C7.38779 15.2391 7.28089 15.2023 7.17774 15.1556L7.17709 15.1549L1.44336 12.5482L1.43946 12.5469C1.20812 12.4398 1.01206 12.2683 0.875003 12.0534C0.737984 11.8384 0.66544 11.5883 0.666019 11.3333C0.66693 10.9651 0.966453 10.6671 1.33464 10.668Z" fill="#A4A7AE"/>
                                                                                            <path d="M1.33464 7.33464C1.70249 7.33571 1.9993 7.63478 1.9987 8.0026L7.66602 10.5794V11.2552C7.46838 11.4137 7.29376 11.5999 7.14779 11.8079L1.44336 9.21484L1.43946 9.21354C1.20812 9.10648 1.01206 8.93497 0.875003 8.72005C0.737984 8.50507 0.66544 8.25493 0.666019 8C0.66693 7.63181 0.966453 7.33373 1.33464 7.33464Z" fill="#A4A7AE"/>
                                                                                            <path d="M7.99935 0.667969C8.28574 0.667969 8.56887 0.729456 8.82943 0.848307L8.82878 0.848958L14.5553 3.45508C14.789 3.55966 14.9877 3.72879 15.1276 3.94336C15.2687 4.15983 15.3437 4.41286 15.3438 4.67122C15.3437 4.92969 15.2687 5.1832 15.1276 5.39974C14.9878 5.6142 14.7883 5.7828 14.5547 5.88737L14.5553 5.88867L12.6335 6.76172C12.3535 6.83762 12.0921 6.95782 11.8568 7.11458L10.8177 7.58659C10.5786 7.11122 10.1211 6.76654 9.57487 6.68685L14.0104 4.67122L14.0033 4.66862L8.2767 2.06185L8.27604 2.0612C8.18921 2.0216 8.09479 2.0013 7.99935 2.0013C7.90391 2.0013 7.80949 2.0216 7.72266 2.0612L7.72201 2.06185L2.00196 4.66471L7.72917 7.27474C7.81398 7.31342 7.90619 7.33368 7.99935 7.33464C7.7901 7.6132 7.66602 7.95941 7.66602 8.33464V8.63867C7.4973 8.60958 7.33235 8.55969 7.17578 8.48828L1.45638 5.88151C1.22317 5.77693 1.02447 5.6074 0.884769 5.39323C0.743577 5.17666 0.668655 4.92324 0.668623 4.66471C0.668654 4.40628 0.743669 4.15337 0.884769 3.93685C1.02453 3.72248 1.22295 3.55252 1.45638 3.44792L7.16927 0.848958C7.42983 0.730108 7.71297 0.66797 7.99935 0.667969Z" fill="#A4A7AE"/>
                                                                                            <path d="M13.9994 9.33464C13.9994 8.96645 13.7009 8.66797 13.3327 8.66797C12.9645 8.66797 12.666 8.96645 12.666 9.33464C12.666 9.70283 12.9645 10.0013 13.3327 10.0013C13.7009 10.0013 13.9994 9.70283 13.9994 9.33464ZM8.66602 13.3346C8.66602 13.7028 8.9645 14.0013 9.33269 14.0013C9.70088 14.0013 9.99936 13.7028 9.99936 13.3346C9.99936 12.9664 9.70088 12.668 9.33269 12.668C8.9645 12.668 8.66602 12.9664 8.66602 13.3346ZM14.666 9.33464C14.666 9.9609 14.2341 10.4858 13.652 10.6289C13.5832 11.4051 13.2451 12.1364 12.6898 12.6917C12.1344 13.2471 11.4031 13.5852 10.627 13.654C10.4838 14.2361 9.95895 14.668 9.33269 14.668C8.59631 14.668 7.99936 14.071 7.99936 13.3346C7.99936 12.7134 8.42428 12.1913 8.99936 12.0433V8.33464C8.99936 8.15054 9.14859 8.0013 9.33269 8.0013C9.51678 8.0013 9.66602 8.15054 9.66602 8.33464V12.0433C10.1292 12.1625 10.4947 12.5244 10.6195 12.9854C11.2212 12.9203 11.7864 12.6524 12.2184 12.2204C12.6505 11.7884 12.9183 11.2232 12.9834 10.6214C12.4165 10.4679 11.9994 9.95013 11.9994 9.33464C11.9994 8.59826 12.5963 8.0013 13.3327 8.0013C14.0691 8.0013 14.666 8.59826 14.666 9.33464Z" fill="#A4A7AE"/>
                                                                                            </g>
                                                                                            <defs>
                                                                                            <clipPath id="clip0_26832_241553">
                                                                                            <rect width="16" height="16" fill="white"/>
                                                                                            </clipPath>
                                                                                            </defs>
                                                                                            </svg>
                                                                                    </i>
                                                                                    <Form.Control
                                                                                        type="text"
                                                                                        className={(!partition.partitionName || partition.partitionName.trim() === '') ? "form-control is-invalid" : "form-control"}
                                                                                        name="partition_name"
                                                                                        placeholder="Partition Name"
                                                                                        value={partition.partitionName}
                                                                                        onChange={(e) => this.handlePartitionFieldChange(config.id, partition.id, 'partitionName', e.target.value)}
                                                                                    />
                                                                                </div>
                                                                                {(!partition.partitionName || partition.partitionName.trim() === '') && (
                                                                                    <div className="error-text">Partition Name is required field</div>
                                                                                )}
                                                                            </Form.Group>
                                                                            <Form.Group className="col-md-6 col-lg-4">
                                                                                <Form.Label className='d-block'>Partition By</Form.Label>
                                                                                <div className="custom-control custom-radio custom-control-inline mt-1">
                                                                                    <Form.Control
                                                                                        type="radio"
                                                                                        className="custom-control-input"
                                                                                        id={`partitionByColumn_${config.id}_${partition.id}`}
                                                                                        name={`partitionBy_${config.id}_${partition.id}`}
                                                                                        value="Column"
                                                                                        checked={partition.partitionBy === 'Column' || partition.partitionBy === undefined}
                                                                                        onChange={() => this.handlePartitionByChange(config.id, partition.id, 'Column')}
                                                                                    />
                                                                                    <Form.Label className="custom-control-label" htmlFor={`partitionByColumn_${config.id}_${partition.id}`}>
                                                                                        Column
                                                                                    </Form.Label>
                                                                                </div>
                                                                                <div className="custom-control custom-radio custom-control-inline mt-1">
                                                                                    <Form.Control
                                                                                        type="radio"
                                                                                        className="custom-control-input"
                                                                                        id={`partitionByCustom_${config.id}_${partition.id}`}
                                                                                        name={`partitionBy_${config.id}_${partition.id}`}
                                                                                        value="Custom Query"
                                                                                        checked={partition.partitionBy === 'Custom Query'}
                                                                                        onChange={() => this.handlePartitionByChange(config.id, partition.id, 'Custom Query')}
                                                                                    />
                                                                                    <Form.Label className="custom-control-label" htmlFor={`partitionByCustom_${config.id}_${partition.id}`}>
                                                                                        Custom Query
                                                                                    </Form.Label>
                                                                                </div>
                                                                            </Form.Group>
                                                                            {(partition.partitionBy === 'Column' || partition.partitionBy === undefined) && (
                                                                            <Form.Group className="col-md-6 col-lg-4">
                                                                                <Form.Label>Partition Identifier</Form.Label>
                                                                                <div class="icon-input-group">
                                                                                    <i>
                                                                                        <TextSearch size={18} color="#A4A7AE" />
                                                                                    </i>
                                                                                    <Form.Control
                                                                                        type="text"
                                                                                        className={(!partition.partitionIdentifier || partition.partitionIdentifier.trim() === '') ? "form-control is-invalid" : "form-control"}
                                                                                        name="partition_identifier"
                                                                                        placeholder="Partition Identifier"
                                                                                        value={partition.partitionIdentifier}
                                                                                        onChange={(e) => this.handlePartitionFieldChange(config.id, partition.id, 'partitionIdentifier', e.target.value)}
                                                                                    />
                                                                                </div>
                                                                                {(!partition.partitionIdentifier || partition.partitionIdentifier.trim() === '') && (
                                                                                    <div className="error-text">Partition Identifier is required field</div>
                                                                                )}
                                                                            </Form.Group>
                                                                            )}
                                                                            {partition.partitionBy === 'Custom Query' && (
                                                                            <Form.Group className="col-md-12 col-lg-8">
                                                                                <Form.Label>Custom Query</Form.Label>
                                                                                <Form.Control
                                                                                    as="textarea"
                                                                                    rows={2}
                                                                                    name="custom_query"
                                                                                    className={(!partition.customQuery || partition.customQuery.trim() === '') ? "form-control is-invalid" : "form-control"}
                                                                                    placeholder="Enter your custom query here..."
                                                                                    value={partition.customQuery}
                                                                                    onChange={(e) => this.handlePartitionFieldChange(config.id, partition.id, 'customQuery', e.target.value)}
                                                                                />
                                                                                {(!partition.customQuery || partition.customQuery.trim() === '') && (
                                                                                    <div className="error-text">Custom Query is required field</div>
                                                                                )}
                                                                                <Form.Text className="text-muted"><strong className="mr-1">Note:</strong>This query will be used to partition and monitor the Dataset.</Form.Text>
                                                                            </Form.Group>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                        </>
                                                        )}
                                                    </div>
                                                </div>
                                                ))}
                                                <button type="button" id="datasource-add-integrations-button" className="btn tw-font-semibold tw-border tw-border-solid tw-border-[#B0BAE3] tw-bg-transparent tw-text-[#334DB7] tw-mb-4 hover:tw-bg-[#E6E9F6] hover:tw-text-[#334DB7]" onClick={this.handleAddIntegration}>
                                                    <Plus size={18} color="currentColor" className='mr-1' />Add Integrations
                                                </button>
                                            </div>
                                                </>
                                            )}
                                            <div className="vertical-stepper__heading !tw-pt-4 sm:!tw-pt-8">
                                                <div className={"d-flex align-items-center tw-pl-1"}>
                                                    <Form.Check 
                                                        custom
                                                        type={'checkbox'}
                                                        id={`storeData`}
                                                        className="tw-mr-2 md:tw-mr-4"
                                                        checked={true}
                                                        readOnly
                                                        aria-readonly="true"
                                                    />
                                                    <div>
                                                        <h5 className="tw-mb-1 tw-font-[400] tw-text-black">Store Data Issues and Errors</h5>
                                                        <p className="tw-mb-0 tw-text-[#535862] dark:tw-text-[#787B86] tw-text-xs">Log and store processing errors for debugging and monitoring</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                   </div>
                                   <div className="text-right border-top tw-py-3 tw-pe-4 sm:tw-pe-6 mt-auto">
                                            {this.state.createDatasourceError && (
                                                <span className="tw-text-xs tw-font-medium tw-text-[#DC2626] tw-text-left">
                                                    {this.state.createDatasourceError}
                                                </span>
                                            )}                                            <button 
                                                className="btn btn-outline btn-grey tw-mr-3" 
                                                onClick={() => this.props.setPage(false)}
                                                disabled={this.state.isCreatingDatasource}
                                            >
                                                Cancel
                                            </button>
                                            <button 
                                                type="button" 
                                                className="btn btn-primary" 
                                                onClick={this.handleCreateDatasource}
                                                disabled={!this.isCreateDatasourceEnabled()}
                                            >
                                                {this.state.isCreatingDatasource ? (
                                                    <div className="tw-flex tw-items-center tw-justify-center">
                                                        <div className="tw-w-[14px] tw-h-[14px] tw-border tw-border-solid tw-rounded-full tw-border-white tw-border-t-transparent tw-animate-spin"></div>
                                                        <span className='tw-ml-2'>Creating...</span>
                                                    </div>
                                                ) : (
                                                    <>
                                                        <Check size={18} color="currentColor" className='mr-1' />Create Datasource
                                                    </>
                                                )}
                                            </button>
                                   </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="portlet-body tw-h-full">
                                    <div id="add-datasource_help" class="qd-helpGuide tw-h-full">
                                        <div class="qd-helpGuide__content">
                                            {/* <div class="connector-badge">
                                                <i class="connector-icon">
                                                    <svg width="20" height="20" viewBox="0 0 147 140" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <g clip-path="url(#clip0_1563_1485)">
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M134.806 60.0962L118.336 69.5862L134.806 78.9962C135.791 79.5655 136.654 80.3232 137.346 81.226C138.038 82.1289 138.546 83.1592 138.84 84.2582C139.134 85.3572 139.208 86.5033 139.059 87.6311C138.91 88.7589 138.541 89.8463 137.971 90.8312C137.402 91.8161 136.644 92.6793 135.741 93.3713C134.839 94.0634 133.808 94.5709 132.709 94.8648C131.61 95.1587 130.464 95.2333 129.336 95.0842C128.209 94.9352 127.121 94.5655 126.136 93.9962L96.6262 76.9962C95.2737 76.2137 94.1576 75.0807 93.3955 73.7166C92.6334 72.3526 92.2536 70.8081 92.2962 69.2462C92.3193 68.5695 92.4234 67.8981 92.6062 67.2462C93.2103 65.06 94.646 63.1972 96.6062 62.0562L126.116 45.1162C127.105 44.5445 128.198 44.1736 129.33 44.0245C130.463 43.8755 131.614 43.9513 132.718 44.2476C133.821 44.5439 134.855 45.0548 135.761 45.7513C136.667 46.4477 137.426 47.3159 137.996 48.3062C138.568 49.2879 138.94 50.3734 139.089 51.4999C139.239 52.6263 139.163 53.7712 138.866 54.868C138.569 55.9649 138.057 56.9919 137.361 57.8894C136.664 58.7869 135.795 59.537 134.806 60.0962ZM119.216 106.096L89.7162 89.1262C88.3964 88.3687 86.9013 87.9699 85.3796 87.9692C83.8579 87.9686 82.3625 88.3661 81.042 89.1224C79.7215 89.8787 78.6219 90.9674 77.8525 92.2803C77.0831 93.5932 76.6707 95.0845 76.6562 96.6062V130.506C76.7327 132.759 77.6812 134.893 79.3016 136.46C80.922 138.026 83.0875 138.901 85.3412 138.901C87.5949 138.901 89.7605 138.026 91.3809 136.46C93.0013 134.893 93.9498 132.759 94.0262 130.506V111.506L110.536 120.996C111.521 121.566 112.609 121.936 113.737 122.086C114.865 122.236 116.011 122.162 117.111 121.868C118.21 121.575 119.241 121.068 120.144 120.376C121.048 119.684 121.806 118.821 122.376 117.836C122.946 116.851 123.317 115.764 123.466 114.636C123.616 113.508 123.542 112.361 123.248 111.262C122.955 110.162 122.448 109.131 121.756 108.228C121.064 107.324 120.201 106.566 119.216 105.996V106.096ZM85.2162 72.9362L72.9162 85.0862C72.4954 85.4774 71.9501 85.7076 71.3762 85.7362H67.7662C67.1937 85.7018 66.6502 85.4724 66.2262 85.0862L53.9962 72.8962C53.6136 72.4787 53.3875 71.9416 53.3562 71.3762V67.7762C53.3892 67.2082 53.615 66.6685 53.9962 66.2462L66.2262 54.0562C66.6512 53.6729 67.1948 53.447 67.7662 53.4162H71.3762C71.9486 53.4429 72.4935 53.6693 72.9162 54.0562L85.1762 66.2462C85.5545 66.6695 85.7767 67.2093 85.8062 67.7762V71.3762C85.7785 71.9405 85.5559 72.4778 85.1762 72.8962L85.2162 72.9362ZM75.4162 69.5562C75.369 68.9732 75.1258 68.4234 74.7262 67.9962L71.1762 64.4862C70.7508 64.1036 70.2075 63.8778 69.6362 63.8462H69.5062C68.9375 63.876 68.3968 64.1022 67.9762 64.4862L64.4262 67.9962C64.0451 68.4256 63.8228 68.9727 63.7962 69.5462V69.6762C63.8214 70.2411 64.0444 70.7791 64.4262 71.1962L67.9962 74.6962C68.4177 75.0788 68.9579 75.3048 69.5262 75.3362H69.6562C70.2275 75.3046 70.7708 75.0788 71.1962 74.6962L74.7462 71.1662C75.1297 70.7483 75.359 70.2121 75.3962 69.6462L75.4162 69.5562ZM19.9262 33.0762L49.4362 49.9962C50.7575 50.7533 52.2539 51.1517 53.7768 51.1516C55.2996 51.1516 56.796 50.7532 58.1173 49.9961C59.4386 49.2389 60.5388 48.1492 61.3087 46.8353C62.0786 45.5214 62.4915 44.029 62.5062 42.5062V8.63619C62.4298 6.38379 61.4813 4.24919 59.8609 2.68284C58.2405 1.1165 56.0749 0.240938 53.8212 0.240938C51.5675 0.240938 49.402 1.1165 47.7816 2.68284C46.1612 4.24919 45.2127 6.38379 45.1362 8.63619V27.6362L28.6062 18.1362C27.6213 17.5663 26.5338 17.1959 25.4057 17.0462C24.2777 16.8966 23.1312 16.9706 22.0318 17.264C20.9323 17.5575 19.9014 18.0646 18.998 18.7564C18.0945 19.4483 17.3361 20.3113 16.7662 21.2962C16.1963 22.2811 15.8259 23.3686 15.6763 24.4967C15.5266 25.6247 15.6006 26.7712 15.8941 27.8706C16.1875 28.9701 16.6946 30.001 17.3864 30.9044C18.0783 31.8079 18.9413 32.5663 19.9262 33.1362V33.0762ZM84.6862 51.1562C86.4288 51.294 88.1722 50.9 89.6862 50.0262L119.186 33.0262C120.171 32.4563 121.034 31.6979 121.726 30.7944C122.418 29.891 122.925 28.8601 123.218 27.7606C123.512 26.6612 123.586 25.5147 123.436 24.3867C123.287 23.2586 122.916 22.1711 122.346 21.1862C121.776 20.2013 121.018 19.3383 120.114 18.6464C119.211 17.9546 118.18 17.4475 117.081 17.154C114.86 16.5614 112.495 16.8752 110.506 18.0262L93.9962 27.6062V8.60619C93.9198 6.35379 92.9713 4.21919 91.3509 2.65284C89.7305 1.0865 87.5649 0.210938 85.3112 0.210938C83.0575 0.210938 80.892 1.0865 79.2716 2.65284C77.6512 4.21919 76.7026 6.35379 76.6262 8.60619V42.5062C76.6235 44.701 77.4542 46.8149 78.9504 48.4207C80.4466 50.0264 82.4967 51.0041 84.6862 51.1562ZM54.4762 87.9962C52.7333 87.8546 50.9888 88.2488 49.4762 89.1262L19.9262 106.056C17.9371 107.207 16.4867 109.101 15.8941 111.322C15.3015 113.542 15.6152 115.907 16.7662 117.896C17.9173 119.885 19.8113 121.336 22.0318 121.928C24.2522 122.521 26.6171 122.207 28.6062 121.056L45.1362 111.566V130.566C45.2127 132.819 46.1612 134.953 47.7816 136.52C49.402 138.086 51.5675 138.961 53.8212 138.961C56.0749 138.961 58.2405 138.086 59.8609 136.52C61.4813 134.953 62.4298 132.819 62.5062 130.566V96.6062C62.5017 94.4225 61.6715 92.3212 60.1821 90.7243C58.6926 89.1273 56.6543 88.1527 54.4762 87.9962ZM46.4762 72.1262C47.0459 70.2529 46.96 68.2415 46.2328 66.4235C45.5057 64.6056 44.1806 63.0898 42.4762 62.1262L12.9962 45.1362C11.0053 43.9958 8.64409 43.6891 6.42786 44.283C4.21163 44.8768 2.32019 46.3231 1.16621 48.3062C0.594906 49.2876 0.223871 50.3726 0.0745668 51.4983C-0.074737 52.6241 0.000654668 53.7682 0.296381 54.8647C0.592107 55.9611 1.1023 56.988 1.79744 57.886C2.49258 58.7839 3.35887 59.5352 4.34621 60.0962L20.8162 69.5862L4.34621 78.9962C3.3613 79.5642 2.4979 80.3206 1.80531 81.2222C1.11272 82.1238 0.604499 83.1531 0.309673 84.2511C0.0148467 85.3492 -0.0608148 86.4946 0.0870081 87.6218C0.234831 88.7491 0.603243 89.8363 1.17121 90.8212C1.73918 91.8061 2.49558 92.6695 3.39722 93.3621C4.29886 94.0547 5.32809 94.5629 6.42615 94.8577C7.5242 95.1526 8.66957 95.2282 9.79686 95.0804C10.9242 94.9326 12.0113 94.5642 12.9962 93.9962L42.4762 76.9962C44.3746 75.9363 45.8005 74.196 46.4662 72.1262H46.4762ZM139.626 15.9062H138.296V17.5362H139.616C140.226 17.5362 140.616 17.2562 140.616 16.7362C140.616 16.2162 140.256 15.9062 139.616 15.9062H139.626ZM136.686 14.4062H139.686C141.306 14.4062 142.386 15.2962 142.386 16.6762C142.391 17.0603 142.294 17.4389 142.104 17.7729C141.914 18.1068 141.639 18.3841 141.306 18.5762L142.476 20.2562V20.5962H140.786L139.616 18.9962H138.296V20.5962H136.676L136.686 14.4062ZM144.986 17.6262C145.035 16.8692 144.926 16.1103 144.666 15.3976C144.406 14.6849 144.001 14.034 143.476 13.4859C142.952 12.9379 142.319 12.5047 141.619 12.2139C140.918 11.923 140.165 11.7808 139.406 11.7962C136.096 11.7962 133.896 14.1862 133.896 17.6262C133.896 20.9062 136.096 23.4462 139.406 23.4462C140.165 23.4644 140.919 23.3245 141.621 23.0354C142.323 22.7463 142.957 22.3143 143.483 21.7669C144.008 21.2195 144.414 20.5687 144.675 19.8558C144.936 19.1429 145.045 18.3836 144.996 17.6262H144.986ZM146.366 17.6262C146.366 21.5162 143.766 24.7662 139.366 24.7662C134.966 24.7662 132.476 21.4862 132.476 17.6262C132.476 13.7662 135.046 10.4862 139.366 10.4862C143.686 10.4862 146.356 13.7262 146.356 17.6262H146.366Z" fill="#29B5E8"/>
                                                        </g>
                                                        <defs>
                                                        <clipPath id="clip0_1563_1485">
                                                        <rect width="146.36" height="139.16" fill="white"/>
                                                        </clipPath>
                                                        </defs>
                                                    </svg>
                                                </i>
                                                <span class="connector-label">Snowflake</span>
                                            </div>
                                            <div class="connector-badge">
                                                <div class="tw-flex tw-items-center tw-gap-2">
                                                    <div class="tw-w-5 tw-h-5 tw-rounded tw-bg-[#d6d6d6] tw-animate-shimmer tw-bg-[linear-gradient(90deg,#d6d6d6_0%,#ebebeb_50%,#d6d6d6_100%)] tw-bg-[length:250px_100%]"></div>
                                                    <div class="tw-h-4 tw-w-20 tw-bg-[#d6d6d6] tw-rounded tw-animate-shimmer tw-bg-[linear-gradient(90deg,#d6d6d6_0%,#ebebeb_50%,#d6d6d6_100%)] tw-bg-[length:250px_100%]"></div>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="tw-h-6 tw-w-4/6 tw-bg-[#d6d6d6] tw-mb-3 tw-rounded tw-animate-shimmer tw-bg-[linear-gradient(90deg,#d6d6d6_0%,#ebebeb_50%,#d6d6d6_100%)] tw-bg-[length:250px_100%]"></div>
                                                <div class="tw-h-4 tw-w-full tw-bg-[#d6d6d6] tw-mb-1 tw-rounded tw-animate-shimmer tw-bg-[linear-gradient(90deg,#d6d6d6_0%,#ebebeb_50%,#d6d6d6_100%)] tw-bg-[length:250px_100%]"></div>
                                                <div class="tw-h-4 tw-w-5/6 tw-bg-[#d6d6d6] tw-mb-1 tw-rounded tw-animate-shimmer tw-bg-[linear-gradient(90deg,#d6d6d6_0%,#ebebeb_50%,#d6d6d6_100%)] tw-bg-[length:250px_100%]"></div>
                                                <div class="tw-h-4 tw-w-4/6 tw-bg-[#d6d6d6] tw-mb-1 tw-rounded tw-animate-shimmer tw-bg-[linear-gradient(90deg,#d6d6d6_0%,#ebebeb_50%,#d6d6d6_100%)] tw-bg-[length:250px_100%]"></div>
                                                <div class="tw-h-4 tw-w-3/6 tw-bg-[#d6d6d6] tw-mb-1 tw-rounded tw-animate-shimmer tw-bg-[linear-gradient(90deg,#d6d6d6_0%,#ebebeb_50%,#d6d6d6_100%)] tw-bg-[length:250px_100%]"></div>
                                            </div> */}
                                            <h4 class="qd-helpGuide__title">Steps to enable access from your storage to Qualdo™: </h4>
                                            <ol class="qd-helpGuide__info">
                                            {this.renderHelpContent()}
                                            </ol>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                { this.renderTest() }
                <Modal show={this.state.showSchemeModal} size="md"  centered onHide={this.handleCloseSchemeModal}>
                    <Modal.Header closeButton>
                        <div className='tw-flex tw-items-center tw-gap-4'>
                            <div className='tw-flex tw-items-center tw-justify-center tw-p-[10px] tw-border tw-border-solid tw-border-[#D5D7DA] dark:tw-border-[#2B2B40] tw-bg-white dark:tw-bg-[#1E1E2D] tw-rounded-[10px]'>
                                <FolderTree size={20} color="#414651" />
                            </div>
                            <div>
                            <h5 className="modal-title !tw-mb-[2px] tw-font-semibold !tw-text-gray-900 dark:!tw-text-white">{this.state.formType === "azure_blob"|| this.state.formType ==='s3' ? "Available Buckets" : "Available Schemas"}</h5>                                
                                <div className='tw-flex tw-items-center tw-gap-2 tw-gap-2'>
                                    <div className='tw-px-2 tw-py-[2px] tw-flex tw-items-center tw-justify-center tw-text-xs tw-font-medium tw-text-[#175CD3] tw-border tw-border-solid tw-border-[#B2DDFF] tw-rounded-[6px] tw-uppercase' onClick={this.handleRefreshSchemas}>
                                     {getDatasourceIcon(this.state.formType)}{this.state.formType}

                                    </div>
                                    <strong className='tw-text-sm tw-text-[#535862] dark:tw-text-[#787B86] !tw-font-medium tw-ms-1'>{this.state.testConnectionFormData?.database || this.state.testConnectionFormData?.database_name ||this.state.testConnectionFormData?.host|| this.state.testConnectionFormData?.host_name||this.state.testConnectionFormData?.host_url ||''}</strong>
                                </div>
                            </div>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        {this.state.schemeModalLoading ? (
                            <div className='tw-py-[60px] tw-text-center'>
                                <i className='tw-p-4 tw-rounded-full tw-bg-[linear-gradient(180deg,#FAFAFA,#E9EAEB)] tw-inline-flex tw-items-center tw-justify-center tw-mb-4'>
                                    <div className="tw-w-[32px] tw-h-[32px] tw-border-4 tw-border-solid tw-rounded-full tw-border-[#D1E9FF] tw-border-t-[#0021A5] tw-animate-spin"></div>
                                </i>
                                <div>
                                    <h5 className='tw-text-base tw-font-medium tw-text-[#181D27] dark:tw-text-[#B2B5BE] tw-mt-0 tw-mb-1'>{this.state.formType === "azure_blob"|| this.state.formType ==='s3' ? "Fetching Buckets" : "Fetching Schemas"}</h5>
                                <p className='tw-text-sm tw-text-[#535862] dark:tw-text-[#787B86] tw-my-0'>{this.state.formType === "azure_blob" ? "Connecting to Azure Blob Storage..." : this.state.formType === 's3' ? "Connecting to AWS S3..." : `Connecting to ${this.state.formType}`}</p>
                                </div>
                            </div>
                        ) : (
                            <><div className='tw-rounded-lg tw-border tw-border-solid tw-border-[#ABEFC6] tw-bg-[#F6FEF9] tw-py-2 tw-px-3 tw-mb-3'>
                                <div className="d-flex align-items-center tw-gap-[10px]">
                                    <i><CircleCheck size={18} color="#17B26A" /></i>
                                    <div>
                                        <span className="tw-block tw-text-sm tw-text-[#067647] tw-font-medium">Successfully fetched {this.state.testConnectionResponse?.schemas?.length || 0} {this.state.formType === "azure_blob" || this.state.formType ==='s3' ? "buckets" : "schemas"}</span>
                                        <span className='tw-block tw-text-xs tw-text-[#079455]'>{this.state.formType === "azure_blob" || this.state.formType ==='s3' ? "Select the buckets you want to work with. You can select multiple buckets." : "Select the schemas you want to work with. You can select multiple schemas."}</span>
                                    </div>
                                </div>
                            </div>
                        
                       <div className='tw-p-3 tw-rounded-xl tw-border tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40] tw-bg-[#FAFAFA] dark:tw-bg-[#161622]'>
                            <div className='d-flex align-items-center justify-content-between tw-mb-3'>
                                <div className="qd-search-bar has-btn-close tw-border tw-border-solid tw-border-[#D5D7DA] dark:tw-border-[#2B2B40] tw-bg-white dark:tw-bg-[#1E1E2D] tw-rounded-lg tw-flex-1 tw-me-3">
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <button id="button-addon4" type="button" className="btn">
                                                <svg className='d-block' width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M17.5 17.5L14.5834 14.5833M16.6667 9.58333C16.6667 13.4954 13.4954 16.6667 9.58333 16.6667C5.67132 16.6667 2.5 13.4954 2.5 9.58333C2.5 5.67132 5.67132 2.5 9.58333 2.5C13.4954 2.5 16.6667 5.67132 16.6667 9.58333Z" stroke="#A4A7AE" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                            </button>
                                        </div>
                                        <input 
                                            type="search" 
                                            placeholder="Search" 
                                            className="form-control h-100" 
                                            value={this.state.schemaSearchText}
                                            onChange={(e) => this.setState({ schemaSearchText: e.target.value })}
                                        />
                                    </div>
                                    {/* {this.state.saveWatchListSearchText && <button className="btn btn-clear" title="clear" onClick={() => this.setState({ saveWatchListSearchText: '' })}><i className="icon-close"></i></button>} */}
                                </div>
                                <button 
                                    type="button" 
                                    className="btn btn-sm btn-outline btn-grey !tw-px-2 !tw-py-1 !tw-rounded-lg tw-whitespace-nowrap hover:!tw-shadow-none"
                                    onClick={this.handleSelectAllSchemas}
                                >
                                    {this.state.selectedSchemas.length === (this.state.testConnectionResponse?.schemas || []).length && this.state.testConnectionResponse?.schemas?.length > 0
                                        ? 'Deselect All' 
                                        : 'Select All'}
                                </button>
                            </div>
                            <div className='tw-rounded-lg tw-border tw-border-solid tw-border-black/10 tw-bg-white dark:tw-bg-[#1E1E2D] tw-p-2'>
                                {(() => {
                                    const filteredSchemas = this.state.testConnectionResponse?.schemas?.filter(schema => 
                                        schema.toLowerCase().includes(this.state.schemaSearchText.toLowerCase())
                                    ) || [];
                                    
                                    return filteredSchemas.length > 0 ? (
                                        filteredSchemas.map((schema, index) => (
                                            <div className='tw-mb-[2px]' key={index}>
                                                <div className='custom-control custom-checkbox custom-control-inline d-flex tw-px-2 tw-py-1 tw-m-0 tw-cursor-pointer tw-rounded-lg hover:tw-bg-[#F5F5F5] dark:hover:tw-bg-[#2B2B40]'>
                                                    <label className="d-flex align-items-center tw-mr-8 tw-mb-0 tw-font-medium">
                                                        <input 
                                                            type="checkbox" 
                                                            name="schema" 
                                                            className="mr-2"
                                                            checked={this.state.selectedSchemas.includes(schema)}
                                                            onChange={() => this.handleSchemaSelect(schema)}
                                                        />
                                                        <span className='d-flex align-items-center'>
                                                            <i><FolderTree size={16} color="#A4A7AE" className='tw-me-2' /></i>
                                                            {schema}
                                                        </span>
                                                    </label>
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                    <div className='tw-text-center tw-py-3 tw-text-[#535862] dark:tw-text-[#787B86]'>
                                        {this.state.formType === "azure_blob"|| this.state.formType ==='s3' ? "No Buckets Found" : "No Schemas Found"}
                                    </div>
                                    );
                                })()}
                            </div>
                       </div>
                       </>
                        )}
                    </Modal.Body>
                    <Modal.Footer className='justify-content-between tw-p-5'>
                        <div>
                        <p
                            className={`tw-text-sm tw-m-0 ${
                                this.state.selectedSchemas.length > 0
                                    ? 'tw-text-[#079455]'
                                    : 'tw-text-[#535862] dark:tw-text-[#787B86]'
                            }`}
                        >
                            {(() => {
                                const count = this.state.selectedSchemas.length;
                                const isBucket =
                                    this.state.formType === 'azure_blob' || 
                                    this.state.formType === 's3' ||
                                    this.state.formType === 'azure_data_lake_gen2';

                                const label = isBucket ? 'bucket' : 'schema';

                                return count > 0
                                    ? `${count} ${label}${count > 1 ? 's' : ''} selected`
                                    : `Please select at least one ${label}`;
                            })()}
                        </p>
                        </div>
                        <div className='m-0'>
                            <button type="button" className="btn btn-outline btn-grey tw-me-2" onClick={this.handleCloseSchemeModal}>Cancel</button>
                            <button 
                                type="button" 
                                className="btn btn-primary" 
                                onClick={this.handleConfirmSchemaSelection}
                                disabled={this.state.selectedSchemas.length === 0}
                            >
                                <i><Check size={20} color="currentColor" className='mr-1' /></i> Confirm Selection ({this.state.selectedSchemas.length})
                            </button>
                        </div>
                    </Modal.Footer>
                </Modal>
             </>
        );
    }

getEditIntegrationContent(data_source_option){
        return (
            <>             
                <div className = "portlet portlet-2col" id="edit_ds_model">
                    <div className = "portlet-body d-none">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="portlet-body"id="add-datasource">
                                    <div className="form-row">
                                        <div className="form-group col-md-6 hello">
                                            <label>Choose a Datasource type </label>
                                            <Select
                                                id="choose_datasource_type_add"
                                                filterOption={({label}, query) => label.toLowerCase().includes(query.toLowerCase())}
                                                onChange={this.setForm}
                                                value={this.state.formType_option}
                                                options={data_source_option}
                                                placeholder="Choose Data Source"
                                                classNamePrefix='select-control'
                                                formatGroupLabel={formatGroupLabel}
                                            />
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='qd-scroll tw-space-y-4' id="edit_ds_flow">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="d-flex flex-column h-100">
                                   <div className="qd-configure-integration-steps">
                                        <div className="vertical-stepper vertical-stepper-sm w-100 border-0">
                                            <button
                                                type="button"
                                                className="tw-flex tw-items-center tw-gap-1.5 tw-bg-transparent tw-border-0 tw-px-1 tw-py-0 tw-cursor-pointer"
                                                onClick={() => this.toggleEditPanel('datasource')}
                                                aria-expanded={this.state.editPanels.datasource}
                                            >
                                                {this.state.editPanels.datasource ? <ChevronDown size={16} className="tw-text-[#007BFF]" /> : <ChevronRight size={16} className="tw-text-[#007BFF]" />}
                                                <span className="tw-text-base tw-font-semibold tw-text-[#007BFF]">Datasource Details</span>
                                            </button>
                                            {this.state.editPanels.datasource && <div className="vertical-stepper__content tw-ml-6 tw-mt-2 tw-rounded-xl tw-border tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40] tw-bg-white dark:tw-bg-[#1E1E2D] tw-p-4">
                                                {!this.state.showTestConnectionInfo && (
                                                <div >
                                                    {/* className={this.state.testConnectionSuccess === null ? "" : "d-none"} */}
                                                    <div class="form-row">
                                                        <div class="form-group col-lg-6">
                                                            <label>Choose a Datasource type <span className='text-primary'>*</span></label>
                                                            <Select
                                                                id="choose_datasource_type_add"
                                                                filterOption={({label}, query) => label.toLowerCase().includes(query.toLowerCase())}
                                                                onChange={this.setForm}
                                                                value={this.state.formType_option}
                                                                options={data_source_option}
                                                                placeholder="Choose Data Source"
                                                                classNamePrefix='select-control'
                                                                formatGroupLabel={formatGroupLabel}
                                                                components={{ Control: (props) => customSelectDatasource({ ...props, icon: data_source_option }) }}
                                                                isDisabled={true}
                                                            />
                                                        </div>
                                                    </div>

                                                    <DynamicDatasourceForm
                                                    key={this.state.formResetKey}
                                                    config={datasourceConfig}
                                                    selectedDatasource={this.state.formType}
                                                    onSubmit={this.handleFormSubmit}
                                                    onTestConnection={this.handleTestConnection}
                                                    isTestingConnection={this.state.isTestingConnection}
                                                    testConnectionSuccess={this.state.testConnectionSuccess}
                                                    testConnectionResponse={this.state.testConnectionResponse}
                                                    testConnectionError={this.state.testConnectionError}
                                                    onContinueSchemaSelection={this.handleContinueSchemaSelection}
                                                    initialFormData={this.state.testConnectionFormData}
                                                    existingDatasources={this.props.existingDatasources || []}
                                                    existingIntegrations={this.props.existingIntegrations || []}
                                                    currentIntegrationName={this.state.testConnectionFormData?.integration_name}
                                                    currentDatasourceId={this.state.datasource_id || this.state.ex_edit_integration_details?.datasource_id || this.props.ex_integration_details?.datasource_id}
                                                    ip_address={this.state.ip_address}
                                                    isEditMode={true}
                                                    />
                                                </div>
                                                )}
                                                
                                                {this.state.showTestConnectionInfo && this.state.testConnectionSuccess!==null && this.state.testConnectionFormData && (
                                                <div className="qd-configure-integration-info">
                                                    <div className="qd-configure-integration-info__content" id="test_connection_info">
                                                        <div className="qd-configure-integration-info__list">
                                                            <div className="qd-configure-integration-info__item">
                                                                <label className='qd-configure-integration-info__label'>Type</label>
                                                                <span className="qd-configure-integration-info__value">
                                                                    <i>
                                                                        <Database size={16} color="#A4A7AE" />
                                                                    </i>
                                                                    <span>{this.getDatasourceLabel(this.state.formType)}</span>
                                                                </span>
                                                            </div>
                                                            {this.state.testConnectionFormData.datasource_name && (
                                                                <div className="qd-configure-integration-info__item">
                                                                    <label className='qd-configure-integration-info__label'>Datasource Name</label>
                                                                    <span className="qd-configure-integration-info__value">
                                                                        <i>
                                                                            <Database size={16} color="#A4A7AE" />
                                                                        </i>
                                                                        <RcTooltip
                                                                            placement="top"
                                                                            overlay={<span>{this.state.testConnectionFormData.datasource_name}</span>}
                                                                            arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                                                                        >
                                                                            <span>{this.state.testConnectionFormData.datasource_name}</span>
                                                                        </RcTooltip>
                                                                    </span>
                                                                </div>
                                                            )}
                                                        </div>
                                                        {/* Dynamically render fields from datasourceConfig.json */}
                                                        {this.renderIntegrationInfoFields()}
                                                        {/* Render Auth Method and Credential fields together */}
                                                        {this.renderCredentialFields()}
                                                        <hr className='tw-block tw-my-3' />
                                                        <div className="qd-configure-integration-info__action">
                                                        {/* Show error message if connection failed */}
                                                        {this.state.testConnectionError ? (
                                                            <div className="tw-flex tw-items-center tw-gap-2">
                                                                <button className="btn btn-sm btn-circle tw-border-[#FCA5A5] tw-bg-[#FEF2F2] tw-text-[#DC2626] tw-mr-3 !tw-px-2 hover:tw-text-[#DC2626] hover:!tw-shadow-none">
                                                                    {this.state.testConnectionError}
                                                                </button>
                                                                <button className="btn btn-sm btn-outline btn-circle btn-grey !tw-px-2" onClick={this.editDatasourceDetails}>Edit</button>
                                                            </div>
                                                        ) : (
                                                            <div className="tw-flex tw-items-center tw-justify-end tw-gap-3">
                                                                {getDatasourceStatus(this.state.ex_edit_integration_details?.auto_config_status || this.props.ex_integration_details?.auto_config_status || 'completed')}
                                                                <button className="tw-flex tw-items-center tw-rounded-full tw-border tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40] tw-bg-white dark:tw-bg-[#1E1E2D] tw-text-xs tw-pl-2 tw-pr-3 tw-py-[5px] tw-text-[#414651] dark:tw-text-[#B2B5BE] tw-font-medium hover:tw-text-[#414651] dark:hover:tw-text-[#B2B5BE] dark:tw-text-[#B2B5BE] hover:tw-border-[#D5D7DA] dark:hover:tw-border-[#2B2B40] dark:tw-border-[#2B2B40] hover:tw-bg-[#F4F5F5] dark:hover:tw-bg-[#2B2B40]" onClick={this.editDatasourceDetails}>
                                                                    <i className='tw-flex tw-items-center tw-justify-center tw-w-4 tw-h-4 tw-mr-1'><SquarePen size={12} color="#A4A7AE" /></i>
                                                                    Edit
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>
                                                    </div>
                                                </div>
                                                )}
                                            </div>}
                                            {this.state.showSchemaConfigInfo && (
                                            <>
                                            <div className="vertical-stepper__heading !tw-pb-2 sm:!tw-pb-1">
                                                <span className="vs-heading__circle">2</span>
                                                <div className="vs-heading__title-wrap">
                                                    <div className="vs-heading__title">{this.state.formType === "azure_blob"|| this.state.formType ==='s3'? "Bucket & Mode Selection" : "Schema & Mode Selection"}</div>
                                                </div>
                                            </div>
                                            {/* Always show schema & mode selection step, even if empty, for edit consistency */}
                                            {/* <div className="vertical-stepper__content">
                                                    <div className="qd-configure-integration-info">
                                                    <div className="qd-configure-integration-info__content">
                                                        <div className="qd-configure-integration-info__list !tw-grid-cols-1">
                                                            <div className="qd-configure-integration-info__item">
                                                                <label className='qd-configure-integration-info__label'>
                                                                    {`${this.state.schemaModeSelection === "allSchemas" ? "All" : "Specified"} ${this.state.formType === "azure_blob" || this.state.formType === "s3" ? "Buckets" : "Schemas"}`}
                                                                </label>
                                                                <span className="qd-configure-integration-info__value d-none">
                                                                    {this.state.schemaModeSelection === 'allSchemas'
                                                                        ? <span className='tw-text-[#535862] dark:tw-text-[#787B86]'>{`Process all available ${this.state.formType === "azure_blob" || this.state.formType === "s3" ? "buckets" : "schemas"} automatically`}</span>
                                                                        : (this.state.selectedSchemas && this.state.selectedSchemas.length > 0
                                                                            ? this.state.selectedSchemas.map((schema, idx) => (
                                                                                <span key={idx} className='tw-py-[2px] tw-px-2 tw-rounded-full tw-border tw-border-solid tw-border-[#C7D7FE] tw-bg-[#EEF4FF] tw-text-[#3538CD] tw-text-xs tw-font-medium tw-flex tw-items-center'>
                                                                                    <i className="tw-me-[2px]">
                                                                                        <FolderTree className="d-block" size={12} color="#175CD3" />
                                                                                    </i>
                                                                                    {schema}
                                                                                </span>
                                                                            ))
                                                                            : <span className='tw-text-[#535862] dark:tw-text-[#787B86]'>No schemas selected</span>
                                                                        )
                                                                    }
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <hr className='tw-block tw-my-3' />
                                                        <div className="qd-configure-integration-info__list">
                                                            <div className="qd-configure-integration-info__item">
                                                                <label className='qd-configure-integration-info__label'>Configuration Mode</label>
                                                                <span className="qd-configure-integration-info__value">
                                                                    <Form.Check
                                                                        custom
                                                                        type={'radio'}
                                                                        id={`configMode_${this.state.configurationMode}`}
                                                                        label={this.state.configurationMode === 'autoconfig' ? 'Autoconfig' : 'Manual Config'}
                                                                        checked={true}
                                                                        className="mr-4"
                                                                        disabled
                                                                    />
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div> */}

                                            {false && this.state.configurationMode === 'manual' && this.state.integrationConfigurations.length > 0 && this.state.showSchemaConfigInfo && this.state.manualNextClicked && (
    <>
        <div className="vertical-stepper__heading !tw-pb-2 sm:!tw-pb-1">
            <span className="vs-heading__circle">3</span>
            <div className="vs-heading__title-wrap">
                <div className="vs-heading__title">Manual Configuration Details</div>
            </div>
        </div>
        <div className="vertical-stepper__content">
            {this.state.integrationConfigurations.map((config, idx) => (
                <div key={config.id} className='tw-border-2 tw-border-solid tw-border-[#9BCBFF] tw-px-4 tw-rounded-xl tw-mb-4' style={this.state.integrationValidationErrors?.[config.id] ? { borderColor: '#FDA29B' } : undefined}>
                    <div className='d-flex align-items-center justify-content-between tw-py-3 tw-border-0 tw-border-b tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40]'>
                        <h5 className='tw-font-medium tw-text-black tw-m-0'>{`Integration ${idx + 1}`}</h5>
                    </div>
                    <div className={`tw-py-4 ${config.isExisting ? 'tw-pointer-events-none' : ''}`}>
                        <div className="qd-configure-integration-info__list !tw-grid-cols-1 sm:!tw-grid-cols-2">
                            <div className="qd-configure-integration-info__item">
                            <label className='qd-configure-integration-info__label'>{this.state.formType === "azure_blob" || this.state.formType ==='s3'? "Select Bucket" : "Select Schema"}</label>
                                <span className="qd-configure-integration-info__value">
                                    {config.schema
                                        ? (
                                            <span className='tw-py-[2px] tw-px-2 tw-rounded-full tw-border tw-border-solid tw-border-[#C7D7FE] tw-bg-[#EEF4FF] tw-text-[#3538CD] tw-text-xs tw-font-medium tw-flex tw-items-center'>
                                                <i className="tw-me-[2px]">
                                                    <FolderTree className="d-block" size={12} color="#175CD3" />
                                                </i>
                                                {config.schema}
                                            </span>
                                        )
                                        : <span className='tw-text-[#535862] dark:tw-text-[#787B86]'>No schema selected</span>
                                    }
                                </span>
                            </div>
                            {(this.state.formType === 'azure_blob' || this.state.formType ==='s3' || this.state.formType === 'azure_data_lake_gen2') && (
                                <div className="qd-configure-integration-info__item">
                                    <label className='qd-configure-integration-info__label'>Subpath</label>
                                    <span className="qd-configure-integration-info__value">
                                        {config.sub_path
                                            ? <span className='tw-py-[2px] tw-px-2 tw-rounded-full tw-border tw-border-solid tw-border-[#D0D5DD] tw-bg-[#F9FAFB] tw-text-[#344054] tw-text-xs tw-font-medium tw-inline-flex tw-items-center'>{config.sub_path}</span>
                                            : <span className='tw-text-[#535862] dark:tw-text-[#787B86]'>No subpath</span>
                                        }
                                    </span>
                                </div>
                            )}
                                                                        {this.state.formType !== 'azure_blob' && this.state.formType !== 's3' && this.state.formType !== 'azure_data_lake_gen2' && (
                            <div className="qd-configure-integration-info__item">
                                <label className='qd-configure-integration-info__label'>Dataset Scope</label>
                                <span className="qd-configure-integration-info__value">
                                    <Form.Check
                                        custom
                                        type={'radio'}
                                        id={`datasetScope_${config.id}`}
                                        label={config.datasetScope === 'allDatasets' ? 'All Datasets' : 'Specified Datasets'}
                                        checked={true}
                                        className="mr-4"
                                        disabled
                                    />
                                </span>
                            </div>
                            )}
                        </div>
                        <hr className='tw-my-3 tw-border-0 tw-border-b tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40]' />
                        <div className="tw-mb-4 tw-p-3 sm:tw-p-4 tw-border tw-border-solid tw-border-[#D5D7DA] dark:tw-border-[#2B2B40] tw-rounded-lg tw-bg-[#FAFAFA] dark:tw-bg-[#161622]">
                            <div className='sm:tw-flex tw-items-center tw-justify-between'>
                                <div>
                                    <h5 className='tw-text-sm tw-font-medium tw-text-[#334DB7] tw-m-0'>Add Partitions</h5>
                                    <p className='tw-text-xs tw-text-[#546AC3] tw-m-0'>Configure partioning dataset.</p>
                                </div>
                                <button type="button" className="btn tw-mt-3 sm:tw-mt-0 tw-font-semibold tw-border-0 tw-bg-[#E6E9F6] tw-text-[#334DB7] tw-whitespace-nowrap hover:tw-bg-[#D2D7EF] hover:tw-text-[#334DB7]" onClick={() => this.handleAddPartitionToConfig(config.id)}>
                                    <Plus size={18} color="#8A99D6" className='mr-1' />Add Row
                                </button>
                            </div>
                            <div className={`integration-collapse-content ${config.partitions.length > 0 ? "open" : ""}`}> 
                                {config.partitions.map((partition, partitionIndex) => (
                                    <div key={partition.id} className="dataset-partition-card">
                                        <div className='dp-card__head'>
                                            <span className="dp-card__label">Partition {partitionIndex + 1}</span>
                                            <button type="button" className='tw-border-0 tw-bg-transparent text-primary' onClick={() => this.handleRemovePartition(config.id, partition.id)}>
                                                <Trash2 size={16} color="currentColor" className='mr-1' /><span className='tw-hidden sm:tw-inline-block'>Remove</span>
                                            </button>
                                        </div>
                                        <hr className='tw-border-0 tw-border-b tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40] tw-m-0' />
                                        <div className="dp-card__content">
                                            <div className="form-row">                                                                 
                                                <Form.Group className="col-md-6 col-lg-4">
                                                    <Form.Label>Select Dataset</Form.Label>
                                                    <input type="text" className="form-control" value={partition.datasetName} onChange={e => this.handlePartitionFieldChange(config.id, partition.id, 'datasetName', e.target.value)} />
                                                </Form.Group>
                                                <Form.Group className="col-md-6 col-lg-4">
                                                    <Form.Label>Partition Name</Form.Label>
                                                    <input type="text" className="form-control" value={partition.partitionName} onChange={e => this.handlePartitionFieldChange(config.id, partition.id, 'partitionName', e.target.value)} />
                                                </Form.Group>
                                                <Form.Group className="col-md-6 col-lg-4">
                                                    <Form.Label className='d-block'>Partition By</Form.Label>
                                                    <select className="form-control" value={partition.partitionBy} onChange={e => this.handlePartitionByChange(config.id, partition.id, e.target.value)}>
                                                        <option value="Column">Column</option>
                                                        <option value="Custom Query">Custom Query</option>
                                                    </select>
                                                </Form.Group>
                                                {(partition.partitionBy === 'Column' || partition.partitionBy === undefined) && (
                                                    <Form.Group className="col-md-6 col-lg-4">
                                                        <Form.Label>Partition Identifier</Form.Label>
                                                        <input type="text" className="form-control" value={partition.partitionIdentifier} onChange={e => this.handlePartitionFieldChange(config.id, partition.id, 'partitionIdentifier', e.target.value)} />
                                                    </Form.Group>
                                                )}
                                                {partition.partitionBy === 'Custom Query' && (
                                                    <Form.Group className="col-md-12 col-lg-8">
                                                        <Form.Label>Custom Query</Form.Label>
                                                        <input type="text" className="form-control" value={partition.customQuery} onChange={e => this.handlePartitionFieldChange(config.id, partition.id, 'customQuery', e.target.value)} />
                                                    </Form.Group>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                            <div className="tw-mb-4 tw-p-3 sm:tw-p-4 tw-border tw-border-solid tw-border-[#D5D7DA] dark:tw-border-[#2B2B40] tw-rounded-lg tw-bg-[#FAFAFA] dark:tw-bg-[#161622] tw-mt-3">
                            <div className='sm:tw-flex tw-items-center tw-justify-between'>
                                <div>
                                    <h5 className='tw-text-sm tw-font-medium tw-text-[#334DB7] tw-m-0'>Add Incremental Data Identification
                                        {config.datasetScope === 'specifiedDatasets' && <span className='text-danger'> *</span>}
                                        {config.datasetScope === 'allDatasets' && <span className='tw-text-[#6B7280]'> (Optional)</span>}
                                    </h5>
                                    <p className='tw-text-xs tw-text-[#546AC3] tw-m-0'>
                                        {config.datasetScope === 'specifiedDatasets' ? 'Required for specified datasets' : 'Configure incremental loading (Optional)'}
                                    </p>
                                </div>
                                <button type="button" className="btn tw-mt-3 sm:tw-mt-0 tw-font-semibold tw-border-0 tw-bg-[#E6E9F6] tw-text-[#334DB7] tw-whitespace-nowrap hover:tw-bg-[#D2D7EF] hover:tw-text-[#334DB7]" onClick={() => this.handleAddIncrementalData(config.id)}>
                                    <Plus size={18} color="#8A99D6" className='mr-1' />Add Row
                                </button>
                            </div>
                            <div className={`integration-collapse-content ${config.incrementalData.length > 0 ? "open" : ""}`}> 
                                {config.incrementalData.map((incrementalItem, incrementalIndex) => (
                                    <div key={incrementalItem.id} className="dataset-partition-card" style={this.state.integrationValidationErrors?.[config.id]?.datasets?.[incrementalItem.id] ? { border: '1px solid #FDA29B' } : undefined}>
                                        <div className='dp-card__head'>
                                            <span className="dp-card__label">Incremental Data {incrementalIndex + 1}</span>
                                            <button type="button" className='tw-border-0 tw-bg-transparent text-primary' onClick={() => this.handleRemoveIncrementalData(config.id, incrementalItem.id)}>
                                                <Trash2 size={16} color="currentColor" className='mr-1' /><span className='tw-hidden sm:tw-inline-block'>Remove</span>
                                            </button>
                                        </div>
                                        <hr className='tw-border-0 tw-border-b tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40] tw-m-0' />
                                        <div className="dp-card__content">
                                            <div className="form-row">                                                                 
                                                <div className="form-group col-md-6 col-lg-4">
                                                    <label>Dataset Name <span className="text-danger">*</span></label>
                                                    <div className="icon-input-group">
                                                        <i><Layers size={18} color="#A4A7AE" /></i>
                                                        <input type="text" className="form-control" value={incrementalItem.datasetName} onChange={e => this.handleIncrementalDataFieldChange(config.id, incrementalItem.id, 'datasetName', e.target.value)} />
                                                    </div>
                                                </div>
                                                <div className="form-group col-md-6 col-lg-4">
                                                    <label>Incremental Data Identifier {config.datasetScope !== 'specifiedDatasets' && <span className="text-danger">*</span>}</label>
                                                    <div className="icon-input-group">
                                                        <i><HardDrive size={18} color="#A4A7AE" /></i>
                                                        <input type="text" 
                                                            className={(config.datasetScope !== 'specifiedDatasets' && (!incrementalItem.identifier || incrementalItem.identifier.trim() === '')) ? "form-control is-invalid" : "form-control"}
                                                            value={incrementalItem.identifier || ''} 
                                                            onChange={e => this.handleIncrementalDataFieldChange(config.id, incrementalItem.id, 'identifier', e.target.value)} 
                                                        />
                                                    </div>
                                                    {(config.datasetScope !== 'specifiedDatasets' && (!incrementalItem.identifier || incrementalItem.identifier.trim() === '')) && (
                                                        <div className="error-text">Incremental Data Identifier is required field</div>
                                                    )}
                                                </div>
                                                <div className="form-group col-md-6 col-lg-4">
                                                    <div className="custom-control custom-checkbox mb-2">
                                                        <input
                                                            id={`start_index_check_box_${config.id}_${incrementalItem.id}`}
                                                            type="checkbox"
                                                            checked={incrementalItem.startingIndexCheckbox}
                                                            className="custom-control-input"
                                                            onChange={e => this.handleStartingIndexCheckbox(config.id, incrementalItem.id, e.target.checked)}
                                                        />
                                                        <label className="custom-control-label" htmlFor={`start_index_check_box_${config.id}_${incrementalItem.id}`}>
                                                            Starting Index (Optional)
                                                        </label>
                                                    </div>
                                                    <div>
                                                        <div className="custom-control custom-radio">
                                                            <input
                                                                type="radio"
                                                                className="custom-control-input"
                                                                id={`radio_by_value_${config.id}_${incrementalItem.id}`}
                                                                name={`start_index_${config.id}_${incrementalItem.id}`}
                                                                value="incremental data identifier"
                                                                checked={incrementalItem.startingIndexType === 'incremental data identifier'}
                                                                disabled={!incrementalItem.startingIndexCheckbox}
                                                                onChange={() => this.handleStartingIndexTypeChange(config.id, incrementalItem.id, 'incremental data identifier')}
                                                            />
                                                            <label className="custom-control-label" htmlFor={`radio_by_value_${config.id}_${incrementalItem.id}`}>
                                                                By Value
                                                            </label>
                                                        </div>
                                                        <div className="custom-control custom-radio">
                                                            <input
                                                                type="radio"
                                                                className="custom-control-input"
                                                                id={`radio_by_query_${config.id}_${incrementalItem.id}`}
                                                                name={`start_index_${config.id}_${incrementalItem.id}`}
                                                                value="custom query"
                                                                checked={incrementalItem.startingIndexType === 'custom query'}
                                                                disabled={!incrementalItem.startingIndexCheckbox}
                                                                onChange={() => this.handleStartingIndexTypeChange(config.id, incrementalItem.id, 'custom query')}
                                                            />
                                                            <label className="custom-control-label" htmlFor={`radio_by_query_${config.id}_${incrementalItem.id}`}>
                                                                By Query
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                                {incrementalItem.startingIndexCheckbox && incrementalItem.startingIndexType === 'incremental data identifier' && (
                                                    <div className="form-group col-md-6 col-lg-4">
                                                        <label>Starting Index Value</label>
                                                        <input type="text" className="form-control" value={incrementalItem.startingIndexValue} onChange={e => this.handleIncrementalDataFieldChange(config.id, incrementalItem.id, 'startingIndexValue', e.target.value)} />
                                                    </div>
                                                )}
                                                {incrementalItem.startingIndexCheckbox && incrementalItem.startingIndexType === 'custom query' && (
                                                    <div className="form-group col-md-12 col-lg-8">
                                                        <label>Starting Index Query</label>
                                                        <input type="text" className="form-control" value={incrementalItem.startingIndexQuery} onChange={e => this.handleIncrementalDataFieldChange(config.id, incrementalItem.id, 'startingIndexQuery', e.target.value)} />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    </>
)}

                                            <div
                                                className={`vertical-stepper__content`}
                                                > 
                                                     <div id="qd-configure-integration-form-selection"
                                                // className={` ${
                                                //     this.state.showSchemaConfigInfo === null ? "" : "d-none"
                                                // }`}
                                                   className={` ${
                                                    (this.state.manualNextClicked === true) ||
                                                    (this.state.configurationMode === 'autoconfig' && this.state.specificSelect && this.state.schemaInfoConfirmed)
                                                        ? "d-none" : ""
                                                }`}
                                                
                                                >
                                                <div
                                                    className={`tw-border tw-border-solid tw-rounded-xl tw-p-4 tw-mb-4 transition-card ${
                                                    this.state.selected ? "border-primary shadow-sm" : "tw-border-[#E9EAEB] dark:tw-border-[#2B2B40]"
                                                    }`}
                                                >
                                                    {/* Top Card Body */}
                                                    <div className={`d-flex ${this.state.selected ? "tw-pb-4" : ""}`}>
                                                        <Form.Check 
                                                            custom
                                                            name='schema_mode_selection'
                                                            type={'radio'}
                                                            id={`allSchemas`}
                                                            value="allSchemas"
                                                            className="md:tw-mr-3"
                                                            checked={this.state.selected}
                                                            onChange={this.handleSchemaModeSelection}
                                                            disabled={this.state.ex_edit_integration_details && !isEditSchemaModeTransitionAllowed(this.state.ex_edit_integration_details, 'allSchemas', this.state.configurationMode)}
                                                        />
                                                        <div>
                                                            <h5 className="tw-mb-1 tw-font-[400] tw-text-black">
                                                                <i className='tw-me-1'>
                                                                    <Layers2 size={16} color="#A4A7AE" />
                                                                </i>
                                                                {this.state.formType === "azure_blob" || this.state.formType ==='s3' ? "All Buckets" : "All Schemas"}
                                                            </h5>
                                                            <p className="tw-mb-0 tw-text-[#535862] dark:tw-text-[#787B86] tw-text-xs">Process all available {this.state.formType === "azure_blob" || this.state.formType ==='s3' ? "buckets" : "schemas"} automatically</p>
                                                        </div>
                                                    </div>

                                                    {/* Expandable Section */}
                                                   
                                                    <div className={`integration-collapse-content ${this.state.selected ? "open tw-ps-5 md:tw-ps-8" : ""}`}>
                                                        {this.state.specificSelect === false ? <div className='md:tw-pe-8 tw-py-4 tw-border-0 tw-border-t tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40]'>
                                                            <Form.Label>Configuration Mode <span className="text-danger">*</span></Form.Label>
                                                            <div className='custom-control custom-radio xl:tw-flex pl-0'>
                                                                <label className="d-flex align-items-center tw-mr-8 tw-mb-0">
                                                                    <input 
                                                                        type="radio" 
                                                                        name="mode" 
                                                                        value="autoconfig"
                                                                        className="mr-2" 
                                                                        checked={this.state.configurationMode === 'autoconfig'}
                                                                        onChange={this.handleConfigurationModeChange}
                                                                        disabled={this.state.ex_edit_integration_details && !isEditSchemaModeTransitionAllowed(this.state.ex_edit_integration_details, this.state.schemaModeSelection, 'autoconfig')}
                                                                    />
                                                                    Autoconfig <span className='tw-text-[#535862] dark:tw-text-[#787B86] tw-ms-1'>(Recommended)</span>
                                                                </label>
                                                                <label className={`d-flex align-items-center tw-mb-0 ${this.state.configurationMode !== 'manual' ? 'text-muted' : ''}`}>
                                                                    <input 
                                                                        type="radio" 
                                                                        name="mode"
                                                                        value="manual"
                                                                        className="mr-2" 
                                                                        checked={this.state.configurationMode === 'manual'}
                                                                        onChange={this.handleConfigurationModeChange}
                                                                        disabled={this.state.schemaModeSelection === 'allSchemas' || (this.state.ex_edit_integration_details && !isEditSchemaModeTransitionAllowed(this.state.ex_edit_integration_details, this.state.schemaModeSelection, 'manual'))}
                                                                    />
                                                                 Manual Config
                                                                </label>
                                                            </div>
                                                            
                                                        </div> : "" }
                                                    </div>
                                                </div>
                                                <div
                                                    className={`tw-border tw-border-solid tw-rounded-xl tw-p-4 transition-card ${
                                                    this.state.specificSelect ? "border-primary shadow-sm" : "tw-border-[#E9EAEB] dark:tw-border-[#2B2B40]"
                                                  
                                                    }`
                                                
                                                }
                                                >

                                                    
                                                    {/* Top Card Body */}
                                                    <div className={`d-flex ${this.state.specificSelect ? "tw-pb-4" : ""}`}>
                                                        <Form.Check 
                                                            custom
                                                            type={'radio'}
                                                            id={`specificSchemas`}
                                                            name='schema_mode_selection'
                                                            value="specificSchemas"
                                                            className="md:tw-mr-3"
                                                            checked={this.state.specificSelect}
                                                            onChange={this.handleSchemaModeSelection}
                                                            disabled={this.state.ex_edit_integration_details && !isEditSchemaModeTransitionAllowed(this.state.ex_edit_integration_details, 'specificSchemas', this.state.configurationMode)}
                                                        />
                                                        <div>
                                                            <h5 className="tw-mb-1 tw-font-[400] tw-text-black">
                                                                <i className='tw-me-1'>
                                                                    <FolderOpen size={16} color="#A4A7AE" />
                                                                </i>
                                                                Specified {this.state.formType === "azure_blob" || this.state.formType ==='s3' ? "Buckets" : "Schemas"}
                                                            </h5>
                                                            <p className="tw-mb-0 tw-text-[#535862] dark:tw-text-[#787B86] tw-text-xs">Select specific {(this.state.formType === "azure_blob"|| this.state.formType ==='s3') ? "buckets" : "schemas"} from your {(this.state.formType === "azure_blob" || this.state.formType ==='s3') ? "filesystem" : "database"} </p>
                                                        </div>
                                                    </div>

                                                    {/* Expandable Section */}
                                                    <div className={`integration-collapse-content ${this.state.specificSelect ? "open tw-ps-5 md:tw-ps-8" : ""}`}>
                                                       {this.state.specificSelect ?
                                                        <div className='md:tw-pe-8 tw-py-4 tw-border-0 tw-border-t tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40]'>
                                                            <button className={this.state.confirmedSchemas.length > 0 && this.state.testConnectionResponse?.schemas?.length > 0 ? "btn !tw-border-[#ABEFC6] tw-bg-[#F6FEF9] tw-text-black btn-block tw-mb-4 hover:!tw-shadow-none" : `btn btn-light btn-block tw-mb-4 hover:!tw-shadow-none ${this.state.schemaSelectionError && this.state.confirmedSchemas.length === 0 ? 'tw-border tw-border-solid !tw-border-[#dc3545] !tw-text-[#dc3545] dark:!tw-border-[#dc3545] dark:!tw-text-[#dc3545]' : ''}`} onClick={this.handleShowSchemeModal}>{/* Replace this class "btn-light" to "!tw-border-[#ABEFC6] !tw-bg-[#F6FEF9] !tw-text-black" */}
                                                                <i className='tw-mr-1'>
                                                                    <FolderTree size={16} color="#A4A7AE" />
                                                                </i>
                                                        {this.state.confirmedSchemas.length > 0 && this.state.testConnectionResponse?.schemas?.length > 0 ? `${this.state.formType === "azure_blob" || this.state.formType ==='s3' ? "Selected Bucket" : "Selected Schema"} (${this.state.confirmedSchemas.length})` : this.state.formType === "azure_blob" || this.state.formType ==='s3' ? "Fetch Available Buckets" : "Fetch Available Schemas"}
                                                            </button>
                                                            {this.state.schemaSelectionError && this.state.confirmedSchemas.length === 0 && <div className="text-danger tw-text-sm tw-mt-[-10px] tw-mb-4">{this.state.formType === "azure_blob" || this.state.formType === "s3" ? "Bucket is required" : "Schema is required"}</div>}
                                                            <div className='sm:tw-flex tw-items-center tw-justify-between'>
                                                                <div>
                                                                    <Form.Label className='tw-block'>Configuration Mode<span className="text-danger">*</span></Form.Label>
                                                                    <div className='custom-control custom-radio xl:tw-flex pl-0'>
                                                                        <label className="d-flex align-items-center tw-mr-8 tw-mb-0">
                                                                            <input 
                                                                        type="radio" 
                                                                        name="mode" 
                                                                        value="autoconfig"
                                                                        className="mr-2" 
                                                                        checked={this.state.configurationMode === 'autoconfig'}
                                                                        onChange={this.handleConfigurationModeChange}
                                                                        disabled={this.state.ex_edit_integration_details && !isEditSchemaModeTransitionAllowed(this.state.ex_edit_integration_details, this.state.schemaModeSelection, 'autoconfig')}
                                                                    />
                                                                            Autoconfig
                                                                        </label>
                                                                        <label className="d-flex align-items-center text-muted tw-mb-0">
                                                                            <input 
                                                                        type="radio" 
                                                                        name="mode"
                                                                        value="manual"
                                                                        className="mr-2"
                                                                        checked={this.state.configurationMode === 'manual'}
                                                                        onChange={this.handleConfigurationModeChange}
                                                                        disabled={this.state.ex_edit_integration_details && !isEditSchemaModeTransitionAllowed(this.state.ex_edit_integration_details, this.state.schemaModeSelection, 'manual')}
                                                                    />
                                                                            Manual Config
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                                
                                                            </div>
                                                        </div> :"" }
                                                    </div>
                                                </div> 
                                                {this.state.configurationMode === 'manual' && (
                                                    <div className='tw-flex tw-items-center tw-justify-end tw-my-4'>
                                                        <button
                                                            name="specifiedSchemasNext"
                                                            onClick={this.handleSchemaModeSelectionNext}
                                                            className='btn btn-outline-primary tw-mt-3 sm:tw-mt-0 tw-inline-flex tw-items-center'>
                                                            Add Integration
                                                            <i className='tw-ms-1'>
                                                                <svg
                                                                    width="20"
                                                                    height="20"
                                                                    viewBox="0 0 20 20"
                                                                    fill="none"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    >
                                                                    <mask
                                                                        id="mask0_26824_209148"
                                                                        style={{ maskType: "alpha" }}
                                                                        maskUnits="userSpaceOnUse"
                                                                        x="0"
                                                                        y="0"
                                                                        width="20"
                                                                        height="20"
                                                                    >
                                                                        <rect width="20" height="20" fill="#D9D9D9" />
                                                                    </mask>

                                                                    <g mask="url(#mask0_26824_209148)">
                                                                        <path
                                                                        d="M11.6673 15L10.5007 13.7917L13.459 10.8333H3.33398V9.16667H13.459L10.5007 6.20833L11.6673 5L16.6673 10L11.6673 15Z"
                                                                        fill="currentColor"
                                                                        />
                                                                    </g>
                                                                    </svg>
                                                            </i>
                                                        </button>
                                                    </div>
                                                )}
                                                </div>
                                                {this.state.showSchemaConfigInfo && this.state.testConnectionResponse && this.state.confirmedSchemas.length > 0 && this.state.schemaInfoConfirmed && (
                                                    (this.state.configurationMode === 'manual' && this.state.manualNextClicked === true) ||
                                                    (this.state.configurationMode === 'autoconfig' && this.state.specificSelect)
                                                ) && (
                                                    <div className="qd-configure-integration-info" id="qd-configure-integration-info-manual-schema">
                                                        <div className="qd-configure-integration-info__content">
                                                            <div className="qd-configure-integration-info__list !tw-grid-cols-2">
                                                                <div className="qd-configure-integration-info__item">
                                                                    <label className='qd-configure-integration-info__label'>
                                                                        {`${this.state.schemaModeSelection === "allSchemas" ? "All" : "Specified"} ${this.state.formType === "azure_blob" || this.state.formType === "s3" ? "Buckets" : "Schemas"}`}
                                                                    </label>
                                                                    <span className="qd-configure-integration-info__value">
                                                                        {this.state.schemaModeSelection === 'allSchemas' ? (
                                                                            <span className='tw-text-[#535862] dark:tw-text-[#787B86]'>{`Process all available ${this.state.formType === "azure_blob" || this.state.formType === "s3" ? "buckets" : "schemas"} automatically`}</span>
                                                                        ) : (
                                                                            <>
                                                                                {this.state.confirmedSchemas.length > 0 ? (
                                                                                    this.state.confirmedSchemas.map((schema, index) => (
                                                                                        <span key={index} className='tw-py-[2px] tw-px-2 tw-rounded-full tw-border tw-border-solid tw-border-[#C7D7FE] tw-bg-[#EEF4FF] tw-text-[#3538CD] tw-text-xs tw-font-medium tw-flex tw-items-center'>
                                                                                            <i className="tw-me-[2px]">
                                                                                                <FolderTree className="d-block" size={12} color="#175CD3" />
                                                                                            </i>
                                                                                            {schema}
                                                                                        </span>
                                                                                    ))
                                                                                ) : (
                                                                                    <span className='tw-text-[#535862] dark:tw-text-[#787B86]'>No schemas selected</span>
                                                                                )}
                                                                            </>
                                                                        )}
                                                                    </span>
                                                                </div>
                                                                <div className="qd-configure-integration-info__item">
                                                                    <label className='qd-configure-integration-info__label'>Configuration Mode</label>
                                                                    <span className="qd-configure-integration-info__value">
                                                                        <Form.Check 
                                                                            disabled={true}
                                                                            custom
                                                                            type={'radio'}
                                                                            id={`configMode_${this.state.configurationMode}`}
                                                                            label={this.state.configurationMode === 'autoconfig' ? 'Autoconfig' : 'Manual Config'}
                                                                            checked={true}
                                                                            className="mr-4"
                                                                        />
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <hr class="tw-block tw-my-3"></hr>
                                                            <div className="qd-configure-integration-info__action">
                                                                <div className='tw-flex tw-items-center tw-justify-end tw-gap-3'>
                                                                    {getDatasourceStatus(this.state.ex_edit_integration_details?.auto_config_status || this.props.ex_integration_details?.auto_config_status || 'completed')}
                                                                    <button className="tw-flex tw-items-center tw-rounded-full tw-border tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40] tw-bg-white dark:tw-bg-[#1E1E2D] tw-text-xs tw-pl-2 tw-pr-3 tw-py-[5px] tw-text-[#414651] dark:tw-text-[#B2B5BE] tw-font-medium hover:tw-text-[#414651] dark:hover:tw-text-[#B2B5BE] dark:tw-text-[#B2B5BE] hover:tw-border-[#D5D7DA] dark:hover:tw-border-[#2B2B40] dark:tw-border-[#2B2B40] hover:tw-bg-[#F4F5F5] dark:hover:tw-bg-[#2B2B40]" onClick={this.editSchemaAndModeSelection}>
                                                                        <i className='tw-flex tw-items-center tw-justify-center tw-w-4 tw-h-4 tw-mr-1'><SquarePen size={12} color="#A4A7AE" /></i>
                                                                        Edit
                                                                    </button>
                                                                    {/* <button className="btn btn-sm btn-circle tw-border-[#ABEFC6] tw-bg-[#ECFDF3] tw-text-[#067647] tw-mr-3 !tw-px-2 hover:tw-text-[#067647] hover:!tw-shadow-none">Completed</button>
                                                                    <button className="btn btn-sm btn-outline btn-circle btn-grey !tw-px-2" onClick={this.editSchemaAndModeSelection}>Edit</button> */}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                            </>
                                            )}
                                            {this.state.integrationConfigurations.length > 0 && this.state.testConnectionSuccess && this.state.showSchemaConfigInfo && (
                                                <>
                                                    <div className="vertical-stepper__heading !tw-pb-2 sm:!tw-pb-1">{/* Add this class for inactive state - vertical-stepper__heading--inactive */}
                                                        <span className="vs-heading__circle">3</span>
                                                        <div className="vs-heading__title-wrap">
                                                            <div className="vs-heading__title">Integration Details</div>
                                                            {/* <p className='m-0'>Configure datasets and partitions for your selected schemas</p> */}
                                                        </div>
                                                    </div>
                                                    <div className="vertical-stepper__content">
                                                {/* {console.log("Rendering integration configurations", this.state.integrationConfigurations)} */}
                                                {this.state.integrationConfigurations.map((config, index) => (
                                                <div key={config.id} className='tw-border-2 tw-border-solid tw-border-[#9BCBFF] tw-px-4 tw-rounded-xl tw-mb-4' style={this.state.integrationValidationErrors?.[config.id] ? { borderColor: '#FDA29B' } : undefined}>
                                                    <div className='tw-flex tw-items-center tw-justify-between tw-py-3 tw-border-0 tw-border-b tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40]'>
                                                        <div className='tw-flex tw-items-center tw-gap-2'>
                                                            {config.isExisting ? (
                                                                <h5 className='tw-font-medium tw-text-black tw-m-0'>
                                                                    <FontAwesomeIcon icon={faDatabase} className='tw-mr-2' />
                                                                    {config.integrationName || `Integration configurations ${index + 1}`}
                                                                </h5>
                                                            ) : (
                                                                <>
                                                                    {(this.state.editingIntegrationId === config.id || (!config.integrationName || config.integrationName.trim() === '')) ? (
                                                                        <>
                                                                            <div>
                                                                                <Form.Control
                                                                                    type="text"
                                                                                    autoFocus
                                                                                    className={
                                                                                        (!config.integrationName || config.integrationName.trim() === '' || this.isDuplicateIntegrationName(config.integrationName, config.id)) 
                                                                                            ? "form-control is-invalid" 
                                                                                            : "form-control"
                                                                                    }
                                                                                    name="integration_name"
                                                                                    value={config.integrationName || ''}
                                                                                    placeholder="Enter Integration Name"
                                                                                    onChange={(e) => this.handleIntegrationNameChange(config.id, e.target.value)}
                                                                                    onKeyDown={(e) => {
                                                                                        if (e.key === 'Enter') {
                                                                                            e.preventDefault();
                                                                                            this.handleSaveIntegrationName(config.id);
                                                                                        }
                                                                                    }}
                                                                                    onBlur={() => this.handleSaveIntegrationName(config.id)}
                                                                                    required
                                                                                />
                                                                                {this.isDuplicateIntegrationName(config.integrationName, config.id) && (
                                                                                    <div className="error-text">Integration with this name already exists.</div>
                                                                                )}
                                                                                {(!config.integrationName || config.integrationName.trim() === '') && (
                                                                                    <div className="error-text">Integration Name is required field</div>
                                                                                )}
                                                                            </div>
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <h5 className='tw-font-medium tw-text-black tw-m-0'>
                                                                                <FontAwesomeIcon icon={faDatabase} className='tw-mr-2' />
                                                                                {config.integrationName || `Integration configurations ${index + 1}`}
                                                                            </h5>
                                                                            <div className={`tw-p-[6px] tw-rounded-lg tw-flex tw-items-center tw-justify-center tw-bg-[#2F6BD6]/10 ${(this.state.editingIntegrationId && (() => { const eCfg = this.state.integrationConfigurations.find(c => c.id === this.state.editingIntegrationId); return eCfg && (!eCfg.integrationName || eCfg.integrationName.trim() === '' || this.isDuplicateIntegrationName(eCfg.integrationName, eCfg.id)); })()) ? 'tw-opacity-50 tw-cursor-not-allowed' : 'cursor-pointer'}`} onClick={() => {
                                                                                const eCfg = this.state.integrationConfigurations.find(c => c.id === this.state.editingIntegrationId);
                                                                                const isEditingInvalid = eCfg && (!eCfg.integrationName || eCfg.integrationName.trim() === '' || this.isDuplicateIntegrationName(eCfg.integrationName, eCfg.id));
                                                                                if (!isEditingInvalid) {
                                                                                    this.handleEditIntegrationName(config.id, config.integrationName || `Integration configurations ${index + 1}`);
                                                                                }
                                                                            }}>
                                                                                <Pencil size={20} color="#A4A7AE" />
                                                                            </div>
                                                                        </>
                                                                    )}
                                                                </>
                                                            )}
                                                        {/* {config.status_code !== 102 && config.status_code !== '102' && (
                                                            <Star size={20} fill="#7071b7" color="#7071b7" />
                                                        )} */}
                                                        </div>
                                                        {this.state.configurationMode !== 'autoconfig' && this.state.integrationConfigurations.length > 1 && (
                                                            <button type="button" className='tw-border-0 tw-bg-transparent text-primary' onClick={() => this.handleShowRemoveIntegration(config.id)}>
                                                                <Trash2 size={16} color="currentColor" className='mr-1' /><span className='tw-hidden sm:tw-inline-block'>Remove</span>
                                                            </button>
                                                        )}
                                                    </div>
                                                    <div className={`tw-py-4 ${config.isExisting ? 'tw-pointer-events-none' : ''}`}>
                                                        <div class="row">
                                                            <div className="col-md-6 !tw-border-0">
                                                                <Form.Label>{this.state.formType === 'azure_blob' || this.state.formType ==='s3' || this.state.formType === 'azure_data_lake_gen2' ? 'Select Bucket' : 'Select Schema'} <span className='text-primary'>*</span></Form.Label>
                                                                <Select isDisabled={config.isExisting}
                                                                    id={`select_schema_${config.id}`}
                                                                    options={(() => {
                                                                                    const isAzureBlob = this.state.formType === 'azure_blob'|| this.state.formType ==='s3' || this.state.formType === 'azure_data_lake_gen2';
                                                                        const sourceSchemas = this.state.schemaModeSelection === 'allSchemas'
                                                                            ? (this.state.testConnectionResponse?.schemas || [])
                                                                            : this.state.selectedSchemas;
                                                                        if (isAzureBlob) {
                                                                            // For Azure Blob, any bucket can be reused across integrations (different sub_paths)
                                                                            return sourceSchemas.map(schema => ({ label: schema, value: schema }));
                                                                        }
                                                                        const schemasWithAllDatasets = this.getSchemasWithAllDatasetsIntegration(config.id);
                                                                        const usedInOtherConfigs = new Set(
                                                                            this.state.integrationConfigurations
                                                                                .filter(c => c.id !== config.id && c.datasetScope === 'allDatasets' && c.schema)
                                                                                .map(c => c.schema)
                                                                        );
                                                                        return sourceSchemas
                                                                            .filter(s => !schemasWithAllDatasets.has(s) && !usedInOtherConfigs.has(s))
                                                                            .map(schema => ({ label: schema, value: schema }));
                                                                    })()}
                                                                    placeholder={this.state.formType === 'azure_blob'|| this.state.formType ==='s3' || this.state.formType === 'azure_data_lake_gen2' ? 'Select Bucket' : 'Select Schema'}
                                                                    value={config.schema ? { label: config.schema, value: config.schema } : null}
                                                                    onChange={(selectedOption) => this.handleSchemaSelectForConfig(config.id, selectedOption)}
                                                                    classNamePrefix='select-control'
                                                                    components={{ Control: customSelectSchema }}
                                                                />
                                                                {(!config.schema || config.schema.trim() === '') && (
                                                                    <div className="error-text">{this.state.formType === 'azure_blob' || this.state.formType === 's3' || this.state.formType === 'azure_data_lake_gen2' ? 'Bucket' : 'Schema'} is required field</div>
                                                                )}
                                                                {this.state.integrationValidationErrors[config.id]?.schema && (
                                                                    <div className="error-text mt-1">{this.state.integrationValidationErrors[config.id].schema}</div>
                                                                )}
                                                            </div>
                                                        </div>
                                                        {(this.state.formType === 'azure_blob'|| this.state.formType ==='s3' || this.state.formType === 'azure_data_lake_gen2') && (
                                                        <div class="row tw-mt-3">
                                                            <Form.Group className="col-md-6 !tw-border-0">
                                                                <Form.Label>Subpath</Form.Label>
                                                                <div className="icon-input-group">
                                                                    <i><FolderOpen size={18} color="#A4A7AE" /></i>
                                                                    <Form.Control
                                                                        type="text"
                                                                        name="sub_path"
                                                                        placeholder="Enter subpath"
                                                                        value={config.sub_path || ""}
                                                                        onChange={(e) => this.handleIntegrationConfigFieldChange(config.id, 'sub_path', e.target.value)}
                                                                    />
                                                                </div>
                                                            </Form.Group>
                                                        </div>
                                                        )}
                                                                    {this.state.formType !== 'azure_blob' && this.state.formType !== 's3' && this.state.formType !== 'azure_data_lake_gen2' && (
                                                        <>
                                                        <hr className='tw-my-3 tw-border-0 tw-border-b tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40]' />
                                                        <div class="row">
                                                            <Form.Group className="col-md-6 !tw-border-0">
                                                                <Form.Label>Dataset Scope</Form.Label>
                                                                <div>
  <div className="custom-control custom-radio custom-control-inline mt-1">
    <input
      type="radio"
      id={`allDataset_${config.id}`}
      name={`datasetGroup_${config.id}`}
      value="allDatasets"
      checked={config.datasetScope === "allDatasets"}
      onChange={() => this.handleDatasetScopeChange(config.id, 'allDatasets')}
      className="custom-control-input"
      
    />
    <Form.Label className="custom-control-label" htmlFor={`allDataset_${config.id}`}>
      All Datasets
    </Form.Label>
  </div>

  <div className="custom-control custom-radio custom-control-inline mt-1">
    <input
      type="radio"
      id={`specifiedDataset_${config.id}`}
      name={`datasetGroup_${config.id}`}
      value="specifiedDatasets"
      checked={config.datasetScope === "specifiedDatasets"}
      onChange={() => this.handleDatasetScopeChange(config.id, 'specifiedDatasets')}
      className="custom-control-input"
    />
    <Form.Label className="custom-control-label" htmlFor={`specifiedDataset_${config.id}`}>
      Specified Datasets
    </Form.Label>
  </div>
</div>

                                                            </Form.Group>
                                                        </div>
                                                        {(!config.isExisting || config.incrementalData.length > 0) && <div className="tw-mb-4 tw-p-3 sm:tw-p-4 tw-border tw-border-solid tw-border-[#D5D7DA] dark:tw-border-[#2B2B40] tw-rounded-lg tw-bg-[#FAFAFA] dark:tw-bg-[#161622]">
                                                            <div className='sm:tw-flex tw-items-center tw-justify-between'>
                                                                <div>
                                                                    <h5 className='tw-text-sm tw-font-medium tw-text-[#334DB7] tw-m-0'>
                                                                        Add Incremental Data Identification
                                                                        {config.datasetScope === 'specifiedDatasets' && <span className='text-danger'> *</span>}
                                                                        {config.datasetScope === 'allDatasets' && <span className='tw-text-[#6B7280]'> (Optional)</span>}
                                                                    </h5>
                                                                    <p className='tw-text-xs tw-text-[#546AC3] tw-m-0'>
                                                                        {config.datasetScope === 'specifiedDatasets' ? 'Required for specified datasets' : 'Configure incremental loading (Optional)'}
                                                                    </p>
                                                                </div>
                                                                {!config.isExisting && (
                                                                    <button type="button" className="btn tw-mt-3 sm:tw-mt-0 tw-font-semibold tw-border-0 tw-bg-[#E6E9F6] tw-text-[#334DB7] tw-whitespace-nowrap hover:tw-bg-[#D2D7EF] hover:tw-text-[#334DB7]" onClick={() => this.handleAddIncrementalData(config.id)}>
                                                                        <Plus size={18} color="#8A99D6" className='mr-1' />Add Row
                                                                    </button>
                                                                )}
                                                            </div>
                                                            {this.state.integrationValidationErrors[config.id]?.incrementalDataRequired && (
                                                                <div className="error-text tw-px-3 sm:tw-px-4 tw-mt-2 tw-mb-2">{this.state.integrationValidationErrors[config.id].incrementalDataRequired}</div>
                                                            )}
                                                            <div className={`integration-collapse-content ${config.incrementalData.length > 0 ? "open" : ""}`}>
                                                                {config.incrementalData.map((incrementalItem, incrementalIndex) => (
                                                                <div key={incrementalItem.id} className="dataset-partition-card" style={this.state.integrationValidationErrors?.[config.id]?.datasets?.[incrementalItem.id] ? { border: '1px solid #FDA29B' } : undefined}>
                                                                    <div className='dp-card__head'>
                                                                        <span class="dp-card__label">Incremental Data {incrementalIndex + 1}</span>
                                                                        {!config.isExisting && (
                                                                            <button type="button" className='tw-border-0 tw-bg-transparent text-primary' onClick={() => this.handleRemoveIncrementalData(config.id, incrementalItem.id)}>
                                                                                <Trash2 size={16} color="currentColor" className='mr-1' /><span className='tw-hidden sm:tw-inline-block'>Remove</span>
                                                                            </button>
                                                                        )}
                                                                    </div>
                                                                    <hr className='tw-border-0 tw-border-b tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40] tw-m-0' />
                                                                    <div class="dp-card__content">
                                                                        <div class="form-row">                                                                            
                                                                            <div class="form-group col-md-6 col-lg-4">
                                                                                <label>
                                                                                    Dataset Name <span class="text-danger">*</span>
                                                                                    <span class="tooltip">
                                                                                        <i><img class="ml-1" width="16px" src="icon_info_circle" alt='Info' /></i>
                                                                                    </span>
                                                                                </label>
                                                                                <div class="icon-input-group">
                                                                                    <i>
                                                                                        <Layers size={18} color="#A4A7AE" />
                                                                                    </i>
                                                                                    <Form.Control
                                                                                        type="text"
                                                                                        className={(!incrementalItem.datasetName || incrementalItem.datasetName.trim() === '') ? "form-control is-invalid" : this.isDatasetAssignedToAnotherIntegration(config, incrementalItem) ? "form-control is-invalid" : "form-control"}
                                                                                        name="dataset_name"
                                                                                        placeholder="Dataset Name"
                                                                                        value={incrementalItem.datasetName}
                                                                                        onChange={(e) => this.handleIncrementalDataFieldChange(config.id, incrementalItem.id, 'datasetName', e.target.value)}
                                                                                    />
                                                                                </div>
                                                                                {(!incrementalItem.datasetName || incrementalItem.datasetName.trim() === '') && (
                                                                                    <div class="error-text">Dataset Name is required field</div>
                                                                                )}
                                                                                {incrementalItem.datasetName && incrementalItem.datasetName.trim() !== '' && this.isDatasetAssignedToAnotherIntegration(config, incrementalItem) && (
                                                                                    <div class="error-text">Dataset Name "{incrementalItem.datasetName}" is already associated with another integration in this schema</div>
                                                                                )}
                                                                                {this.state.integrationValidationErrors[config.id]?.datasets?.[incrementalItem.id] && (
                                                                                    <div class="error-text">{this.state.integrationValidationErrors[config.id].datasets[incrementalItem.id]}</div>
                                                                                )}
                                                                                <Form.Text className="text-muted">
                                                                                    <Form.Check
                                                                                        custom
                                                                                        type="checkbox"
                                                                                        label="Exact match only"
                                                                                        id={`exact-match_${config.id}_${incrementalItem.id}`}
                                                                                        checked={incrementalItem.exactMatch}
                                                                                        onChange={(e) => this.handleExactMatchChange(config.id, incrementalItem.id, e.target.checked)}
                                                                                    />
                                                                                </Form.Text>
                                                                            </div>                                                                            
                                                                            <div class="form-group col-md-6 col-lg-4">
                                                                                <label>Incremental Data Identifier {config.datasetScope !== 'specifiedDatasets' && <span className="text-danger">*</span>}</label>
                                                                                <div class="icon-input-group">
                                                                                    <i>
                                                                                        <HardDrive size={18} color="#A4A7AE" />
                                                                                    </i>
                                                                                    <Form.Control
                                                                                        type="text"
                                                                                        className={(config.datasetScope !== 'specifiedDatasets' && (!incrementalItem.identifier || incrementalItem.identifier.trim() === '')) ? "form-control is-invalid" : "form-control"}
                                                                                        name="incremental_identifier"
                                                                                        placeholder="Incremental data identifier"
                                                                                        value={incrementalItem.identifier}
                                                                                        onChange={(e) => this.handleIncrementalDataFieldChange(config.id, incrementalItem.id, 'identifier', e.target.value)}
                                                                                    />
                                                                                </div>
                                                                                {(config.datasetScope !== 'specifiedDatasets' && (!incrementalItem.identifier || incrementalItem.identifier.trim() === '')) && (
                                                                                    <div className="error-text">Incremental Data Identifier is required field</div>
                                                                                )}
                                                                            </div>                                                                
                                                                            <div class="form-group col-md-6 col-lg-4">
                                                                                <div className="custom-control custom-checkbox mb-2">
                                                                                    <Form.Control
                                                                                        id={`start_index_check_box_${config.id}_${incrementalItem.id}`}
                                                                                        type="checkbox"
                                                                                        checked={incrementalItem.startingIndexCheckbox}
                                                                                        className="custom-control-input"
                                                                                        onChange={(e) => this.handleStartingIndexCheckbox(config.id, incrementalItem.id, e.target.checked)}
                                                                                    />
                                                                                    <Form.Label className="custom-control-label" htmlFor={`start_index_check_box_${config.id}_${incrementalItem.id}`}>
                                                                                        Starting Index (Optional)
                                                                                    </Form.Label>
                                                                                </div>
                                                                                <div>
                                                                                    <div className="custom-control custom-radio">
                                                                                        <input
                                                                                            type="radio"
                                                                                            className="custom-control-input"
                                                                                            id={`radio_by_value_${config.id}_${incrementalItem.id}`}
                                                                                            name={`start_index_${config.id}_${incrementalItem.id}`}
                                                                                            value="incremental data identifier"
                                                                                            checked={incrementalItem.startingIndexType === 'incremental data identifier'}
                                                                                            disabled={!incrementalItem.startingIndexCheckbox}
                                                                                            onChange={() => this.handleStartingIndexTypeChange(config.id, incrementalItem.id, 'incremental data identifier')}
                                                                                        />
                                                                                        <label className="custom-control-label" htmlFor={`radio_by_value_${config.id}_${incrementalItem.id}`}>
                                                                                            By Value
                                                                                        </label>
                                                                                    </div>
                                                                                    <div className="custom-control custom-radio">
                                                                                        <input
                                                                                            type="radio"
                                                                                            className="custom-control-input"
                                                                                            id={`radio_by_query_${config.id}_${incrementalItem.id}`}
                                                                                            name={`start_index_${config.id}_${incrementalItem.id}`}
                                                                                            value="custom query"
                                                                                            checked={incrementalItem.startingIndexType === 'custom query'}
                                                                                            disabled={!incrementalItem.startingIndexCheckbox}
                                                                                            onChange={() => this.handleStartingIndexTypeChange(config.id, incrementalItem.id, 'custom query')}
                                                                                        />
                                                                                        <label className="custom-control-label" htmlFor={`radio_by_query_${config.id}_${incrementalItem.id}`}>
                                                                                            By Query
                                                                                        </label>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            {incrementalItem.startingIndexCheckbox && incrementalItem.startingIndexType === 'incremental data identifier' && (
                                                                            <Form.Group className="col-md-6 col-lg-4">
                                                                                <Form.Label>Starting Index Value</Form.Label>
                                                                                <Form.Control
                                                                                    type="text"
                                                                                    className={(!incrementalItem.startingIndexValue || incrementalItem.startingIndexValue.trim() === '') ? "form-control is-invalid" : "form-control"}
                                                                                    name="start_index_value"
                                                                                    placeholder="Starting Index Value"
                                                                                    value={incrementalItem.startingIndexValue}
                                                                                    onChange={(e) => this.handleIncrementalDataFieldChange(config.id, incrementalItem.id, 'startingIndexValue', e.target.value)}
                                                                                />
                                                                                {(!incrementalItem.startingIndexValue || incrementalItem.startingIndexValue.trim() === '') && (
                                                                                    <div class="error-text">Starting Index Value is required field</div>
                                                                                )}
                                                                            </Form.Group>
                                                                            )}
                                                                            {incrementalItem.startingIndexCheckbox && incrementalItem.startingIndexType === 'custom query' && (
                                                                            <Form.Group className="col-md-12 col-lg-8">
                                                                                <Form.Label>Starting Index Query</Form.Label>
                                                                                <Form.Control
                                                                                    as="textarea"
                                                                                    rows={2}
                                                                                    name="start_index_query"
                                                                                    className={(!incrementalItem.startingIndexQuery || incrementalItem.startingIndexQuery.trim() === '') ? "form-control is-invalid" : "form-control"}
                                                                                    placeholder="Starting Index Query"
                                                                                    value={incrementalItem.startingIndexQuery}
                                                                                    onChange={(e) => this.handleIncrementalDataFieldChange(config.id, incrementalItem.id, 'startingIndexQuery', e.target.value)}
                                                                                />
                                                                                {(!incrementalItem.startingIndexQuery || incrementalItem.startingIndexQuery.trim() === '') && (
                                                                                    <div class="error-text">Starting Index query is required field</div>
                                                                                )}
                                                                                <Form.Text className="text-muted"><strong className="mr-1">Note:</strong>This query will be used for Starting Index.</Form.Text>
                                                                            </Form.Group>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                ))}
                                                            </div>
                                                        </div>}
                                                        {(!config.isExisting || config.partitions.length > 0) && <div className="tw-p-3 sm:tw-p-4 tw-border tw-border-solid tw-border-[#D5D7DA] dark:tw-border-[#2B2B40] tw-rounded-lg tw-bg-[#FAFAFA] dark:tw-bg-[#161622]">
                                                            <div className='sm:tw-flex tw-items-center tw-justify-between'>
                                                                <div>
                                                                    <h5 className='tw-text-sm tw-font-medium tw-text-[#334DB7] tw-m-0'>Add Partitions</h5>
                                                                    <p className='tw-text-xs tw-text-[#546AC3] tw-m-0'>Configure partioning dataset.</p>
                                                                </div>
                                                                {!config.isExisting && (
                                                                    <button type="button" className="btn tw-mt-3 sm:tw-mt-0 tw-font-semibold tw-border-0 tw-bg-[#E6E9F6] tw-text-[#334DB7] tw-whitespace-nowrap hover:tw-bg-[#D2D7EF] hover:tw-text-[#334DB7]" onClick={() => this.handleAddPartitionToConfig(config.id)}>
                                                                        <Plus size={18} color="#8A99D6" className='mr-1' />Add Row
                                                                    </button>
                                                                )}
                                                            </div>
                                                            <div className={`integration-collapse-content ${config.partitions.length > 0 ? "open" : ""}`}>
                                                                {config.partitions.map((partition, partitionIndex) => (
                                                                <div key={partition.id} class="dataset-partition-card">
                                                                    <div className='dp-card__head'>
                                                                        <span class="dp-card__label">Partition {partitionIndex + 1}</span>
                                                                        {!config.isExisting && (
                                                                            <button type="button" className='tw-border-0 tw-bg-transparent text-primary' onClick={() => this.handleRemovePartition(config.id, partition.id)}>
                                                                                <Trash2 size={16} color="currentColor" className='mr-1' /><span className='tw-hidden sm:tw-inline-block'>Remove</span>
                                                                            </button>
                                                                        )}
                                                                    </div>
                                                                    <hr className='tw-border-0 tw-border-b tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40] tw-m-0' />
                                                                    <div class="dp-card__content">
                                                                        <div class="form-row">                                                                            
                                                                            <Form.Group className="col-md-6 col-lg-4">
                                                                                <Form.Label>{config.datasetScope === 'allDatasets' ? 'Dataset Name' : 'Select Dataset'}</Form.Label>
                                                                                {config.datasetScope === 'allDatasets' ? (
                                                                                    <Form.Control
                                                                                        type="text"
                                                                                        className={(!partition.datasetName || partition.datasetName.trim() === '') ? "form-control is-invalid" : "form-control"}
                                                                                        name="dataset_name"
                                                                                        placeholder="Dataset Name"
                                                                                        value={partition.datasetName || ''}
                                                                                        onChange={(e) => this.handlePartitionFieldChange(config.id, partition.id, 'datasetName', e.target.value)}
                                                                                    />
                                                                                ) : null}
                                                                                {config.datasetScope === 'specifiedDatasets' ? (
                                                                                    <Select
                                                                                        name="dataset_name"
                                                                                        classNamePrefix={(!partition.datasetName || partition.datasetName.trim() === '') ? 'select-control is-invalid' : 'select-control'}
                                                                                        options={
                                                                                            this.getDatasetsForPartitionOptions(config, partition)
                                                                                        }
                                                                                        placeholder={
                                                                                            (config.incrementalData || []).length === 0
                                                                                                ? "Add Incremental Data first"
                                                                                                : "Dataset"
                                                                                        }
                                                                                        isDisabled={(config.incrementalData || []).length === 0}
                                                                                        value={partition.datasetName ? { label: partition.datasetName, value: partition.datasetName } : null}
                                                                                        onChange={(selectedOption) => this.handlePartitionFieldChange(config.id, partition.id, 'datasetName', selectedOption?.value || '')}
                                                                                        components={{ Control: customSelectDataset }}
                                                                                        styles={{
                                                                                            control: (base, state) => ({
                                                                                                ...base,
                                                                                                ...(state.isDisabled && (!partition.datasetName || partition.datasetName.trim() === '') ? { fontSize: '11px' } : {})
                                                                                            })
                                                                                        }}
                                                                                    />
                                                                                ) : null}
                                                                                {(!partition.datasetName || partition.datasetName.trim() === '') && (
                                                                                    <div className="error-text">Dataset Name is required field</div>
                                                                                )}
                                                                            </Form.Group>                                                              
                                                                            <Form.Group className="col-md-6 col-lg-4">
                                                                                <Form.Label>Partition Name</Form.Label>
                                                                                <div class="icon-input-group">
                                                                                    <i>
                                                                                        <svg width="18" height="18" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                            <g clip-path="url(#clip0_26832_241553)">
                                                                                            <path d="M1.33464 10.668C1.70249 10.669 1.9993 10.9681 1.9987 11.3359L6.66927 13.4596C6.68835 13.8731 6.80116 14.2621 6.98763 14.6055C7.02875 14.6812 7.07374 14.7545 7.12175 14.8255C7.23043 14.9864 7.35652 15.1343 7.49675 15.2676C7.38779 15.2391 7.28089 15.2023 7.17774 15.1556L7.17709 15.1549L1.44336 12.5482L1.43946 12.5469C1.20812 12.4398 1.01206 12.2683 0.875003 12.0534C0.737984 11.8384 0.66544 11.5883 0.666019 11.3333C0.66693 10.9651 0.966453 10.6671 1.33464 10.668Z" fill="#A4A7AE"/>
                                                                                            <path d="M1.33464 7.33464C1.70249 7.33571 1.9993 7.63478 1.9987 8.0026L7.66602 10.5794V11.2552C7.46838 11.4137 7.29376 11.5999 7.14779 11.8079L1.44336 9.21484L1.43946 9.21354C1.20812 9.10648 1.01206 8.93497 0.875003 8.72005C0.737984 8.50507 0.66544 8.25493 0.666019 8C0.66693 7.63181 0.966453 7.33373 1.33464 7.33464Z" fill="#A4A7AE"/>
                                                                                            <path d="M7.99935 0.667969C8.28574 0.667969 8.56887 0.729456 8.82943 0.848307L8.82878 0.848958L14.5553 3.45508C14.789 3.55966 14.9877 3.72879 15.1276 3.94336C15.2687 4.15983 15.3437 4.41286 15.3438 4.67122C15.3437 4.92969 15.2687 5.1832 15.1276 5.39974C14.9878 5.6142 14.7883 5.7828 14.5547 5.88737L14.5553 5.88867L12.6335 6.76172C12.3535 6.83762 12.0921 6.95782 11.8568 7.11458L10.8177 7.58659C10.5786 7.11122 10.1211 6.76654 9.57487 6.68685L14.0104 4.67122L14.0033 4.66862L8.2767 2.06185L8.27604 2.0612C8.18921 2.0216 8.09479 2.0013 7.99935 2.0013C7.90391 2.0013 7.80949 2.0216 7.72266 2.0612L7.72201 2.06185L2.00196 4.66471L7.72917 7.27474C7.81398 7.31342 7.90619 7.33368 7.99935 7.33464C7.7901 7.6132 7.66602 7.95941 7.66602 8.33464V8.63867C7.4973 8.60958 7.33235 8.55969 7.17578 8.48828L1.45638 5.88151C1.22317 5.77693 1.02447 5.6074 0.884769 5.39323C0.743577 5.17666 0.668655 4.92324 0.668623 4.66471C0.668654 4.40628 0.743669 4.15337 0.884769 3.93685C1.02453 3.72248 1.22295 3.55252 1.45638 3.44792L7.16927 0.848958C7.42983 0.730108 7.71297 0.66797 7.99935 0.667969Z" fill="#A4A7AE"/>
                                                                                            <path d="M13.9994 9.33464C13.9994 8.96645 13.7009 8.66797 13.3327 8.66797C12.9645 8.66797 12.666 8.96645 12.666 9.33464C12.666 9.70283 12.9645 10.0013 13.3327 10.0013C13.7009 10.0013 13.9994 9.70283 13.9994 9.33464ZM8.66602 13.3346C8.66602 13.7028 8.9645 14.0013 9.33269 14.0013C9.70088 14.0013 9.99936 13.7028 9.99936 13.3346C9.99936 12.9664 9.70088 12.668 9.33269 12.668C8.9645 12.668 8.66602 12.9664 8.66602 13.3346ZM14.666 9.33464C14.666 9.9609 14.2341 10.4858 13.652 10.6289C13.5832 11.4051 13.2451 12.1364 12.6898 12.6917C12.1344 13.2471 11.4031 13.5852 10.627 13.654C10.4838 14.2361 9.95895 14.668 9.33269 14.668C8.59631 14.668 7.99936 14.071 7.99936 13.3346C7.99936 12.7134 8.42428 12.1913 8.99936 12.0433V8.33464C8.99936 8.15054 9.14859 8.0013 9.33269 8.0013C9.51678 8.0013 9.66602 8.15054 9.66602 8.33464V12.0433C10.1292 12.1625 10.4947 12.5244 10.6195 12.9854C11.2212 12.9203 11.7864 12.6524 12.2184 12.2204C12.6505 11.7884 12.9183 11.2232 12.9834 10.6214C12.4165 10.4679 11.9994 9.95013 11.9994 9.33464C11.9994 8.59826 12.5963 8.0013 13.3327 8.0013C14.0691 8.0013 14.666 8.59826 14.666 9.33464Z" fill="#A4A7AE"/>
                                                                                            </g>
                                                                                            <defs>
                                                                                            <clipPath id="clip0_26832_241553">
                                                                                            <rect width="16" height="16" fill="white"/>
                                                                                            </clipPath>
                                                                                            </defs>
                                                                                            </svg>
                                                                                    </i>
                                                                                    <Form.Control
                                                                                        type="text"
                                                                                        className={(!partition.partitionName || partition.partitionName.trim() === '') ? "form-control is-invalid" : "form-control"}
                                                                                        name="partition_name"
                                                                                        placeholder="Partition Name"
                                                                                        value={partition.partitionName}
                                                                                        onChange={(e) => this.handlePartitionFieldChange(config.id, partition.id, 'partitionName', e.target.value)}
                                                                                    />
                                                                                </div>
                                                                                {(!partition.partitionName || partition.partitionName.trim() === '') && (
                                                                                    <div className="error-text">Partition Name is required field</div>
                                                                                )}
                                                                            </Form.Group>
                                                                            <Form.Group className="col-md-6 col-lg-4">
                                                                                <Form.Label className='d-block'>Partition By</Form.Label>
                                                                                <div className="custom-control custom-radio custom-control-inline mt-1">
                                                                                    <Form.Control
                                                                                        type="radio"
                                                                                        className="custom-control-input"
                                                                                        id={`partitionByColumn_${config.id}_${partition.id}`}
                                                                                        name={`partitionBy_${config.id}_${partition.id}`}
                                                                                        value="Column"
                                                                                        checked={partition.partitionBy === 'Column' || partition.partitionBy === undefined}
                                                                                        onChange={() => this.handlePartitionByChange(config.id, partition.id, 'Column')}
                                                                                    />
                                                                                    <Form.Label className="custom-control-label" htmlFor={`partitionByColumn_${config.id}_${partition.id}`}>
                                                                                        Column
                                                                                    </Form.Label>
                                                                                </div>
                                                                                <div className="custom-control custom-radio custom-control-inline mt-1">
                                                                                    <Form.Control
                                                                                        type="radio"
                                                                                        className="custom-control-input"
                                                                                        id={`partitionByCustom_${config.id}_${partition.id}`}
                                                                                        name={`partitionBy_${config.id}_${partition.id}`}
                                                                                        value="Custom Query"
                                                                                        checked={partition.partitionBy === 'Custom Query'}
                                                                                        onChange={() => this.handlePartitionByChange(config.id, partition.id, 'Custom Query')}
                                                                                    />
                                                                                    <Form.Label className="custom-control-label" htmlFor={`partitionByCustom_${config.id}_${partition.id}`}>
                                                                                        Custom Query
                                                                                    </Form.Label>
                                                                                </div>
                                                                            </Form.Group>
                                                                            {(partition.partitionBy === 'Column' || partition.partitionBy === undefined) && (
                                                                            <Form.Group className="col-md-6 col-lg-4">
                                                                                <Form.Label>Partition Identifier</Form.Label>
                                                                                <div class="icon-input-group">
                                                                                    <i>
                                                                                        <TextSearch size={18} color="#A4A7AE" />
                                                                                    </i>
                                                                                    <Form.Control
                                                                                        type="text"
                                                                                        className={(!partition.partitionIdentifier || partition.partitionIdentifier.trim() === '') ? "form-control is-invalid" : "form-control"}
                                                                                        name="partition_identifier"
                                                                                        placeholder="Partition Identifier"
                                                                                        value={partition.partitionIdentifier}
                                                                                        onChange={(e) => this.handlePartitionFieldChange(config.id, partition.id, 'partitionIdentifier', e.target.value)}
                                                                                    />
                                                                                </div>
                                                                                {(!partition.partitionIdentifier || partition.partitionIdentifier.trim() === '') && (
                                                                                    <div className="error-text">Partition Identifier is required field</div>
                                                                                )}
                                                                            </Form.Group>
                                                                            )}
                                                                            {partition.partitionBy === 'Custom Query' && (
                                                                            <Form.Group className="col-md-12 col-lg-8">
                                                                                <Form.Label>Custom Query</Form.Label>
                                                                                <Form.Control
                                                                                    as="textarea"
                                                                                    rows={2}
                                                                                    name="custom_query"
                                                                                    className={(!partition.customQuery || partition.customQuery.trim() === '') ? "form-control is-invalid" : "form-control"}
                                                                                    placeholder="Enter your custom query here..."
                                                                                    value={partition.customQuery}
                                                                                    onChange={(e) => this.handlePartitionFieldChange(config.id, partition.id, 'customQuery', e.target.value)}
                                                                                />
                                                                                {(!partition.customQuery || partition.customQuery.trim() === '') && (
                                                                                    <div className="error-text">Custom Query is required field</div>
                                                                                )}
                                                                                <Form.Text className="text-muted"><strong className="mr-1">Note:</strong>This query will be used to partition and monitor the Dataset.</Form.Text>
                                                                            </Form.Group>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                ))}
                                                            </div>
                                                        </div>}
                                                        </>
                                                        )}
                                                    </div>
                                                </div>
                                                ))}
                                                {this.state.configurationMode !== 'autoconfig' && (
                                                    <button type="button" id="datasource-add-integrations-button" className="btn tw-font-semibold tw-border tw-border-solid tw-border-[#B0BAE3] tw-bg-transparent tw-text-[#334DB7] tw-mb-4 hover:tw-bg-[#E6E9F6] hover:tw-text-[#334DB7]" onClick={this.handleAddIntegration}>
                                                        <Plus size={18} color="currentColor" className='mr-1' />Add Integrations
                                                    </button>
                                                )}
                                            </div>
                                                </>
                                            )}
                                            <div className="vertical-stepper__heading !tw-pt-4 sm:!tw-pt-8">
                                                <div className={"d-flex align-items-center tw-pl-1"}>
                                                    <Form.Check 
                                                        custom
                                                        type={'checkbox'}
                                                        id={`storeData`}
                                                        className="tw-mr-2 md:tw-mr-4"
                                                        checked={true}
                                                        readOnly
                                                        aria-readonly="true"
                                                    />
                                                    <div>
                                                        <h5 className="tw-mb-1 tw-font-[400] tw-text-black">Store Data Issues and Errors</h5>
                                                        <p className="tw-mb-0 tw-text-[#535862] dark:tw-text-[#787B86] tw-text-xs">Log and store processing errors for debugging and monitoring</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                   </div>
                                   <div className="text-right border-top tw-py-3 tw-pe-4 sm:tw-pe-6 mt-auto d-none">
                                            <button 
                                                className="btn btn-outline btn-grey tw-mr-3" 
                                                onClick={() => this.props.closeModal()}
                                                disabled={this.state.isCreatingDatasource}
                                            >
                                                Cancel
                                            </button>
                                            <button 
                                                type="button" 
                                                id="hidden-save-datasource-btn"
                                                className="btn btn-primary" 
                                                onClick={this.handleCreateDatasource}
                                                disabled={!this.isCreateDatasourceEnabled()}
                                            >
                                                {this.state.isCreatingDatasource ? (
                                                    <div className="tw-flex tw-items-center tw-justify-center">
                                                        <div className="tw-w-[14px] tw-h-[14px] tw-border tw-border-solid tw-rounded-full tw-border-white tw-border-t-transparent tw-animate-spin"></div>
                                                        <span className='tw-ml-2'>Creating...</span>
                                                    </div>
                                                ) : (
                                                    <>
                                                        <Check size={18} color="currentColor" className='mr-1' />Save Datasource
                                                    </>
                                                )}
                                            </button>
                                   </div>
                                </div>
                            </div>
                            {/* <div className="col-md-4">
                                <div className="portlet-body tw-h-full">
                                    <div id="add-datasource_help" class="qd-helpGuide tw-h-full">
                                        <div class="qd-helpGuide__content">
                                            {/* <div class="connector-badge">
                                                <i class="connector-icon">
                                                    <svg width="20" height="20" viewBox="0 0 147 140" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <g clip-path="url(#clip0_1563_1485)">
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M134.806 60.0962L118.336 69.5862L134.806 78.9962C135.791 79.5655 136.654 80.3232 137.346 81.226C138.038 82.1289 138.546 83.1592 138.84 84.2582C139.134 85.3572 139.208 86.5033 139.059 87.6311C138.91 88.7589 138.541 89.8463 137.971 90.8312C137.402 91.8161 136.644 92.6793 135.741 93.3713C134.839 94.0634 133.808 94.5709 132.709 94.8648C131.61 95.1587 130.464 95.2333 129.336 95.0842C128.209 94.9352 127.121 94.5655 126.136 93.9962L96.6262 76.9962C95.2737 76.2137 94.1576 75.0807 93.3955 73.7166C92.6334 72.3526 92.2536 70.8081 92.2962 69.2462C92.3193 68.5695 92.4234 67.8981 92.6062 67.2462C93.2103 65.06 94.646 63.1972 96.6062 62.0562L126.116 45.1162C127.105 44.5445 128.198 44.1736 129.33 44.0245C130.463 43.8755 131.614 43.9513 132.718 44.2476C133.821 44.5439 134.855 45.0548 135.761 45.7513C136.667 46.4477 137.426 47.3159 137.996 48.3062C138.568 49.2879 138.94 50.3734 139.089 51.4999C139.239 52.6263 139.163 53.7712 138.866 54.868C138.569 55.9649 138.057 56.9919 137.361 57.8894C136.664 58.7869 135.795 59.537 134.806 60.0962ZM119.216 106.096L89.7162 89.1262C88.3964 88.3687 86.9013 87.9699 85.3796 87.9692C83.8579 87.9686 82.3625 88.3661 81.042 89.1224C79.7215 89.8787 78.6219 90.9674 77.8525 92.2803C77.0831 93.5932 76.6707 95.0845 76.6562 96.6062V130.506C76.7327 132.759 77.6812 134.893 79.3016 136.46C80.922 138.026 83.0875 138.901 85.3412 138.901C87.5949 138.901 89.7605 138.026 91.3809 136.46C93.0013 134.893 93.9498 132.759 94.0262 130.506V111.506L110.536 120.996C111.521 121.566 112.609 121.936 113.737 122.086C114.865 122.236 116.011 122.162 117.111 121.868C118.21 121.575 119.241 121.068 120.144 120.376C121.048 119.684 121.806 118.821 122.376 117.836C122.946 116.851 123.317 115.764 123.466 114.636C123.616 113.508 123.542 112.361 123.248 111.262C122.955 110.162 122.448 109.131 121.756 108.228C121.064 107.324 120.201 106.566 119.216 105.996V106.096ZM85.2162 72.9362L72.9162 85.0862C72.4954 85.4774 71.9501 85.7076 71.3762 85.7362H67.7662C67.1937 85.7018 66.6502 85.4724 66.2262 85.0862L53.9962 72.8962C53.6136 72.4787 53.3875 71.9416 53.3562 71.3762V67.7762C53.3892 67.2082 53.615 66.6685 53.9962 66.2462L66.2262 54.0562C66.6512 53.6729 67.1948 53.447 67.7662 53.4162H71.3762C71.9486 53.4429 72.4935 53.6693 72.9162 54.0562L85.1762 66.2462C85.5545 66.6695 85.7767 67.2093 85.8062 67.7762V71.3762C85.7785 71.9405 85.5559 72.4778 85.1762 72.8962L85.2162 72.9362ZM75.4162 69.5562C75.369 68.9732 75.1258 68.4234 74.7262 67.9962L71.1762 64.4862C70.7508 64.1036 70.2075 63.8778 69.6362 63.8462H69.5062C68.9375 63.876 68.3968 64.1022 67.9762 64.4862L64.4262 67.9962C64.0451 68.4256 63.8228 68.9727 63.7962 69.5462V69.6762C63.8214 70.2411 64.0444 70.7791 64.4262 71.1962L67.9962 74.6962C68.4177 75.0788 68.9579 75.3048 69.5262 75.3362H69.6562C70.2275 75.3046 70.7708 75.0788 71.1962 74.6962L74.7462 71.1662C75.1297 70.7483 75.359 70.2121 75.3962 69.6462L75.4162 69.5562ZM19.9262 33.0762L49.4362 49.9962C50.7575 50.7533 52.2539 51.1517 53.7768 51.1516C55.2996 51.1516 56.796 50.7532 58.1173 49.9961C59.4386 49.2389 60.5388 48.1492 61.3087 46.8353C62.0786 45.5214 62.4915 44.029 62.5062 42.5062V8.63619C62.4298 6.38379 61.4813 4.24919 59.8609 2.68284C58.2405 1.1165 56.0749 0.240938 53.8212 0.240938C51.5675 0.240938 49.402 1.1165 47.7816 2.68284C46.1612 4.24919 45.2127 6.38379 45.1362 8.63619V27.6362L28.6062 18.1362C27.6213 17.5663 26.5338 17.1959 25.4057 17.0462C24.2777 16.8966 23.1312 16.9706 22.0318 17.264C20.9323 17.5575 19.9014 18.0646 18.998 18.7564C18.0945 19.4483 17.3361 20.3113 16.7662 21.2962C16.1963 22.2811 15.8259 23.3686 15.6763 24.4967C15.5266 25.6247 15.6006 26.7712 15.8941 27.8706C16.1875 28.9701 16.6946 30.001 17.3864 30.9044C18.0783 31.8079 18.9413 32.5663 19.9262 33.1362V33.0762ZM84.6862 51.1562C86.4288 51.294 88.1722 50.9 89.6862 50.0262L119.186 33.0262C120.171 32.4563 121.034 31.6979 121.726 30.7944C122.418 29.891 122.925 28.8601 123.218 27.7606C123.512 26.6612 123.586 25.5147 123.436 24.3867C123.287 23.2586 122.916 22.1711 122.346 21.1862C121.776 20.2013 121.018 19.3383 120.114 18.6464C119.211 17.9546 118.18 17.4475 117.081 17.154C114.86 16.5614 112.495 16.8752 110.506 18.0262L93.9962 27.6062V8.60619C93.9198 6.35379 92.9713 4.21919 91.3509 2.65284C89.7305 1.0865 87.5649 0.210938 85.3112 0.210938C83.0575 0.210938 80.892 1.0865 79.2716 2.65284C77.6512 4.21919 76.7026 6.35379 76.6262 8.60619V42.5062C76.6235 44.701 77.4542 46.8149 78.9504 48.4207C80.4466 50.0264 82.4967 51.0041 84.6862 51.1562ZM54.4762 87.9962C52.7333 87.8546 50.9888 88.2488 49.4762 89.1262L19.9262 106.056C17.9371 107.207 16.4867 109.101 15.8941 111.322C15.3015 113.542 15.6152 115.907 16.7662 117.896C17.9173 119.885 19.8113 121.336 22.0318 121.928C24.2522 122.521 26.6171 122.207 28.6062 121.056L45.1362 111.566V130.566C45.2127 132.819 46.1612 134.953 47.7816 136.52C49.402 138.086 51.5675 138.961 53.8212 138.961C56.0749 138.961 58.2405 138.086 59.8609 136.52C61.4813 134.953 62.4298 132.819 62.5062 130.566V96.6062C62.5017 94.4225 61.6715 92.3212 60.1821 90.7243C58.6926 89.1273 56.6543 88.1527 54.4762 87.9962ZM46.4762 72.1262C47.0459 70.2529 46.96 68.2415 46.2328 66.4235C45.5057 64.6056 44.1806 63.0898 42.4762 62.1262L12.9962 45.1362C11.0053 43.9958 8.64409 43.6891 6.42786 44.283C4.21163 44.8768 2.32019 46.3231 1.16621 48.3062C0.594906 49.2876 0.223871 50.3726 0.0745668 51.4983C-0.074737 52.6241 0.000654668 53.7682 0.296381 54.8647C0.592107 55.9611 1.1023 56.988 1.79744 57.886C2.49258 58.7839 3.35887 59.5352 4.34621 60.0962L20.8162 69.5862L4.34621 78.9962C3.3613 79.5642 2.4979 80.3206 1.80531 81.2222C1.11272 82.1238 0.604499 83.1531 0.309673 84.2511C0.0148467 85.3492 -0.0608148 86.4946 0.0870081 87.6218C0.234831 88.7491 0.603243 89.8363 1.17121 90.8212C1.73918 91.8061 2.49558 92.6695 3.39722 93.3621C4.29886 94.0547 5.32809 94.5629 6.42615 94.8577C7.5242 95.1526 8.66957 95.2282 9.79686 95.0804C10.9242 94.9326 12.0113 94.5642 12.9962 93.9962L42.4762 76.9962C44.3746 75.9363 45.8005 74.196 46.4662 72.1262H46.4762ZM139.626 15.9062H138.296V17.5362H139.616C140.226 17.5362 140.616 17.2562 140.616 16.7362C140.616 16.2162 140.256 15.9062 139.616 15.9062H139.626ZM136.686 14.4062H139.686C141.306 14.4062 142.386 15.2962 142.386 16.6762C142.391 17.0603 142.294 17.4389 142.104 17.7729C141.914 18.1068 141.639 18.3841 141.306 18.5762L142.476 20.2562V20.5962H140.786L139.616 18.9962H138.296V20.5962H136.676L136.686 14.4062ZM144.986 17.6262C145.035 16.8692 144.926 16.1103 144.666 15.3976C144.406 14.6849 144.001 14.034 143.476 13.4859C142.952 12.9379 142.319 12.5047 141.619 12.2139C140.918 11.923 140.165 11.7808 139.406 11.7962C136.096 11.7962 133.896 14.1862 133.896 17.6262C133.896 20.9062 136.096 23.4462 139.406 23.4462C140.165 23.4644 140.919 23.3245 141.621 23.0354C142.323 22.7463 142.957 22.3143 143.483 21.7669C144.008 21.2195 144.414 20.5687 144.675 19.8558C144.936 19.1429 145.045 18.3836 144.996 17.6262H144.986ZM146.366 17.6262C146.366 21.5162 143.766 24.7662 139.366 24.7662C134.966 24.7662 132.476 21.4862 132.476 17.6262C132.476 13.7662 135.046 10.4862 139.366 10.4862C143.686 10.4862 146.356 13.7262 146.356 17.6262H146.366Z" fill="#29B5E8"/>
                                                        </g>
                                                        <defs>
                                                        <clipPath id="clip0_1563_1485">
                                                        <rect width="146.36" height="139.16" fill="white"/>
                                                        </clipPath>
                                                        </defs>
                                                    </svg>
                                                </i>
                                                <span class="connector-label">Snowflake</span>
                                            </div>
                                            <div class="connector-badge">
                                                <div class="tw-flex tw-items-center tw-gap-2">
                                                    <div class="tw-w-5 tw-h-5 tw-rounded tw-bg-[#d6d6d6] tw-animate-shimmer tw-bg-[linear-gradient(90deg,#d6d6d6_0%,#ebebeb_50%,#d6d6d6_100%)] tw-bg-[length:250px_100%]"></div>
                                                    <div class="tw-h-4 tw-w-20 tw-bg-[#d6d6d6] tw-rounded tw-animate-shimmer tw-bg-[linear-gradient(90deg,#d6d6d6_0%,#ebebeb_50%,#d6d6d6_100%)] tw-bg-[length:250px_100%]"></div>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="tw-h-6 tw-w-4/6 tw-bg-[#d6d6d6] tw-mb-3 tw-rounded tw-animate-shimmer tw-bg-[linear-gradient(90deg,#d6d6d6_0%,#ebebeb_50%,#d6d6d6_100%)] tw-bg-[length:250px_100%]"></div>
                                                <div class="tw-h-4 tw-w-full tw-bg-[#d6d6d6] tw-mb-1 tw-rounded tw-animate-shimmer tw-bg-[linear-gradient(90deg,#d6d6d6_0%,#ebebeb_50%,#d6d6d6_100%)] tw-bg-[length:250px_100%]"></div>
                                                <div class="tw-h-4 tw-w-5/6 tw-bg-[#d6d6d6] tw-mb-1 tw-rounded tw-animate-shimmer tw-bg-[linear-gradient(90deg,#d6d6d6_0%,#ebebeb_50%,#d6d6d6_100%)] tw-bg-[length:250px_100%]"></div>
                                                <div class="tw-h-4 tw-w-4/6 tw-bg-[#d6d6d6] tw-mb-1 tw-rounded tw-animate-shimmer tw-bg-[linear-gradient(90deg,#d6d6d6_0%,#ebebeb_50%,#d6d6d6_100%)] tw-bg-[length:250px_100%]"></div>
                                                <div class="tw-h-4 tw-w-3/6 tw-bg-[#d6d6d6] tw-mb-1 tw-rounded tw-animate-shimmer tw-bg-[linear-gradient(90deg,#d6d6d6_0%,#ebebeb_50%,#d6d6d6_100%)] tw-bg-[length:250px_100%]"></div>
                                            </div> 
                                            <h4 class="qd-helpGuide__title">Steps to enable access from your storage to Qualdo™: </h4>
                                            <ol class="qd-helpGuide__info">
                                            {this.renderHelpContent()}
                                            </ol>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
                { this.renderTest() }
                <Modal show={this.state.showSchemeModal} size="md"  centered onHide={this.handleCloseSchemeModal}>
                    <Modal.Header closeButton>
                        <div className='tw-flex tw-items-center tw-gap-4'>
                            <div className='tw-flex tw-items-center tw-justify-center tw-p-[10px] tw-border tw-border-solid tw-border-[#D5D7DA] dark:tw-border-[#2B2B40] tw-bg-white dark:tw-bg-[#1E1E2D] tw-rounded-[10px]'>
                                <FolderTree size={20} color="#414651" />
                            </div>
                            <div>
                            <h5 className="modal-title !tw-mb-[2px] tw-font-semibold !tw-text-gray-900 dark:!tw-text-white">{this.state.formType === "azure_blob" || this.state.formType ==='s3' ? "Available Buckets" : "Available Schemas"}</h5>                                
                            <div className='tw-flex tw-items-center tw-gap-2 tw-gap-2'>
                                    <div className='tw-px-2 tw-py-[2px] tw-flex tw-items-center tw-justify-center tw-text-xs tw-font-medium tw-text-[#175CD3] tw-border tw-border-solid tw-border-[#B2DDFF] tw-rounded-[6px] tw-uppercase' onClick={this.handleRefreshSchemas}>
                                        {getDatasourceIcon(this.state.formType)}{this.state.formType}
                                    </div>
                                    <strong className='tw-text-sm tw-text-[#535862] dark:tw-text-[#787B86] !tw-font-medium tw-ms-1'>{this.state.testConnectionFormData?.database || this.state.testConnectionFormData?.database_name ||this.state.testConnectionFormData?.host|| this.state.testConnectionFormData?.host_name||this.state.testConnectionFormData?.host_url || ''}</strong>
                                </div>
                            </div>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        {this.state.schemeModalLoading ? (
                            <div className='tw-py-[60px] tw-text-center'>
                                <i className='tw-p-4 tw-rounded-full tw-bg-[linear-gradient(180deg,#FAFAFA,#E9EAEB)] tw-inline-flex tw-items-center tw-justify-center tw-mb-4'>
                                    <div className="tw-w-[32px] tw-h-[32px] tw-border-4 tw-border-solid tw-rounded-full tw-border-[#D1E9FF] tw-border-t-[#0021A5] tw-animate-spin"></div>
                                </i>
                                <div>
                                    <h5 className='tw-text-base tw-font-medium tw-text-[#181D27] dark:tw-text-[#B2B5BE] tw-mt-0 tw-mb-1'>{this.state.formType === "azure_blob" || this.state.formType ==='s3' ? "Fetching Buckets" : "Fetching Schemas"}</h5>
                                <p className='tw-text-sm tw-text-[#535862] dark:tw-text-[#787B86] tw-my-0'>{this.state.formType === "azure_blob" ? "Connecting to Azure Blob Storage..." : this.state.formType === 's3' ? "Connecting to AWS S3..." : `Connecting to ${this.state.formType}`}</p>
                                </div>
                            </div>
                        ) : (
                            <>{this.state.testConnectionSuccess ? (
                                <div className='tw-rounded-lg tw-border tw-border-solid tw-border-[#ABEFC6] tw-bg-[#F6FEF9] tw-py-2 tw-px-3 tw-mb-3'>
                                    <div className="d-flex align-items-center tw-gap-[10px]">
                                        <i><CircleCheck size={18} color="#17B26A" /></i>
                                        <div>
                                    <span className="tw-block tw-text-sm tw-text-[#067647] tw-font-medium">Successfully fetched {this.state.testConnectionResponse?.schemas?.length || 0} {this.state.formType === "azure_blob" || this.state.formType === 's3' ? "buckets" : "schemas"}</span>
                                            <span className='tw-block tw-text-xs tw-text-[#079455]'>{this.state.formType === "azure_blob" || this.state.formType ==='s3'? "Select the buckets you want to work with. You can select multiple buckets." : "Select the schemas you want to work with. You can select multiple schemas."}</span>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div className='tw-rounded-lg tw-border tw-border-solid tw-border-[#FECDCA] tw-bg-[#FFF9F9] dark:tw-bg-[#2d1a1a] dark:tw-border-[#7a2828] tw-py-2 tw-px-3 tw-mb-3'>
                                    <div className="d-flex align-items-center tw-gap-[10px]">
                                        <i><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="9" cy="9" r="9" fill="#FEE4E2"/><path d="M12 6L6 12M6 6L12 12" stroke="#D92D20" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg></i>
                                        <div>
                                            <span className="tw-block tw-text-sm tw-text-[#B42318] dark:tw-text-[#f87171] tw-font-medium">Connection Failed</span>
                                            <span className='tw-block tw-text-xs tw-text-[#D92D20] dark:tw-text-[#fca5a5]'>{this.state.testConnectionResponse?.status_message || 'Please check your credentials and try again.'}</span>
                                        </div>
                                    </div>
                                </div>
                            )}
                        
                       <div className='tw-p-3 tw-rounded-xl tw-border tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40] tw-bg-[#FAFAFA] dark:tw-bg-[#161622]'>
                            {this.state.testConnectionSuccess && <div className='d-flex align-items-center justify-content-between tw-mb-3'>
                                <div className="qd-search-bar has-btn-close tw-border tw-border-solid tw-border-[#D5D7DA] dark:tw-border-[#2B2B40] tw-bg-white dark:tw-bg-[#1E1E2D] tw-rounded-lg tw-flex-1 tw-me-3">
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <button id="button-addon4" type="button" className="btn">
                                                <svg className='d-block' width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M17.5 17.5L14.5834 14.5833M16.6667 9.58333C16.6667 13.4954 13.4954 16.6667 9.58333 16.6667C5.67132 16.6667 2.5 13.4954 2.5 9.58333C2.5 5.67132 5.67132 2.5 9.58333 2.5C13.4954 2.5 16.6667 5.67132 16.6667 9.58333Z" stroke="#A4A7AE" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                            </button>
                                        </div>
                                        <input 
                                            type="search" 
                                            placeholder="Search" 
                                            className="form-control h-100" 
                                            value={this.state.schemaSearchText}
                                            onChange={(e) => this.setState({ schemaSearchText: e.target.value })}
                                        />
                                    </div>
                                    {/* {this.state.saveWatchListSearchText && <button className="btn btn-clear" title="clear" onClick={() => this.setState({ saveWatchListSearchText: '' })}><i className="icon-close"></i></button>} */}
                                </div>
                                <button 
                                    type="button" 
                                    className="btn btn-sm btn-outline btn-grey !tw-px-2 !tw-py-1 !tw-rounded-lg tw-whitespace-nowrap hover:!tw-shadow-none"
                                    onClick={this.handleSelectAllSchemas}
                                >
                                    {this.state.selectedSchemas.length === (this.state.testConnectionResponse?.schemas || []).length && this.state.testConnectionResponse?.schemas?.length > 0
                                        ? 'Deselect All' 
                                        : 'Select All'}
                                </button>
                            </div>}
                            <div className='tw-rounded-lg tw-border tw-border-solid tw-border-black/10 tw-bg-white dark:tw-bg-[#1E1E2D] tw-p-2'>
                                {(() => {
                                    const filteredSchemas = this.state.testConnectionResponse?.schemas?.filter(schema => 
                                        schema.toLowerCase().includes(this.state.schemaSearchText.toLowerCase())
                                    ) || [];
                                    
                                    return filteredSchemas.length > 0 ? (
                                        filteredSchemas.map((schema, index) => {
                                            const isSelected = this.state.selectedSchemas.includes(schema);
                                            const isConfirmedSchema = this.state.confirmedSchemas.includes(schema);
                                            const isPendingRemoval = isConfirmedSchema && !isSelected;
                                            const isPendingAddition = isSelected && !isConfirmedSchema;
                                            const schemaLabel = this.state.formType === "azure_blob" || this.state.formType === 's3' || this.state.formType === 'azure_data_lake_gen2' ? "bucket" : "schema";
                                            const checkboxInput = (
                                                <input 
                                                    type="checkbox" 
                                                    name="schema" 
                                                    className="mr-2"
                                                    checked={isSelected}
                                                    onChange={() => this.handleSchemaSelect(schema)}
                                                />
                                            );

                                            return (
                                                <div className='tw-mb-[2px]' key={index}>
                                                    <div 
                                                        className={`custom-control custom-checkbox custom-control-inline d-flex tw-items-center tw-justify-between tw-px-2 tw-py-1 tw-m-0 tw-cursor-pointer tw-rounded-lg ${isPendingRemoval ? 'tw-bg-[#FFF9F9] dark:tw-bg-[#2d1a1a]' : isPendingAddition ? 'tw-bg-[#F6FEF9] dark:tw-bg-[#172B20]' : 'hover:tw-bg-[#F5F5F5] dark:hover:tw-bg-[#2B2B40]'}`}
                                                        style={isPendingRemoval ? { border: '1px solid #FDA29B' } : isPendingAddition ? { border: '1px solid #ABEFC6' } : undefined}
                                                    >
                                                        <label className="d-flex align-items-center tw-mr-8 tw-mb-0 tw-font-medium">
                                                            {isSelected && isConfirmedSchema ? (
                                                                <RcTooltip
                                                                    trigger={["hover"]}
                                                                    placement="bottomLeft"
                                                                    overlay={
                                                                        <div className='tw-max-w-[220px] tw-p-2'>
                                                                            <div className='tw-text-sm tw-font-semibold tw-mb-1'>Remove {schemaLabel}?</div>
                                                                            <div className='tw-text-xs tw-leading-5'>
                                                                                Unchecking this {schemaLabel} will remove it from the integration when you confirm your changes.
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                    arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                                                                >
                                                                    <span className='tw-inline-flex tw-items-center'>{checkboxInput}</span>
                                                                </RcTooltip>
                                                            ) : checkboxInput}
                                                            <span className='d-flex align-items-center'>
                                                                <i><FolderTree size={16} color="#A4A7AE" className='tw-me-2' /></i>
                                                                {schema}
                                                            </span>
                                                        </label>
                                                        {isPendingRemoval && (
                                                            <span className='tw-text-xs tw-font-medium tw-text-[#F04438] tw-whitespace-nowrap'>
                                                                Will be removed
                                                            </span>
                                                        )}
                                                        {isPendingAddition && (
                                                            <span className='tw-text-xs tw-font-medium tw-text-[#067647] tw-whitespace-nowrap'>
                                                                Will be added
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            );
                                        })
                                    ) : (
                                        (() => {
                                            // Only show stages when there's no active search term (list is genuinely empty)
                                            // If user is searching and no results match, show "No Schemas/Buckets Found"
                                            const hasSearchText = this.state.schemaSearchText && this.state.schemaSearchText.trim().length > 0;
                                            const stages = this.state.testConnectionResponse?.stages || [];
                                            return !hasSearchText && stages.length > 0 ? (
                                                <div className='tw-py-2 tw-px-1'>
                                                    {stages.map((stageItem, idx) => (
                                                        <div key={idx} className='d-flex align-items-start tw-mb-2 tw-px-2 tw-py-2 tw-rounded-lg tw-bg-[#F9FAFB] dark:tw-bg-[#1a1a2e]'>
                                                            <span className={`tw-flex-shrink-0 tw-inline-flex align-items-center justify-content-center tw-rounded-full tw-me-3 tw-mt-[2px] ${stageItem.status ? 'tw-text-[#079455]' : 'tw-text-[#D92D20]'}`} style={{minWidth: '18px'}}>
                                                                {stageItem.status ? (
                                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <circle cx="8" cy="8" r="8" fill="#DCFAE6"/>
                                                                        <path d="M4.5 8L6.83333 10.3333L11.5 5.66667" stroke="#079455" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                                                    </svg>
                                                                ) : (
                                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <circle cx="8" cy="8" r="8" fill="#FEE4E2"/>
                                                                        <path d="M10.5 5.5L5.5 10.5M5.5 5.5L10.5 10.5" stroke="#D92D20" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                                                    </svg>
                                                                )}
                                                            </span>
                                                            <div className='tw-flex-1 tw-min-w-0'>
                                                                <p className={`tw-mb-0 tw-text-sm tw-font-medium ${stageItem.status ? 'tw-text-[#344054] dark:tw-text-[#D0D5DD]' : 'tw-text-[#D92D20]'}`}>
                                                                    {stageItem.name}
                                                                </p>
                                                                {!stageItem.status && stageItem.message && (
                                                                    <p className='tw-mb-0 tw-text-xs tw-text-[#D92D20] tw-mt-[2px] tw-opacity-80'>{stageItem.message}</p>
                                                                )}
                                                            </div>
                                                            {/* <span className='tw-text-xs tw-text-[#98A2B3] dark:tw-text-[#475467] tw-flex-shrink-0 tw-ms-2'>Stage {stageItem.stage}</span> */}
                                                        </div>
                                                    ))}
                                                </div>
                                            ) : (
                                                <div className='tw-text-center tw-py-3 tw-text-[#535862] dark:tw-text-[#787B86]'>
                                                    {this.state.formType === "azure_blob" || this.state.formType ==='s3' || this.state.formType === 'azure_data_lake_gen2' ? "No Buckets Found" : "No Schemas Found"}
                                                </div>
                                            );
                                        })()
                                    );
                                })()}
                            </div>
                       </div>
                       </>
                        )}
                    </Modal.Body>
                    {this.state.testConnectionSuccess && <Modal.Footer className='justify-content-between tw-p-5'>
                        <div>
                            <p className="tw-text-sm tw-m-0">
                                {(() => {
                                    const count = this.state.selectedSchemas.length;
                                    const pendingRemovalCount = this.state.confirmedSchemas.filter(schema => !this.state.selectedSchemas.includes(schema)).length;
                                    const pendingAdditionCount = this.state.selectedSchemas.filter(schema => !this.state.confirmedSchemas.includes(schema)).length;
                                    const isBucket =
                                        this.state.formType === 'azure_blob' || 
                                        this.state.formType === 's3' ||
                                        this.state.formType === 'azure_data_lake_gen2';

                                    const label = isBucket ? 'bucket' : 'schema';

                                    if (pendingRemovalCount > 0 || pendingAdditionCount > 0) {
                                        const changes = [];

                                        if (pendingAdditionCount > 0) {
                                            changes.push(
                                                <span key="addition" className="tw-font-medium" style={{ color: '#079455' }}>
                                                    {`${pendingAdditionCount} ${label}${pendingAdditionCount > 1 ? 's' : ''} will be added`}
                                                </span>
                                            );
                                        }

                                        if (pendingRemovalCount > 0) {
                                            changes.push(
                                                <span key="removal" className="tw-font-medium" style={{ color: '#F04438' }}>
                                                    {`${pendingRemovalCount} ${label}${pendingRemovalCount > 1 ? 's' : ''} will be removed`}
                                                </span>
                                            );
                                        }

                                        return changes.reduce((result, change, index) => (
                                            index === 0 ? [change] : [...result, ', ', change]
                                        ), []);
                                    }

                                    return count > 0
                                        ? <span className="tw-text-[#079455]">{`${count} ${label}${count > 1 ? 's' : ''} selected`}</span>
                                        : <span className="tw-text-[#535862] dark:tw-text-[#787B86]">{`Please select at least one ${label}`}</span>;
                                })()}
                            </p>
                        </div>
                        <div className='m-0'>
                            <button type="button" className="btn btn-outline btn-grey tw-me-2" onClick={this.handleCloseSchemeModal}>Cancel</button>
                            <button 
                                type="button" 
                                className="btn btn-primary" 
                                onClick={this.handleConfirmSchemaSelection}
                                disabled={this.state.selectedSchemas.length === 0}
                            >
                                <i><Check size={20} color="currentColor" className='mr-1' /></i> {this.state.confirmedSchemas.filter(schema => !this.state.selectedSchemas.includes(schema)).length > 0 ? 'Confirm Changes' : 'Confirm Selection'} ({this.state.selectedSchemas.length})
                            </button>
                        </div>
                    </Modal.Footer>}
                </Modal>
                {this.state.integrationToRemove && (
                    <DeleteWarningModal
                        delete_show={true}
                        deleteClose={this.handleCloseRemoveIntegration}
                        handleDeleteFunction={this.handleConfirmRemoveIntegration}
                        component="Datasource"
                        datasourceDetails={{
                            integration_name: this.state.integrationToRemove.integrationName
                        }}
                    />
                )}
             </>
        );
    }

    getViewIntegrationContent(data_source_option) {
    // Extract integration details from state
    // eslint-disable-next-line
    const integrationDetails = this.state.ex_edit_integration_details;
    const formData = this.state.testConnectionFormData || {};
    const integrationConfigs = this.state.integrationConfigurations || [];
    const selectedSchemas = this.state.selectedSchemas || [];
    const schemaModeSelection = this.state.schemaModeSelection || 'allSchemas';
    const configurationMode = this.state.configurationMode || 'autoconfig';
    const isVersionRefreshType = ['file_version', 'folder_version'].includes(
        (formData.refreshType || '').toLowerCase()
    );

    // Helper to render schema chips
    const renderSchemaChips = (schemas) => (
        schemas.map((schema, idx) => (
            <span key={idx} className='tw-py-[2px] tw-px-2 tw-rounded-full tw-border tw-border-solid tw-border-[#C7D7FE] tw-bg-[#EEF4FF] tw-text-[#3538CD] tw-text-xs tw-font-medium tw-flex tw-items-center'>
                <i className="tw-me-[2px]">
                    <FolderTree className="d-block" size={12} color="#175CD3" />
                </i>
                {schema}
            </span>
        ))
    );

    // Helper to render partitions
    const renderPartitions = (partitions) => (
        partitions.map((partition, idx) => (
            <div key={idx} className="dataset-partition-card">
                <div className='dp-card__head'>
                    <span className="dp-card__label">{`Partition ${idx + 1}`}</span>
                </div>
                <hr className='tw-border-0 tw-border-b tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40] tw-m-0' />
                <div className="dp-card__content">
                    <div className="qd-configure-integration-info__list !tw-grid-cols-1 sm:!tw-grid-cols-2">
                        <div className="qd-configure-integration-info__item">
                            <label className='qd-configure-integration-info__label'>Select Dataset</label>
                            <span className="qd-configure-integration-info__value">
                                <i><Layers size={20} color="#A4A7AE" /></i>
                                <RcTooltip placement="top" overlay={<span>{partition.datasetName}</span>} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
                                    <span>{partition.datasetName}</span>
                                </RcTooltip>
                            </span>
                        </div>
                        <div className="qd-configure-integration-info__item">
                            <label className='qd-configure-integration-info__label'>Partition Name</label>
                            <span className="qd-configure-integration-info__value">
                                <i>
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        {/* ...icon svg... */}
                                    </svg>
                                </i>
                                <RcTooltip placement="top" overlay={<span>{partition.partitionName}</span>} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
                                    <span>{partition.partitionName}</span>
                                </RcTooltip>
                            </span>
                        </div>
                        <div className="qd-configure-integration-info__item">
                            <label className='qd-configure-integration-info__label'>Partition By</label>
                            <span className="qd-configure-integration-info__value">
                                <RcTooltip placement="top" overlay={<span>{partition.partitionBy}</span>} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
                                    <span>{partition.partitionBy}</span>
                                </RcTooltip>
                            </span>
                        </div>
                        {partition.partitionBy === 'Custom Query' && (
                            <div className="qd-configure-integration-info__item">
                                <label className='qd-configure-integration-info__label'>Custom Query</label>
                                <span className="qd-configure-integration-info__value">
                                    <RcTooltip placement="top" overlay={<span>{partition.customQuery || '—'}</span>} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
                                        <span>{partition.customQuery || '—'}</span>
                                    </RcTooltip>
                                </span>
                            </div>
                        )}
                        {partition.partitionBy !== 'Custom Query' && (
                        <div className="qd-configure-integration-info__item">
                            <label className='qd-configure-integration-info__label'>Partition Identifier</label>
                            <span className="qd-configure-integration-info__value">
                                <i><TextSearch size={20} color="#A4A7AE" /></i>
                                <RcTooltip placement="top" overlay={<span>{partition.partitionIdentifier || '—'}</span>} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
                                    <span>{partition.partitionIdentifier || '—'}</span>
                                </RcTooltip>
                            </span>
                        </div>
                        )}
                    </div>
                </div>
            </div>
        ))
    );

    // Helper to render incremental data
    const renderIncrementalData = (incrementalData) => (
        incrementalData.map((item, idx) => (
            <div key={idx} className="dataset-partition-card">
                <div className='dp-card__head'>
                    <span className="dp-card__label">{`Incremental Data Identification ${idx + 1}`}</span>
                </div>
                <hr className='tw-border-0 tw-border-b tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40] tw-m-0' />
                <div className="dp-card__content">
                    <div className="qd-configure-integration-info__list !tw-grid-cols-1 sm:!tw-grid-cols-2">
                        <div className="qd-configure-integration-info__item">
                            <label className='qd-configure-integration-info__label'>Dataset Name</label>
                            <span className="qd-configure-integration-info__value">
                                <i><Layers size={20} color="#A4A7AE" /></i>
                                <RcTooltip placement="top" overlay={<span>{item.datasetName}</span>} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
                                    <span>{item.datasetName}</span>
                                </RcTooltip>
                            </span>
                        </div>
                        <div className="qd-configure-integration-info__item">
                            <label className='qd-configure-integration-info__label'>Incremental Data Identifier</label>
                            <span className="qd-configure-integration-info__value">
                                <i><HardDrive size={20} color="#A4A7AE" /></i>
                                <RcTooltip placement="top" overlay={<span>{item.identifier}</span>} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
                                    <span>{item.identifier}</span>
                                </RcTooltip>
                            </span>
                        </div>
                        {item.exactMatch && (
                            <div className="qd-configure-integration-info__item">
                                <label className='qd-configure-integration-info__label'>Exact Match</label>
                                <span className="qd-configure-integration-info__value">
                                    <RcTooltip placement="top" overlay={<span>Yes</span>} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
                                        <span>Yes</span>
                                    </RcTooltip>
                                </span>
                            </div>
                        )}
                        {item.startingIndexCheckbox && (
                            <div className="qd-configure-integration-info__item">
                                <label className='qd-configure-integration-info__label'>Starting Index Type</label>
                                <span className="qd-configure-integration-info__value">
                                    <RcTooltip placement="top" overlay={<span>{item.startingIndexType === 'incremental data identifier' ? 'Incremental Data Identifier' : 'Custom Query'}</span>} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
                                        <span>{item.startingIndexType === 'incremental data identifier' ? 'Incremental Data Identifier' : 'Custom Query'}</span>
                                    </RcTooltip>
                                </span>
                            </div>
                        )}
                        {item.startingIndexCheckbox && item.startingIndexType === 'incremental data identifier' && (
                            <div className="qd-configure-integration-info__item">
                                <label className='qd-configure-integration-info__label'>Starting Index Value</label>
                                <span className="qd-configure-integration-info__value">
                                    <RcTooltip placement="top" overlay={<span>{item.startingIndexValue}</span>} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
                                        <span>{item.startingIndexValue}</span>
                                    </RcTooltip>
                                </span>
                            </div>
                        )}
                        {item.startingIndexCheckbox && item.startingIndexType === 'custom query' && (
                            <div className="qd-configure-integration-info__item">
                                <label className='qd-configure-integration-info__label'>Starting Index Query</label>
                                <span className="qd-configure-integration-info__value">
                                    <RcTooltip placement="top" overlay={<span>{item.startingIndexQuery}</span>} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
                                        <span>{item.startingIndexQuery}</span>
                                    </RcTooltip>
                                </span>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        ))
    );

    return (
        <div className="qd-scroll tw-space-y-4" id="view_ds_model">
            <div className="d-flex flex-column h-100">
                <div className="qd-configure-integration-steps">
                    <div className="vertical-stepper vertical-stepper-sm w-100 border-0">
                        {/* Datasource connection card */}
                        <div className="tw-flex tw-items-center tw-justify-between tw-rounded-t-xl tw-border tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40] tw-bg-[#FBFCFE] dark:tw-bg-[#161622] tw-px-5 tw-py-3">
                            <div className="tw-flex tw-items-center tw-gap-2">
                                <Database size={16} className="tw-text-[#475467] dark:tw-text-[#A1A5B7]" />
                                <span className="tw-font-semibold tw-text-base tw-text-[#101828] dark:tw-text-white">Datasource Details</span>
                            </div>
                            {getDatasourceStatus(this.state.ex_edit_integration_details?.auto_config_status || this.props.ex_integration_details?.auto_config_status || 'completed')}
                        </div>
                        <div className="vertical-stepper__content !tw-pt-0" >
                            <div className="qd-configure-integration-info tw-rounded-b-xl tw-border tw-border-t-0 tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40] tw-bg-white dark:tw-bg-[#1E1E2D]">
                                <div className="qd-configure-integration-info__content">
                                    <div className="qd-configure-integration-info__list">
                                        <div className="qd-configure-integration-info__item">
                                            <label className='qd-configure-integration-info__label'>Type</label>
                                            <span className="qd-configure-integration-info__value">
                                                <i>
                                                    <Database size={16} color="#A4A7AE" />
                                                </i>
                                                <span>{this.getDatasourceLabel(this.state.formType)}</span>
                                            </span>
                                        </div>
                                        <div className="qd-configure-integration-info__item">
                                            <label className='qd-configure-integration-info__label'>Datasource Name</label>
                                            <span className="qd-configure-integration-info__value">
                                                <i>
                                                    <Database size={16} color="#A4A7AE" />
                                                </i>
                                                <RcTooltip placement="top" overlay={<span>{formData.datasource_name}</span>} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
                                                    <span>{formData.datasource_name}</span>
                                                </RcTooltip>
                                            </span>
                                        </div>
                                        {this.state.formType === 'azure_blob' || this.state.formType ==='s3' || this.state.formType === 'azure_data_lake_gen2' ? (
                                            <>
                                                {(this.state.formType === 'azure_blob' || this.state.formType === 'azure_data_lake_gen2') && (
                                                <div className="qd-configure-integration-info__item">
                                                    <label className='qd-configure-integration-info__label'>Storage Name</label>
                                                    <span className="qd-configure-integration-info__value">
                                                        <i><HardDrive size={16} color="#A4A7AE" /></i>
                                                        <RcTooltip placement="top" overlay={<span>{formData.storage_name}</span>} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
                                                            <span>{formData.storage_name || '—'}</span>
                                                        </RcTooltip>
                                                    </span>
                                                </div>
                                                )}
                                                {formData.fileType && (
                                                    <div className="qd-configure-integration-info__item">
                                                        <label className='qd-configure-integration-info__label'>File Type</label>
                                                        <span className="qd-configure-integration-info__value">
                                                            <i><Layers size={16} color="#A4A7AE" /></i>
                                                            <span>{formData.fileType}</span>
                                                        </span>
                                                    </div>
                                                )}
                                                {formData.refreshType && (
                                                    <div className="qd-configure-integration-info__item">
                                                        <label className='qd-configure-integration-info__label'>Refresh Type</label>
                                                        <span className="qd-configure-integration-info__value">
                                                            <i><Layers2 size={16} color="#A4A7AE" /></i>
                                                            <span>{FILE_TYPE_FORMATS[formData.refreshType] || formData.refreshType}</span>
                                                        </span>
                                                    </div>
                                                )}
                                                {isVersionRefreshType && formData.versionFormat && (
                                                    <div className="qd-configure-integration-info__item">
                                                        <label className='qd-configure-integration-info__label'>Refresh Format</label>
                                                        <span className="qd-configure-integration-info__value">
                                                            <i><Layers3 size={16} color="#A4A7AE" /></i>
                                                            <span>{formData.versionFormat}</span>
                                                        </span>
                                                    </div>
                                                )}
                                                {isVersionRefreshType && formData.versionFormat === 'custom' && formData.versionFormatRegex && (
                                                    <div className="qd-configure-integration-info__item">
                                                        <label className='qd-configure-integration-info__label'>Custom Refresh Format</label>
                                                        <span className="qd-configure-integration-info__value">
                                                            <i><TextSearch size={16} color="#A4A7AE" /></i>
                                                            <RcTooltip placement="top" overlay={<span>{formData.versionFormatRegex}</span>} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
                                                                <span>{formData.versionFormatRegex}</span>
                                                            </RcTooltip>
                                                        </span>
                                                    </div>
                                                )}
                                                {isVersionRefreshType && formData.versionOccurence && formData.versionOccurence !== 'default' && (
                                                    <div className="qd-configure-integration-info__item">
                                                        <label className='qd-configure-integration-info__label'>Refresh Format Occurrence</label>
                                                        <span className="qd-configure-integration-info__value">
                                                            <i><TextSearch size={16} color="#A4A7AE" /></i>
                                                            <span>{formData.versionOccurence}</span>
                                                        </span>
                                                    </div>
                                                )}
                                                {this.state.formType === 's3' && formData.accessKey && (
                                                    <div className="qd-configure-integration-info__item">
                                                        <label className='qd-configure-integration-info__label'>Access Key</label>
                                                        <span className="qd-configure-integration-info__value">
                                                            <i><LockKeyhole size={16} color="#A4A7AE" /></i>
                                                            {this.state.showSecret?.['view_s3_access_key'] ? (
                                                                <RcTooltip placement="top" overlay={<span>{formData.accessKey}</span>} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
                                                                    <span>{formData.accessKey}</span>
                                                                </RcTooltip>
                                                            ) : (
                                                                <span>••••••••</span>
                                                            )}
                                                            <i className='cursor-pointer' onClick={() => this.toggleSecretVisibility('view_s3_access_key')}>
                                                                {this.state.showSecret?.['view_s3_access_key'] ? <EyeOff size={16} color="#A4A7AE" /> : <Eye size={16} color="#A4A7AE" />}
                                                            </i>
                                                        </span>
                                                    </div>
                                                )}
                                                <div className="qd-configure-integration-info__item">
                                                    <label className='qd-configure-integration-info__label'>{this.state.formType === 's3' ? 'Secret Access Key' : 'Blob Secret'}</label>
                                                    <span className="qd-configure-integration-info__value">
                                                        <i><LockKeyhole size={16} color="#A4A7AE" /></i>
                                                        {this.state.showSecret?.[this.state.formType === 's3' ? 'view_s3_secret' : 'view_blob_secret'] ? (
                                                            <RcTooltip placement="top" overlay={<span>{this.state.formType === 's3' ? formData.secretAccessKey : (formData.blob_secret || integrationDetails?.auth_config?.secret_key || '')}</span>} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
                                                                <span>{this.state.formType === 's3' ? formData.secretAccessKey : (formData.blob_secret || integrationDetails?.auth_config?.secret_key || '')}</span>
                                                            </RcTooltip>
                                                        ) : (
                                                            <span>••••••••</span>
                                                        )}
                                                        <i className='cursor-pointer' onClick={() => this.toggleSecretVisibility(this.state.formType === 's3' ? 'view_s3_secret' : 'view_blob_secret')}>
                                                            {this.state.showSecret?.[this.state.formType === 's3' ? 'view_s3_secret' : 'view_blob_secret'] ? <EyeOff size={16} color="#A4A7AE" /> : <Eye size={16} color="#A4A7AE" />}
                                                        </i>
                                                    </span>
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <div className="qd-configure-integration-info__item">
                                                    <label className='qd-configure-integration-info__label'>Host</label>
                                                    <span className="qd-configure-integration-info__value">
                                                        <i><HardDrive size={16} color="#A4A7AE" /></i>
                                                        <RcTooltip placement="top" overlay={<span>{formData.host || formData.host_url || formData.synapse_sql_host || formData.server || formData.project_id}</span>} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
                                                            <span>{formData.host || formData.host_url || formData.synapse_sql_host || formData.server || formData.project_id}</span>
                                                        </RcTooltip>
                                                    </span>
                                                </div>
                                                <div className="qd-configure-integration-info__item">
                                                    <label className='qd-configure-integration-info__label'>Database</label>
                                                    <span className="qd-configure-integration-info__value">
                                                        <i><DatabaseZap size={16} color="#A4A7AE" /></i>
                                                        <RcTooltip placement="top" overlay={<span>{formData.database || formData.database_name || formData.dataset_id || formData.catalog}</span>} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
                                                            <span>{formData.database || formData.database_name || formData.dataset_id || formData.catalog}</span>
                                                        </RcTooltip>
                                                    </span>
                                                </div>
                                                <div className="qd-configure-integration-info__item">
                                                    <label className='qd-configure-integration-info__label'>Auth</label>
                                                    <span className="qd-configure-integration-info__value">
                                                        <i><LockKeyhole size={16} color="#A4A7AE" /></i>
                                                        <RcTooltip placement="top" overlay={<span>{formData.username || formData.user_name}/{this.state.showSecret?.['view_auth_password'] ? (formData.password || integrationDetails?.auth_config?.password || '') : "••••••••"}</span>} arrowContent={<div className="rc-tooltip-arrow-inner"></div>}>
                                                            <span>{formData.username || formData.user_name}/{this.state.showSecret?.['view_auth_password'] ? (formData.password || integrationDetails?.auth_config?.password || '') : "••••••••"}</span>
                                                        </RcTooltip>
                                                        <i className='cursor-pointer' onClick={() => this.toggleSecretVisibility('view_auth_password')}>
                                                            {this.state.showSecret?.['view_auth_password'] ? <EyeOff size={16} color="#A4A7AE" /> : <Eye size={16} color="#A4A7AE" />}
                                                        </i>
                                                    </span>
                                                </div>
                                            </>
                                        )}
                                        <div className="qd-configure-integration-info__item">
                                            <label className='qd-configure-integration-info__label'>Status</label>
                                            <span className="qd-configure-integration-info__value">
                                            <span>{getDatasourceStatus(this.state.ex_edit_integration_details?.auto_config_status || this.props.ex_integration_details?.auto_config_status || 'completed')}</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Integration summary */}
                        <div className="tw-flex tw-items-center tw-gap-2.5 tw-pt-3 tw-pb-1">
                            <h3 className="tw-m-0 tw-text-lg tw-font-semibold tw-text-[#484848] dark:tw-text-white">Integrations</h3>
                            <span className="tw-rounded-full tw-border tw-border-solid tw-border-[#D1E0FF] dark:tw-border-[#2B2B40] tw-bg-[#EFF8FF] dark:tw-bg-[#161622] tw-px-3 tw-py-0.5 tw-text-sm tw-font-medium tw-text-[#175CD3] dark:tw-text-[#53B1FD]">{integrationConfigs.length}</span>
                        </div>
                        <div className="vertical-stepper__content !tw-pt-0">
                            <div className="qd-configure-integration-info tw-rounded-xl tw-border tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40] tw-bg-white dark:tw-bg-[#1E1E2D]">
                                <div className="qd-configure-integration-info__content">
                                    <div className="qd-configure-integration-info__list !tw-grid-cols-1">
                                        <div className="qd-configure-integration-info__item">
                                            <label className='qd-configure-integration-info__label'>
                                                {`${schemaModeSelection === 'allSchemas' ? 'All' : 'Specified'} ${this.state.formType === "azure_blob" || this.state.formType === "s3" ? "Buckets" : "Schemas"}`}
                                            </label>
                                            <span className="qd-configure-integration-info__value">
                                                {schemaModeSelection === 'allSchemas'
                                                    ? <span className='tw-text-[#535862] dark:tw-text-[#787B86]'>{`Process all available ${this.state.formType === "azure_blob" || this.state.formType === "s3" ? "buckets" : "schemas"} automatically`}</span>
                                                    : renderSchemaChips(selectedSchemas)
                                                }
                                            </span>
                                        </div>
                                    </div>
                                    <hr className='tw-block tw-my-3' />
                                    <div className="qd-configure-integration-info__list">
                                        <div className="qd-configure-integration-info__item">
                                            <label className='qd-configure-integration-info__label'>Configuration Mode</label>
                                            <span className="qd-configure-integration-info__value">
                                                <Form.Check
                                                    custom
                                                    type={'radio'}
                                                    id={`configMode_${configurationMode}`}
                                                    label={configurationMode === 'autoconfig' ? 'Autoconfig' : 'Manual Config'}
                                                    checked={true}
                                                    className="mr-4"
                                                    disabled
                                                />
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Step 5: Manual Configuration Details */}
                        {integrationConfigs.length > 0 && (
                            <>
                                <div className="vertical-stepper__heading !tw-pb-2 sm:!tw-pb-1">
                                    <span className="vs-heading__circle">3</span>
                                    <div className="vs-heading__title-wrap">
                                        <div className="vs-heading__title">Integration Details</div>
                                    </div>
                                </div>
                                <div className="vertical-stepper__content">
                                    {integrationConfigs.map((config, idx) => (
                                        <div key={config.id} className='tw-border tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40] tw-px-4 tw-rounded-xl tw-mb-4 tw-bg-white dark:tw-bg-[#1E1E2D]' style={this.state.integrationValidationErrors?.[config.id] ? { borderColor: '#FDA29B' } : undefined}>
                                            <div className='d-flex align-items-center justify-content-between tw-py-3 tw-border-0 tw-border-b tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40]'>
                                                <div className='tw-flex tw-items-center tw-gap-2'>
                                                    <FontAwesomeIcon icon={faDatabase} />
                                                    <h5 className='tw-font-medium tw-text-black tw-m-0'>{config.integrationName || `Integration ${idx + 1}`}</h5>
                                                </div>
                                            </div>
                                            <div className="tw-py-4">
                                                <div className="qd-configure-integration-info__list !tw-grid-cols-1 sm:!tw-grid-cols-2">
                                                    <div className="qd-configure-integration-info__item">
                                                        <label className='qd-configure-integration-info__label'>{this.state.formType === "azure_blob" || this.state.formType ==='s3' || this.state.formType === 'azure_data_lake_gen2' ? "Selected Bucket" : "Selected Schema"}</label>
                                                        <span className="qd-configure-integration-info__value">
                                                            {(config.schema || config.schema_name)
                                                                ? renderSchemaChips([config.schema || config.schema_name])
                                                                : <span className='tw-text-[#535862] dark:tw-text-[#787B86]'>No schema selected</span>
                                                            }
                                                        </span>
                                                    </div>
                                                    {(this.state.formType === 'azure_blob' || this.state.formType ==='s3' || this.state.formType === 'azure_data_lake_gen2') && (
                                                        <div className="qd-configure-integration-info__item">
                                                            <label className='qd-configure-integration-info__label'>Subpath</label>
                                                            <span className="qd-configure-integration-info__value">
                                                                {config.sub_path
                                                                    ? <span className='tw-py-[2px] tw-px-2 tw-rounded-full tw-border tw-border-solid tw-border-[#D0D5DD] tw-bg-[#F9FAFB] tw-text-[#344054] tw-text-xs tw-font-medium tw-inline-flex tw-items-center'>{config.sub_path}</span>
                                                                    : <span className='tw-text-[#535862] dark:tw-text-[#787B86]'>No subpath</span>
                                                                }
                                                            </span>
                                                        </div>
                                                    )}
                                                {this.state.formType !== 'azure_blob' && this.state.formType !== 's3' && this.state.formType !== 'azure_data_lake_gen2' && (
                                                        <div className="qd-configure-integration-info__item">
                                                            <label className='qd-configure-integration-info__label'>Dataset Scope</label>
                                                            <span className="qd-configure-integration-info__value">
                                                                <Form.Check
                                                                    custom
                                                                    type={'radio'}
                                                                    id={`datasetScope_${config.id}`}
                                                                    label={config.datasetScope === 'allDatasets' ? 'All Datasets' : 'Specified Datasets'}
                                                                    checked={true}
                                                                    className="mr-4"
                                                                    disabled
                                                                />
                                                            </span>
                                                        </div>
                                                    )}
                                                </div>
                                                {config.incrementalData && config.incrementalData.length > 0 && (
                                                    <div className="tw-p-3 sm:tw-p-4 tw-border tw-border-solid tw-border-[#D5D7DA] dark:tw-border-[#2B2B40] tw-rounded-lg tw-bg-[#FAFAFA] dark:tw-bg-[#161622] tw-mt-3">
                                                        <h6 className="tw-text-sm tw-font-medium tw-text-[#334DB7] tw-m-0">Incremental Data Identifications</h6>
                                                        <div className="integration-collapse-content open">
                                                            {renderIncrementalData(config.incrementalData)}
                                                        </div>
                                                    </div>
                                                )}
                                                {config.partitions && config.partitions.length > 0 && (
                                                    <>
                                                        <hr className='tw-my-3 tw-border-0 tw-border-b tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40]' />
                                                        <div className="tw-p-3 sm:tw-p-4 tw-border tw-border-solid tw-border-[#D5D7DA] dark:tw-border-[#2B2B40] tw-rounded-lg tw-bg-[#FAFAFA] dark:tw-bg-[#161622]">
                                                            <h6 className="tw-text-sm tw-font-medium tw-text-[#334DB7] tw-m-0">Partitions</h6>
                                                            <div className="integration-collapse-content open">
                                                                {renderPartitions(config.partitions)}
                                                            </div>
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </>
                        )}
                        {/* Store Data Issues and Errors */}
                        <div className="vertical-stepper__heading tw-pt-4 sm:!tw-pt-8">
                            <div className={"d-flex align-items-center tw-pl-1"}>
                                <Form.Check
                                    custom
                                    type={'checkbox'}
                                    id={`storeData`}
                                    className="tw-mr-2 md:tw-mr-4"
                                    checked={true}
                                    readOnly
                                    aria-readonly="true"
                                />
                                <div>
                                    <h5 className="tw-mb-1 tw-font-[400] tw-text-black">Store Data Issues and Errors</h5>
                                    <p className="tw-mb-0 tw-text-[#535862] dark:tw-text-[#787B86] tw-text-xs">Log and store processing errors for debugging and monitoring</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

    render() {
        const data_source_option = this.state.data_source_options;
        let editLoad = false;
       
        if (this.props.src_page === "edit_integration" && this.state.ex_edit_integration_details === null) {
            editLoad = true;
            this.getDatasourceDetailById(this.props.ex_integration_details["datasource_id"],this.props.ex_integration_details["env_id"]);
        }

        return (
            editLoad ?
                <Load/>
                :
                <>
                    {
                        this.props.ex_integration_details !== undefined &&   this.props.view === true ?
                            this.getViewIntegrationContent(data_source_option) :
                         this.props.ex_integration_details !== undefined ?   this.getEditIntegrationContent(data_source_option) :
                            this.getAddIntegrationContent(data_source_option)
                            
                    }
                </>
        );
    }
}
export default Datasource;
